flwebpackjsonp([0],[
/* 0 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(197);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(202)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(12);
var $find = __webpack_require__(308)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(90)(KEY);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(50)('wks');
var uid = __webpack_require__(38);
var Symbol = __webpack_require__(8).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(125);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(82),
    baseIteratee = __webpack_require__(83),
    baseMap = __webpack_require__(265),
    isArray = __webpack_require__(3);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(112),
    getTag = __webpack_require__(43),
    isArguments = __webpack_require__(48),
    isArray = __webpack_require__(3),
    isArrayLike = __webpack_require__(22),
    isBuffer = __webpack_require__(49),
    isPrototype = __webpack_require__(36),
    isTypedArray = __webpack_require__(73);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(103);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(28);
var hide = __webpack_require__(18);
var redefine = __webpack_require__(29);
var ctx = __webpack_require__(26);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(8);
var has = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(16);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(29);
var META = __webpack_require__(190).KEY;
var $fails = __webpack_require__(25);
var shared = __webpack_require__(50);
var setToStringTag = __webpack_require__(52);
var uid = __webpack_require__(38);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(117);
var wksDefine = __webpack_require__(191);
var enumKeys = __webpack_require__(192);
var isArray = __webpack_require__(120);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);
var toObject = __webpack_require__(32);
var toIObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(77);
var createDesc = __webpack_require__(37);
var _create = __webpack_require__(121);
var gOPNExt = __webpack_require__(195);
var $GOPD = __webpack_require__(124);
var $GOPS = __webpack_require__(81);
var $DP = __webpack_require__(17);
var $keys = __webpack_require__(40);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(123).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(54).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(39)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(18)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(25)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(116);
var toPrimitive = __webpack_require__(77);
var dP = Object.defineProperty;

exports.f = __webpack_require__(16) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var createDesc = __webpack_require__(37);
module.exports = __webpack_require__(16) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(53);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(167),
    getValue = __webpack_require__(170);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(108),
    isLength = __webpack_require__(70);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(111),
    baseKeys = __webpack_require__(112),
    isArrayLike = __webpack_require__(22);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(51);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(11);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var hide = __webpack_require__(18);
var has = __webpack_require__(24);
var SRC = __webpack_require__(38)('src');
var $toString = __webpack_require__(189);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(28).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(78);
var defined = __webpack_require__(41);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(41);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27),
    getRawTag = __webpack_require__(163),
    objectToString = __webpack_require__(164);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(68),
    baseAssignValue = __webpack_require__(106);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(118);
var enumBugKeys = __webpack_require__(80);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(12);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(196).set });


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(249),
    Map = __webpack_require__(85),
    Promise = __webpack_require__(250),
    Set = __webpack_require__(251),
    WeakMap = __webpack_require__(252),
    baseGetTag = __webpack_require__(34),
    toSource = __webpack_require__(109);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(26);
var $export = __webpack_require__(12);
var toObject = __webpack_require__(32);
var call = __webpack_require__(145);
var isArrayIter = __webpack_require__(146);
var toLength = __webpack_require__(19);
var createProperty = __webpack_require__(333);
var getIterFn = __webpack_require__(147);

$export($export.S + $export.F * !__webpack_require__(150)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STATE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AI_QUESTION1_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AI_QUESTION2_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NEXT_BUTTON_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PROCESSING_LABEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return STATE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AI_QUESTION1_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AI_QUESTION2_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NEXT_BUTTON_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PROCESSING_LABEL_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EXPLANATION_TEXT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EXPLANATION_TEXT_KEY; });
var STATE_ID = 1;
var STATE_KEY = 'ai_enhancement_status_state';
var PROCESSING_LABEL_ID = 2;
var PROCESSING_LABEL_KEY = 'ai_enhancement_status_processing_label';
var AI_QUESTION1_ID = 3;
var AI_QUESTION1_KEY = 'ai_question_1';
var AI_QUESTION2_ID = 4;
var AI_QUESTION2_KEY = 'ai_question_2';
var NEXT_BUTTON_ID = 5;
var NEXT_BUTTON_KEY = 'ai_enhancement_status_next_button';
var EXPLANATION_TEXT_ID = 6;
var EXPLANATION_TEXT_KEY = 'ai_enhancement_status_explanation_text';


/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(180),
    isObjectLike = __webpack_require__(20);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(11),
    stubFalse = __webpack_require__(181);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(28);
var global = __webpack_require__(8);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(39) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(17).f;
var has = __webpack_require__(24);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(16) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(217),
    listCacheDelete = __webpack_require__(218),
    listCacheGet = __webpack_require__(219),
    listCacheHas = __webpack_require__(220),
    listCacheSet = __webpack_require__(221);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(47);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(235);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(33);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(12);
var $includes = __webpack_require__(119)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(90)('includes');


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(12);
var context = __webpack_require__(138);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(140)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toLength = __webpack_require__(19);
var advanceStringIndex = __webpack_require__(91);
var regExpExec = __webpack_require__(92);

// @@match logic
__webpack_require__(94)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VISIBLE_FOCUSABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FOCUSABLE; });
var VISIBLE_FOCUSABLE = 'a[href]:visible, area[href]:visible, input:not([disabled]):visible, select:not([disabled]):visible, textarea:not([disabled]):visible, button:not([disabled]):visible, iframe:visible, object:visible, embed:visible, *[tabindex=0]:visible, *[tabindex=1]:visible, *[contenteditable]:visible';
var FOCUSABLE = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex=0], *[tabindex=1], *[contenteditable]';

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(317), __webpack_require__(104)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(39);
var global = __webpack_require__(8);
var ctx = __webpack_require__(26);
var classof = __webpack_require__(93);
var $export = __webpack_require__(12);
var isObject = __webpack_require__(13);
var aFunction = __webpack_require__(51);
var anInstance = __webpack_require__(318);
var forOf = __webpack_require__(319);
var speciesConstructor = __webpack_require__(143);
var task = __webpack_require__(148).set;
var microtask = __webpack_require__(321)();
var newPromiseCapabilityModule = __webpack_require__(149);
var perform = __webpack_require__(322);
var userAgent = __webpack_require__(323);
var promiseResolve = __webpack_require__(324);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(325)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(52)($Promise, PROMISE);
__webpack_require__(326)(PROMISE);
Wrapper = __webpack_require__(28)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(150)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(334);
var getKeys = __webpack_require__(40);
var redefine = __webpack_require__(29);
var global = __webpack_require__(8);
var hide = __webpack_require__(18);
var Iterators = __webpack_require__(44);
var wks = __webpack_require__(5);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(106),
    eq = __webpack_require__(47);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(182),
    baseUnary = __webpack_require__(74),
    nodeUtil = __webpack_require__(75);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 74 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(103);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var document = __webpack_require__(8).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(13);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(31);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(50)('keys');
var uid = __webpack_require__(38);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 81 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(215),
    baseMatchesProperty = __webpack_require__(254),
    identity = __webpack_require__(69),
    isArray = __webpack_require__(3),
    property = __webpack_require__(262);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(56),
    stackClear = __webpack_require__(222),
    stackDelete = __webpack_require__(223),
    stackGet = __webpack_require__(224),
    stackHas = __webpack_require__(225),
    stackSet = __webpack_require__(226);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(21),
    root = __webpack_require__(11);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(227),
    mapCacheDelete = __webpack_require__(234),
    mapCacheGet = __webpack_require__(236),
    mapCacheHas = __webpack_require__(237),
    mapCacheSet = __webpack_require__(238);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(248),
    stubArray = __webpack_require__(132);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(3),
    isSymbol = __webpack_require__(33);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(5)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(18)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(304)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(93);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(31);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(305);
var redefine = __webpack_require__(29);
var hide = __webpack_require__(18);
var fails = __webpack_require__(25);
var defined = __webpack_require__(41);
var wks = __webpack_require__(5);
var regexpExec = __webpack_require__(95);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(306);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const__ = __webpack_require__(64);




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var containerElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var $ = jQuery;
  var queryResults = arguments.length === 0 ? $(__WEBPACK_IMPORTED_MODULE_3__const__["b" /* VISIBLE_FOCUSABLE */]) : $(containerElement).find(__WEBPACK_IMPORTED_MODULE_3__const__["b" /* VISIBLE_FOCUSABLE */]);
  var focusableElements = [];

  for (var i = 0; i < queryResults.length; i++) {
    var element = queryResults.get(i); // Filter invisible links or screen-reader only links

    var isInvisible = element.className.includes('da11y-screen-reader-text') || element.className.includes('sr-only') || $(element).css('visibility') === 'hidden' || $(element).css('height') === '1px' && $(element).css('width') === '1px' || element.type && element.type === 'hidden';

    if (!isInvisible) {
      focusableElements.push(queryResults.get(i));
    }
  }

  focusableElements.sort(function (a, b) {
    var TabIndexA = parseInt(a.getAttribute('tab-index'), 10);
    var TabIndexB = parseInt(b.getAttribute('tab-index'), 10);

    if (TabIndexA < TabIndexB) {
      return -1;
    } else if (TabIndexA > TabIndexB) {
      return 1;
    }

    return 0;
  });
  return focusableElements;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(19);
var toInteger = __webpack_require__(53);
var advanceStringIndex = __webpack_require__(91);
var regExpExec = __webpack_require__(92);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(94)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _class; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _class =
/*#__PURE__*/
function () {
  function _class(source, target) {
    _classCallCheck(this, _class);

    this.source = source instanceof jQuery ? source.get(0) : source;
    this.target = target instanceof jQuery ? target.get(0) : target;
    this.initHandlers();
  }

  _createClass(_class, [{
    key: "initHandlers",
    value: function initHandlers() {
      var _this = this;

      this.tabHandler = function (event) {
        if (!event.shiftKey && event.key === 'Tab') {
          event.stopPropagation();
          event.preventDefault();
          window.ignoreGlobalFocusHandlers = true;

          _this.target.focus();

          window.ignoreGlobalFocusHandlers = false;
          return -1;
        }

        return 1;
      };

      this.tabHandler = this.tabHandler.bind(this);

      this.shiftTabHandler = function (event) {
        if (event.shiftKey && event.key === 'Tab') {
          event.stopPropagation();
          event.preventDefault();
          window.ignoreGlobalFocusHandlers = true;

          _this.source.focus();

          window.ignoreGlobalFocusHandlers = false;
        }

        return 1;
      };

      this.shiftTabHandler = this.shiftTabHandler.bind(this);
    }
  }, {
    key: "link",
    value: function link() {
      this.source.addEventListener('keydown', this.tabHandler);
      this.target.addEventListener('keydown', this.shiftTabHandler);
    }
  }, {
    key: "unlink",
    value: function unlink() {
      this.source.removeEventListener('keydown', this.tabHandler);
      this.target.removeEventListener('keydown', this.shiftTabHandler);
    }
  }]);

  return _class;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(342);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(129);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findDisclaimerKey__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findDisclaimerHtml__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findSubmitButtonKey__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__findMessageKey__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__findMessageId__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__findDisclaimerKey__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__findDisclaimerHtml__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__findSubmitButtonKey__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__findMessageKey__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__findMessageId__["a"]; });







/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _class; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _class =
/*#__PURE__*/
function () {
  function _class(selector) {
    _classCallCheck(this, _class);

    this.element = selector;
    this.handlers = {
      update: []
    };
    this.initObserver();
  }

  _createClass(_class, [{
    key: "initObserver",
    value: function initObserver() {
      var _this = this;

      var config = {
        attributes: true
      };

      var callback = function callback(mutationsList) {
        mutationsList.forEach(function (mutation) {
          if (mutation.type === 'attributes') {
            _this.emit('update');
          }
        });
      };

      this.observer = new MutationObserver(callback);
      this.observer.observe(this.element, config);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.observer.disconnect();
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(handler) {
      this.handlers.update.push(handler);
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this2 = this;

      this.handlers[event].forEach(function (item) {
        item.call(_this2, event);
      });
    }
  }]);

  return _class;
}();



/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),
/* 104 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ready; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trigger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_assign__);


var on = function on(el, name, handler) {
  if (el.addEventListener) {
    el.addEventListener(name, handler);
  } else {
    el.attachEvent("on".concat(name), function () {
      handler.call(el);
    });
  }
};

var ready = function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState !== 'loading') {
        fn();
      }
    });
  }
};

var trigger = function trigger(opts) {
  var event;

  var options = __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default()({
    data: {},
    el: document,
    event: '',
    native: true
  }, opts);

  if (options.native) {
    event = document.createEvent('HTMLEvents');
    event.initEvent(options.event, true, false);
  } else {
    try {
      event = new CustomEvent(options.event, {
        detail: options.data
      });
    } catch (e) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(options.event, true, true, options.data);
    }
  }

  options.el.dispatchEvent(event);
};



/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(107);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(21);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObject = __webpack_require__(14);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(47),
    isArrayLike = __webpack_require__(22),
    isIndex = __webpack_require__(71),
    isObject = __webpack_require__(14);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(179),
    isArguments = __webpack_require__(48),
    isArray = __webpack_require__(3),
    isBuffer = __webpack_require__(49),
    isIndex = __webpack_require__(71),
    isTypedArray = __webpack_require__(73);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(36),
    nativeKeys = __webpack_require__(183);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_verge__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_verge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_verge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_state__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_options__ = __webpack_require__(185);
/**
 * @module
 * @exports viewportDims
 * @description Sets viewport dimensions using verge on shared state
 * and detects mobile or desktop state.
 */




var viewportDims = function viewportDims() {
  __WEBPACK_IMPORTED_MODULE_1__config_state__["a" /* default */].v_height = __WEBPACK_IMPORTED_MODULE_0_verge___default.a.viewportH();
  __WEBPACK_IMPORTED_MODULE_1__config_state__["a" /* default */].v_width = __WEBPACK_IMPORTED_MODULE_0_verge___default.a.viewportW();

  if (__WEBPACK_IMPORTED_MODULE_1__config_state__["a" /* default */].v_width >= __WEBPACK_IMPORTED_MODULE_2__config_options__["a" /* MOBILE_BREAKPOINT */]) {
    __WEBPACK_IMPORTED_MODULE_1__config_state__["a" /* default */].is_desktop = true;
    __WEBPACK_IMPORTED_MODULE_1__config_state__["a" /* default */].is_mobile = false;
  } else {
    __WEBPACK_IMPORTED_MODULE_1__config_state__["a" /* default */].is_desktop = false;
    __WEBPACK_IMPORTED_MODULE_1__config_state__["a" /* default */].is_mobile = true;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (viewportDims);

/***/ }),
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(16) && !__webpack_require__(25)(function () {
  return Object.defineProperty(__webpack_require__(76)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(24);
var toIObject = __webpack_require__(30);
var arrayIndexOf = __webpack_require__(119)(false);
var IE_PROTO = __webpack_require__(79)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(30);
var toLength = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(193);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(31);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(9);
var dPs = __webpack_require__(194);
var enumBugKeys = __webpack_require__(80);
var IE_PROTO = __webpack_require__(79)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(76)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(122).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(8).document;
module.exports = document && document.documentElement;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(118);
var hiddenKeys = __webpack_require__(80).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(54);
var createDesc = __webpack_require__(37);
var toIObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(77);
var has = __webpack_require__(24);
var IE8_DOM_DEFINE = __webpack_require__(116);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(16) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(214);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(239),
    isObjectLike = __webpack_require__(20);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(240),
    arraySome = __webpack_require__(128),
    cacheHas = __webpack_require__(243);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(11);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(131),
    getSymbols = __webpack_require__(88),
    keys = __webpack_require__(23);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(87),
    isArray = __webpack_require__(3);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 132 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(136),
    toKey = __webpack_require__(60);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(3),
    isKey = __webpack_require__(89),
    stringToPath = __webpack_require__(256),
    toString = __webpack_require__(125);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(266),
    createBaseEach = __webpack_require__(269);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(139);
var defined = __webpack_require__(41);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(13);
var cof = __webpack_require__(31);
var MATCH = __webpack_require__(5)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(5)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* unused harmony export addClass */
/* unused harmony export getChildren */
/* unused harmony export hasClass */
/* unused harmony export removeClass */
/* unused harmony export removeClassThatContains */
/* unused harmony export hasClassFromArray */
/* unused harmony export convertElements */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closest; });
/* unused harmony export insertAfter */
/* unused harmony export insertBefore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMaybeCloseToView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isInViewport; });
/**
 * @module
 * @description Some vanilla js cross browser utils
 */

/**
 * Add a class to a dom element or exit safely if not set
 *
 * @param el Node
 * @param className Class string
 * @returns {*} Node or false
 */
var addClass = function addClass(el) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var element = el;

  if (!element) {
    return false;
  }

  element.classList.add(className);
  return element;
};
/**
 *
 * Get immediate child nodes and return an array of them
 *
 * @param el
 * @returns {Array} Iterable array of dom nodes
 */

var getChildren = function getChildren(el) {
  var children = [];
  var i = el.children.length;

  for (i; i--;) {
    // eslint-disable-line
    if (el.children[i].nodeType !== 8) {
      children.unshift(el.children[i]);
    }
  }

  return children;
};
/**
 *
 * Test if a dom node has a class or returns false if el not defined
 *
 * @param el
 * @param className
 * @returns {boolean}
 */

var hasClass = function hasClass(el) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!el) {
    return false;
  }

  return el.classList.contains(className);
};
/**
 * Removes a class from the dom node
 *
 * @param el
 * @param className
 * @returns {*} returns false or el if passed
 */

var removeClass = function removeClass(el, className) {
  var element = el;

  if (!element) {
    return false;
  }

  element.classList.remove(className);
  return element;
};
/**
 * Remove a class from an element that contains a string
 *
 * @param el
 * @param string
 */

var removeClassThatContains = function removeClassThatContains(el) {
  var string = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  for (var i = 0; i < el.classList.length; i++) {
    if (el.classList.item(i).indexOf(string) !== -1) {
      el.classList.remove(el.classList.item(i));
    }
  }
};
/**
 * Compares an els classList against an array of strings to see if any match
 * @param el the element to check against
 * @param arr The array of classes as strings to test against
 * @param prefix optional prefix string applied to all test strings
 * @param suffix optional suffix string
 */

var hasClassFromArray = function hasClassFromArray(el) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return arr.some(function (c) {
    return el.classList.contains("".concat(prefix).concat(c).concat(suffix));
  });
};
/**
 * Highly efficient function to convert a nodelist into a standard array. Allows you to run Array.forEach
 *
 * @param {Element|NodeList} elements to convert
 * @returns {Array} Of converted elements
 */

var convertElements = function convertElements() {
  var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var converted = [];
  var i = elements.length;

  for (i; i--; converted.unshift(elements[i])) {
    ;
  } // eslint-disable-line


  return converted;
};
/**
 * Should be used at all times for getting nodes throughout our app. Please use the data-js attribute whenever possible
 *
 * @param selector The selector string to search for. If arg 4 is false (default) then we search for [data-js="selector"]
 * @param convert Convert the NodeList to an array? Then we can Array.forEach directly. Uses convertElements from above
 * @param node Parent node to search from. Defaults to document
 * @param custom Is this a custom selector where we don't want to use the data-js attribute?
 * @returns {NodeList}
 */

var getNodes = function getNodes() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var convert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var node = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  var custom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var selectorString = custom ? selector : "[data-js=\"".concat(selector, "\"]");
  var nodes = node.querySelectorAll(selectorString);

  if (convert) {
    nodes = convertElements(nodes);
  }

  return nodes;
};
/**
 * Gets the closest ancestor that matches a selector string
 *
 * @param el
 * @param selector
 * @returns {*}
 */

var closest = function closest(el, selector) {
  var matchesFn;
  var parent;
  ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
    if (typeof document.body[fn] === 'function') {
      matchesFn = fn;
      return true;
    }
    /* istanbul ignore next */


    return false;
  });

  while (el) {
    parent = el.parentElement;

    if (parent && parent[matchesFn](selector)) {
      return parent;
    }

    el = parent; // eslint-disable-line
  }

  return null;
};
/**
 * Insert a node after another node
 *
 * @param newNode {Element|NodeList}
 * @param referenceNode {Element|NodeList}
 */

var insertAfter = function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextElementSibling);
};
/**
 * Insert a node before another node
 *
 * @param newNode {Element|NodeList}
 * @param referenceNode {Element|NodeList}
 */

var insertBefore = function insertBefore(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode);
};
var isMaybeCloseToView = function isMaybeCloseToView(elem, distance) {
  return window.scrollY + distance >= $(elem).offset().top;
};
var isInViewport = function isInViewport(elem) {
  var bounding = elem.getBoundingClientRect();
  return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(139);
var anObject = __webpack_require__(9);
var speciesConstructor = __webpack_require__(143);
var advanceStringIndex = __webpack_require__(91);
var toLength = __webpack_require__(19);
var callRegExpExec = __webpack_require__(92);
var regexpExec = __webpack_require__(95);
var fails = __webpack_require__(25);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(94)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(51);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_all_focusables__ = __webpack_require__(96);

/* harmony default export */ __webpack_exports__["a"] = (function (element) {
  var focusableElements = Object(__WEBPACK_IMPORTED_MODULE_0__get_all_focusables__["a" /* default */])();
  var targetIndex = focusableElements.indexOf(element);

  if (targetIndex === -1) {
    var errorMessage = 'Next focusable not found, is the argument  focusable?';
    throw errorMessage;
  }

  return targetIndex < focusableElements.length - 1 ? focusableElements[targetIndex + 1] : focusableElements[0];
});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(9);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(44);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(93);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(44);
module.exports = __webpack_require__(28).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(26);
var invoke = __webpack_require__(320);
var html = __webpack_require__(122);
var cel = __webpack_require__(76);
var global = __webpack_require__(8);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(31)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(51);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFormKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_assign__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace__);




function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var buildUrl = function buildUrl(template, params) {
  return template.replace(/{([^{}]+)}/g, function (match, key) {
    return Object.prototype.hasOwnProperty.call(params, key) ? encodeURIComponent(params[key]) : 'none';
  });
};

var getInvalidFormIdError = function getInvalidFormIdError() {
  return new Error('Invalid form ID');
}; // TODO Remove the additionalParams argument after AB#245834 is in prod
// as it is not involved in the backend logic of the /get_form endpoint


var getForm = function getForm(formId, nfFormsCounter) {
  var additionalParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if ($('.ENABLE_CACHE_LAZY_FORMS').length > 0) {
    return new Promise(function (resolve, reject) {
      var filteredFormId = parseInt(formId, 10);

      if (isNaN(filteredFormId)) {
        reject(getInvalidFormIdError());
      }

      var urlPathTemplate = '/wp-json/nf_tp/get_form/{form_id}/{async_form}/{nf_forms_counter}';
      var formData = {
        form_id: filteredFormId,
        async_form: 1,
        nf_forms_counter: nfFormsCounter
      };
      var url = buildUrl(urlPathTemplate, formData);
      var urlParams = {
        _wpnonce: nf_get_forms_data.NONCE
      };
      $.get(url, urlParams, function (response) {
        return resolve(response);
      });
    });
  } // Remove after AB#245834 in prod


  return new Promise(function (resolve) {
    var formData = _extends({
      form_id: formId,
      async_form: true,
      nf_forms_counter: nfFormsCounter
    }, additionalParams);

    formData._wpnonce = nf_get_forms_data.NONCE;
    $.post('/wp-json/nf_tp/get_form', formData, function (response) {
      return resolve(response);
    });
  });
};
var getFormKey = function getFormKey(formId) {
  if ($('.ENABLE_CACHE_LAZY_FORMS').length > 0) {
    var filteredFormId = parseInt(formId, 10);

    if (isNaN(filteredFormId)) {
      throw getInvalidFormIdError();
    }

    return btoa(filteredFormId);
  } // Remove after AB#2245834 in prod


  return btoa(formId);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(111),
    baseKeysIn = __webpack_require__(346),
    isArrayLike = __webpack_require__(22);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(87),
    getPrototype = __webpack_require__(154),
    getSymbols = __webpack_require__(88),
    stubArray = __webpack_require__(132);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(113);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(12);
var toLength = __webpack_require__(19);
var context = __webpack_require__(138);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(140)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _class; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_emitter__ = __webpack_require__(396);





function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var $ = jQuery;

var _class =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(_class, _EventEmitter);

  function _class(liDOM) {
    var _this;

    _classCallCheck(this, _class);

    _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));
    _this.VISIBLE_MENU_LI_CLASSES = ['et-show-dropdown', 'visible'];
    _this.liDOM = liDOM;
    _this.submenuDOM = $(liDOM).children('ul');
    _this.liObserver = new MutationObserver(function (mutationList) {
      mutationList.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (_this.hasClass(_this.liDOM, mutation.oldValue, _this.VISIBLE_MENU_LI_CLASSES)) {
            _this.emit('show');
          } else if (_this.hadClass(_this.liDOM, mutation.oldValue, _this.VISIBLE_MENU_LI_CLASSES)) {
            _this.emit('hide');
          }
        }
      });
    });
    return _this;
  }

  _createClass(_class, [{
    key: "connect",
    value: function connect() {
      this.liObserver.observe(this.liDOM, {
        attributes: true,
        attributeOldValue: true
      });
    }
  }, {
    key: "onShow",
    value: function onShow(handler) {
      this.on('show', handler);
    }
  }, {
    key: "onHide",
    value: function onHide(handler) {
      this.on('hide', handler);
    }
  }, {
    key: "hasClass",
    value: function hasClass(dom, oldValue, classes) {
      var result = false;

      if (!oldValue) {
        /* eslint-disable no-param-reassign */
        oldValue = '';
      }

      classes.forEach(function (currentValue) {
        if (!oldValue.includes(currentValue) && dom.className.includes(currentValue)) {
          result = true;
        }
      });
      return result;
    }
  }, {
    key: "hadClass",
    value: function hadClass(dom, oldValue, classes) {
      var result = false;

      if (!oldValue) {
        /* eslint-disable no-param-reassign */
        oldValue = '';
      }

      classes.forEach(function (currentValue) {
        if (oldValue.includes(currentValue) && !dom.className.includes(currentValue)) {
          result = true;
        }
      });
      return result;
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_4__event_emitter__["a" /* default */]);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (immutable) */ __webpack_exports__["b"] = restoreFocusForSubmenu;
/* harmony export (immutable) */ __webpack_exports__["a"] = disableFocusForSubmenu;
var $ = jQuery;
function restoreFocusForSubmenu(menuLI) {
  $(menuLI).children('ul').children('li').children('a,button').each(function () {
    var tabIndex = $(this).is('[data-original-focus]') ? $(this).attr('data-original-focus') : 0;
    $(this).attr('tabindex', tabIndex);
  });
}
function disableFocusForSubmenu(menuLI) {
  var result = false;
  $(menuLI).children('ul').children('li').children('a,button').each(function () {
    if (!$(this).is('[data-original-focus]')) {
      var focusValue = $(this).is('[tabindex]') ? $(this).attr('tabindex') : 0;
      $(this).attr('data-original-focus', focusValue);
    }

    if (parseInt($(this).attr('tabindex'), 10) >= 0) {
      result = true;
    }

    $(this).attr('tabindex', '-1');
  });
  return result;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_ready__ = __webpack_require__(159);

Object(__WEBPACK_IMPORTED_MODULE_0__core_ready__["a" /* default */])();

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resize__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__viewport_dims__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_events__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__divi_index__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_index__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__accessibility_index__ = __webpack_require__(379);

// you MUST do this in every module you use lodash in.
// A custom bundle of only the lodash you use will be built by babel.






/**
 * @function bindEvents
 * @description Bind global event listeners here,
 */

var bindEvents = function bindEvents() {
  Object(__WEBPACK_IMPORTED_MODULE_3__utils_events__["a" /* on */])(window, 'resize', __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(__WEBPACK_IMPORTED_MODULE_1__resize__["a" /* default */], 200, false));
};

var init = function init() {
  Object(__WEBPACK_IMPORTED_MODULE_2__viewport_dims__["a" /* default */])(); // initialize global events

  bindEvents();
  Object(__WEBPACK_IMPORTED_MODULE_5__forms_index__["a" /* default */])();
  console.info('Initialized all javascript that targeted document ready.');
};
/**
 * @function setupEnivironment
 * @description
 */


var setupEnvironment = function setupEnvironment() {
  init();
};
/**
 * @function domReady
 * @description Export our dom ready enabled init.
 */


var domReady = function domReady() {
  Object(__WEBPACK_IMPORTED_MODULE_4__divi_index__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_3__utils_events__["b" /* ready */])(setupEnvironment);
  Object(__WEBPACK_IMPORTED_MODULE_6__accessibility_index__["a" /* default */])();
};

/* harmony default export */ __webpack_exports__["a"] = (domReady);

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14),
    now = __webpack_require__(161),
    toNumber = __webpack_require__(162);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(11);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14),
    isSymbol = __webpack_require__(33);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_events__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__viewport_dims__ = __webpack_require__(114);
/**
 * @module
 * @exports resize
 * @description Kicks in any third party plugins that operate on a sitewide basis.
 */



var resize = function resize() {
  // code for resize events can go here
  Object(__WEBPACK_IMPORTED_MODULE_1__viewport_dims__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_events__["c" /* trigger */])({
    event: 'modern_tribe/resize_executed',
    native: false
  });
};

/* harmony default export */ __webpack_exports__["a"] = (resize);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(68),
    copyObject = __webpack_require__(35),
    createAssigner = __webpack_require__(171),
    isArrayLike = __webpack_require__(22),
    isPrototype = __webpack_require__(36),
    keys = __webpack_require__(23);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(108),
    isMasked = __webpack_require__(168),
    isObject = __webpack_require__(14),
    toSource = __webpack_require__(109);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(169);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(11);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 170 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(172),
    isIterateeCall = __webpack_require__(110);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(69),
    overRest = __webpack_require__(173),
    setToString = __webpack_require__(175);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(174);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(176),
    shortOut = __webpack_require__(178);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(177),
    defineProperty = __webpack_require__(107),
    identity = __webpack_require__(69);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 179 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isLength = __webpack_require__(70),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(113);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  desktop_initialized: false,
  is_desktop: false,
  is_mobile: false,
  mobile_initialized: false,
  v_height: 0,
  v_width: 0
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MOBILE_BREAKPOINT; });
/* unused harmony export FULL_BREAKPOINT */
// breakpoint settings
var MOBILE_BREAKPOINT = 768;
var FULL_BREAKPOINT = 960;

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bg_video__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fontawesome__ = __webpack_require__(311);




/**
 * @function init
 * @description Kick off this modules functions
 */

var init = function init() {
  Object(__WEBPACK_IMPORTED_MODULE_0__modules__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_1__bg_video__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_2__navigation__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_3__fontawesome__["a" /* default */])();
};

/* harmony default export */ __webpack_exports__["a"] = (init);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__people_people__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__people_people_single__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__custom_types_fl_select__ = __webpack_require__(301);




var registerModules = function registerModules(event, API) {
  var modules = [__WEBPACK_IMPORTED_MODULE_0__people_people__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__people_people_single__["a" /* default */]];
  API.registerModules(modules);
};

var registerCustomFields = function registerCustomFields(event, API) {
  var customTypes = [__WEBPACK_IMPORTED_MODULE_2__custom_types_fl_select__["a" /* default */]];
  API.registerModalFields(customTypes);
};

var bindEvents = function bindEvents() {
  $(window).on('et_builder_api_ready', registerModules);

  if ($('.ENABLE_DIVI_NINJA_FORM_FIX').length > 0) {
    $(window).on('et_builder_api_ready', registerCustomFields);
  }
};
/**
 * @function init
 * @description Initializes modules.
 */


var init = function init() {
  bindEvents();
};

/* harmony default export */ __webpack_exports__["a"] = (init);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__image__ = __webpack_require__(204);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// External Dependencies




var People =
/*#__PURE__*/
function (_Component) {
  _inherits(People, _Component);

  function People() {
    _classCallCheck(this, People);

    return _possibleConstructorReturn(this, (People.__proto__ || Object.getPrototypeOf(People)).apply(this, arguments));
  }

  _createClass(People, [{
    key: "getImage",
    value: function getImage(imgUrl) {
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__image__["a" /* default */], {
          imageURL: imgUrl
        })
      );
    }
  }, {
    key: "getManualPerson",
    value: function getManualPerson() {
      var person = {};
      person.name = this.props.name;
      person.bio = this.props.content().props.content;
      person.image = this.getImage(this.props.image);
      person.profile_url = {
        url: this.props.link,
        label: 'See Profile'
      };
      person.contact_url = {
        url: this.props.contact_link,
        label: 'Contact Now'
      };
      person.container_classes = 'fl-bio t-content fl-col fl-bio--right';
      return person;
    }
  }, {
    key: "render",
    value: function render() {
      var person = false;

      if (typeof this.props.person_details.data !== 'undefined' && this.props.type === 'select') {
        person = this.props.person_details.data;
        person.image = this.getImage(person.image_url);
      }

      if (this.props.type === 'manual') {
        person = this.getManualPerson();
      }

      if (!person) {
        return null;
      }

      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
          className: "fl-component et_pb_module et_pb_team_member",
          id: this.props.id
        },
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
          className: person.container_classes
        }, person.image &&
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
          className: "fl-bio__image et_pb_team_member_image"
        }, person.image),
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
          className: "fl-bio__content et_pb_team_member_description"
        },
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h4", {
          className: "fl-bio__name et_pb_module_header"
        }, person.name),
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("p", {
          className: "fl-bio__desc",
          dangerouslySetInnerHTML: {
            __html: person.bio
          }
        }), person.profile_url.url &&
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a", {
          className: "fl-bio__link",
          href: person.profile_url.url
        },
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", {
          className: "icon icon-person",
          "aria-hidden": "true"
        }), person.profile_url.label))))
      );
    }
  }]);

  return People;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

People.slug = 'fl_people';
People.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  person_details: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  content: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  image: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  link: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  contact_link: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};
People.defaultProps = {
  person_details: {}
};
/* harmony default export */ __webpack_exports__["a"] = (People);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(50)('native-function-to-string', Function.toString);


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(38)('meta');
var isObject = __webpack_require__(13);
var has = __webpack_require__(24);
var setDesc = __webpack_require__(17).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(25)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(28);
var LIBRARY = __webpack_require__(39);
var wksExt = __webpack_require__(117);
var defineProperty = __webpack_require__(17).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(40);
var gOPS = __webpack_require__(81);
var pIE = __webpack_require__(54);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(53);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var anObject = __webpack_require__(9);
var getKeys = __webpack_require__(40);

module.exports = __webpack_require__(16) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(30);
var gOPN = __webpack_require__(123).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(13);
var anObject = __webpack_require__(9);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(26)(Function.call, __webpack_require__(124).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(198),n=__webpack_require__(199),p=__webpack_require__(200),q=__webpack_require__(201),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(203);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// External Dependencies



var Image =
/*#__PURE__*/
function (_Component) {
  _inherits(Image, _Component);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: "render",
    value: function render() {
      this.srcSet = "".concat(this.props.imageURL, " 150w");
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("figure", {
          className: "fl-bio__image-figure"
        },
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", {
          className: "fl-bio__image-img",
          alt: "profile",
          src: this.props.imageURL,
          srcSet: this.srcSet,
          "data-parent-fit": "width"
        }))
      );
    }
  }]);

  return Image;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Image.propTypes = {
  imageURL: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_parts_map__ = __webpack_require__(206);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PeopleSingle =
/*#__PURE__*/
function (_Component) {
  _inherits(PeopleSingle, _Component);

  function PeopleSingle() {
    _classCallCheck(this, PeopleSingle);

    return _possibleConstructorReturn(this, (PeopleSingle.__proto__ || Object.getPrototypeOf(PeopleSingle)).apply(this, arguments));
  }

  _createClass(PeopleSingle, [{
    key: "render",
    value: function render() {
      var personConfig = window.et_person_config;

      if (!personConfig) {
        return null;
      }

      if (typeof this.props.element === 'undefined' || !this.props.element) {
        return null;
      }

      var Tag = __WEBPACK_IMPORTED_MODULE_4__parts_parts_map__["a" /* default */][this.props.element];
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, {
          data: personConfig,
          moduleProps: this.props
        })
      );
    }
  }]);

  return PeopleSingle;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

PeopleSingle.slug = 'fl_people_single';
PeopleSingle.propTypes = {
  element: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PeopleSingle);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__first_name__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middle_name__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__last_name__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__full_name__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bio__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__image__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bar_admissions__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_seminars__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__education__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__honors__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__location__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__location_text__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__phone__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fax__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__email__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__practice_areas__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__professional_association__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__published_works__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__past_positions__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pro_bonos__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__languages__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__fraternity_sororities__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__references__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__representative_cases__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__specialties__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ancillary_businesses__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__current_positions__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__representative_clients__ = __webpack_require__(300);




























/* harmony default export */ __webpack_exports__["a"] = ({
  first_name: __WEBPACK_IMPORTED_MODULE_0__first_name__["a" /* default */],
  middle_name: __WEBPACK_IMPORTED_MODULE_1__middle_name__["a" /* default */],
  last_name: __WEBPACK_IMPORTED_MODULE_2__last_name__["a" /* default */],
  full_name: __WEBPACK_IMPORTED_MODULE_3__full_name__["a" /* default */],
  bio: __WEBPACK_IMPORTED_MODULE_4__bio__["a" /* default */],
  profile_image: __WEBPACK_IMPORTED_MODULE_5__image__["a" /* default */],
  bar_admissions: __WEBPACK_IMPORTED_MODULE_6__bar_admissions__["a" /* default */],
  classes_seminars: __WEBPACK_IMPORTED_MODULE_7__classes_seminars__["a" /* default */],
  education: __WEBPACK_IMPORTED_MODULE_8__education__["a" /* default */],
  honors: __WEBPACK_IMPORTED_MODULE_9__honors__["a" /* default */],
  location: __WEBPACK_IMPORTED_MODULE_10__location__["a" /* default */],
  location_text: __WEBPACK_IMPORTED_MODULE_11__location_text__["a" /* default */],
  phone: __WEBPACK_IMPORTED_MODULE_12__phone__["a" /* default */],
  fax: __WEBPACK_IMPORTED_MODULE_13__fax__["a" /* default */],
  email: __WEBPACK_IMPORTED_MODULE_14__email__["a" /* default */],
  practice_areas: __WEBPACK_IMPORTED_MODULE_15__practice_areas__["a" /* default */],
  professional_assoc: __WEBPACK_IMPORTED_MODULE_16__professional_association__["a" /* default */],
  published_works: __WEBPACK_IMPORTED_MODULE_17__published_works__["a" /* default */],
  past_positions: __WEBPACK_IMPORTED_MODULE_18__past_positions__["a" /* default */],
  pro_bonos: __WEBPACK_IMPORTED_MODULE_19__pro_bonos__["a" /* default */],
  languages: __WEBPACK_IMPORTED_MODULE_20__languages__["a" /* default */],
  fraternity_sororities: __WEBPACK_IMPORTED_MODULE_21__fraternity_sororities__["a" /* default */],
  representative_cases: __WEBPACK_IMPORTED_MODULE_23__representative_cases__["a" /* default */],
  specialties: __WEBPACK_IMPORTED_MODULE_24__specialties__["a" /* default */],
  references: __WEBPACK_IMPORTED_MODULE_22__references__["a" /* default */],
  ancillary_businesses: __WEBPACK_IMPORTED_MODULE_25__ancillary_businesses__["a" /* default */],
  current_positions: __WEBPACK_IMPORTED_MODULE_26__current_positions__["a" /* default */],
  representative_clients: __WEBPACK_IMPORTED_MODULE_27__representative_clients__["a" /* default */]
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var FirstName = function FirstName(props) {
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, props.data.first_name)
  );
};

FirstName.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FirstName);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var MiddleName = function MiddleName(props) {
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, props.data.middle_name)
  );
};

MiddleName.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (MiddleName);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var LastName = function LastName(props) {
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, props.data.last_name)
  );
};

LastName.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LastName);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var FullName = function FullName(props) {
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, props.data.full_name)
  );
};

FullName.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FullName);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Bio = function Bio(props) {
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: props.data.bio
      }
    })
  );
};

Bio.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Bio);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Image = function Image(props) {
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      className: "bio-image",
      src: props.data.profile_image,
      alt: "profile"
    })
  );
};

Image.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var BarAdmissions = function BarAdmissions(props) {
  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(props.data.bar_admissions) && props.data.bar_admissions.length) {
    return (
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ul", {
        className: "bio-list"
      }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(props.data.bar_admissions, function (data) {
        var barDisplay = data.ba_name;

        if (data.ba_year) {
          barDisplay = "".concat(data.ba_name, ", ").concat(data.ba_year);
        }

        return (
          /*#__PURE__*/
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li", {
            className: "bio-list__item",
            key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
          }, barDisplay)
        );
      }))
    );
  }

  return null;
};

BarAdmissions.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (BarAdmissions);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27),
    arrayMap = __webpack_require__(82),
    isArray = __webpack_require__(3),
    isSymbol = __webpack_require__(33);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(216),
    getMatchData = __webpack_require__(253),
    matchesStrictComparable = __webpack_require__(134);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(84),
    baseIsEqual = __webpack_require__(126);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(57);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(57);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(57);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(57);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(56);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(56),
    Map = __webpack_require__(85),
    MapCache = __webpack_require__(86);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(228),
    ListCache = __webpack_require__(56),
    Map = __webpack_require__(85);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(229),
    hashDelete = __webpack_require__(230),
    hashGet = __webpack_require__(231),
    hashHas = __webpack_require__(232),
    hashSet = __webpack_require__(233);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(58);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(58);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(58);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(58);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(59);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(59);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(59);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(59);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(84),
    equalArrays = __webpack_require__(127),
    equalByTag = __webpack_require__(244),
    equalObjects = __webpack_require__(247),
    getTag = __webpack_require__(43),
    isArray = __webpack_require__(3),
    isBuffer = __webpack_require__(49),
    isTypedArray = __webpack_require__(73);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(86),
    setCacheAdd = __webpack_require__(241),
    setCacheHas = __webpack_require__(242);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 241 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 242 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 243 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27),
    Uint8Array = __webpack_require__(129),
    eq = __webpack_require__(47),
    equalArrays = __webpack_require__(127),
    mapToArray = __webpack_require__(245),
    setToArray = __webpack_require__(246);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 245 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(130);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 248 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(21),
    root = __webpack_require__(11);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(21),
    root = __webpack_require__(11);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(21),
    root = __webpack_require__(11);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(21),
    root = __webpack_require__(11);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(133),
    keys = __webpack_require__(23);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(126),
    get = __webpack_require__(255),
    hasIn = __webpack_require__(259),
    isKey = __webpack_require__(89),
    isStrictComparable = __webpack_require__(133),
    matchesStrictComparable = __webpack_require__(134),
    toKey = __webpack_require__(60);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(135);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(257);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(258);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(86);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(260),
    hasPath = __webpack_require__(261);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(136),
    isArguments = __webpack_require__(48),
    isArray = __webpack_require__(3),
    isIndex = __webpack_require__(71),
    isLength = __webpack_require__(70),
    toKey = __webpack_require__(60);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(263),
    basePropertyDeep = __webpack_require__(264),
    isKey = __webpack_require__(89),
    toKey = __webpack_require__(60);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 263 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(135);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(137),
    isArrayLike = __webpack_require__(22);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(267),
    keys = __webpack_require__(23);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(268);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(22);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var formatClassOrSeminar = function formatClassOrSeminar(_ref) {
  var desc = _ref.cs_desc,
      sponsor = _ref.cs_sponsor,
      time = _ref.cs_time;
  var classOrSeminar = desc;

  if (sponsor) {
    classOrSeminar += ", ".concat(sponsor);
  }

  if (time) {
    classOrSeminar += ", ".concat(time);
  }

  return classOrSeminar;
};

var ClassesSeminars = function ClassesSeminars(props) {
  var classesSeminars = props.data.classes_seminars;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(classesSeminars) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(classesSeminars)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(classesSeminars, function (classOrSeminar) {
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, formatClassOrSeminar(classOrSeminar))
      );
    }))
  );
};

ClassesSeminars.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ClassesSeminars);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__school__ = __webpack_require__(272);







var Education = function Education(props) {
  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(props.data.education) || !props.data.education.length) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(props.data.education, function (data) {
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__school__["a" /* default */], {
          data: data,
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('school-')
        })
      );
    }))
  );
};

Education.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Education);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__degree__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__focus_list__ = __webpack_require__(276);






var getDegreesAndFocuses = function getDegreesAndFocuses(data) {
  if ( // We only want to show the sublist if at least one of these properties exist.
  !__WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(['degree_name', 'grad_date', 'distinction', 'school_latin_honors', 'school_honors', 'school_majors', 'school_minors'], function (prop) {
    return data[prop];
  })) {
    return null;
  }

  var distinction = data.distinction ?
  /*#__PURE__*/
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li", null, "Honors: ",
  /*#__PURE__*/
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("em", null, data.distinction.toLowerCase())) : null;
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("ul", null,
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__degree__["a" /* default */], {
      name: data.degree_name,
      date: data.grad_date
    }), distinction,
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__focus_list__["a" /* default */], {
      prefix: "Honors:",
      items: data.school_latin_honors
    }),
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__focus_list__["a" /* default */], {
      prefix: "Honors:",
      items: data.school_honors
    }),
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__focus_list__["a" /* default */], {
      prefix: "Major:",
      items: data.school_majors
    }),
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__focus_list__["a" /* default */], {
      prefix: "Minor:",
      items: data.school_minors
    }))
  );
};

var School = function School(_ref) {
  var data = _ref.data;
  var city = data.city ?
  /*#__PURE__*/
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", null, ", ", data.city) : '';
  var state = data.state ?
  /*#__PURE__*/
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", null, ", ", data.state) : '';
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li", {
      className: "bio-list__item"
    },
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, data.school), city, state, getDegreesAndFocuses(data))
  );
};

School.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (School);

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(128),
    baseIteratee = __webpack_require__(83),
    baseSome = __webpack_require__(274),
    isArray = __webpack_require__(3),
    isIterateeCall = __webpack_require__(110);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(137);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




var Degree = function Degree(_ref) {
  var name = _ref.name,
      date = _ref.date;

  if (!name && !date) {
    return null;
  }

  var separator = name && date ? ' - ' : '';
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li", null, name, separator, date)
  );
};

Degree.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Degree.defaultProps = {
  name: null,
  date: null
};
/* harmony default export */ __webpack_exports__["a"] = (Degree);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_flatten__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var FocusList = function FocusList(_ref) {
  var items = _ref.items,
      prefix = _ref.prefix;
  // Convert objects to arrays, assuming there is only one item in the array.
  var listOfArrays = (items || []).map(__WEBPACK_IMPORTED_MODULE_2_lodash_values___default.a); // Combine (or flatten) all values so it's a simple array of strings.

  return __WEBPACK_IMPORTED_MODULE_1_lodash_flatten___default()(listOfArrays).map(function (item) {
    return (
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
        key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
      }, prefix, " ", item)
    );
  });
};

FocusList.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  prefix: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
FocusList.defaultProps = {
  items: [],
  prefix: ''
};
/* harmony default export */ __webpack_exports__["a"] = (FocusList);

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(278);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(87),
    isFlattenable = __webpack_require__(279);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27),
    isArguments = __webpack_require__(48),
    isArray = __webpack_require__(3);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(281),
    keys = __webpack_require__(23);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(82);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Honors = function Honors(props) {
  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(props.data.honors) && props.data.honors.length) {
    return (
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ul", {
        className: "bio-list"
      }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(props.data.honors, function (data) {
        return (
          /*#__PURE__*/
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li", {
            className: "bio-list__item",
            key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
          }, data.honor_desc)
        );
      }))
    );
  }

  return null;
};

Honors.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Honors);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Location = function Location(props) {
  var address = props.data.location.address;
  var mapStyle = {
    height: "".concat(props.moduleProps.map_height, "px")
  };
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", {
      className: "people-module__location",
      title: address,
      src: "//maps.google.com/maps?q=".concat(address, "&z=15&output=embed"),
      frameBorder: "0",
      style: mapStyle
    })
  );
};

Location.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  moduleProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Location);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var LocationText = function LocationText(props) {
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, props.data.location_text)
  );
};

LocationText.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LocationText);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Phone = function Phone(props) {
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, props.data.phone)
  );
};

Phone.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Phone);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Fax = function Fax(props) {
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, props.data.fax)
  );
};

Fax.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Fax);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Email = function Email(props) {
  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, props.data.email)
  );
};

Email.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Email);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var PracticeAreas = function PracticeAreas(props) {
  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(props.data.practice_areas) && props.data.practice_areas.length) {
    return (
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ul", {
        className: "bio-list"
      }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(props.data.practice_areas, function (data) {
        var paPercentage = parseInt(data.pra_percentage, 10) ? "".concat(data.pra_percentage, "%") : '';
        return (
          /*#__PURE__*/
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li", {
            className: "bio-list__item",
            key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
          }, data.pra_title, " ", paPercentage)
        );
      }))
    );
  }

  return null;
};

PracticeAreas.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PracticeAreas);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var formatProfesssionalAssoc = function formatProfesssionalAssoc(_ref) {
  var name = _ref.pa_name,
      title = _ref.pa_title,
      timePeriod = _ref.pa_time_period;
  var professionalAssoc = name;

  if (title) {
    professionalAssoc += ", ".concat(title);
  }

  if (timePeriod) {
    professionalAssoc += ", ".concat(timePeriod);
  }

  return professionalAssoc;
};

var ProfessionalAssociation = function ProfessionalAssociation(props) {
  var professionalAssoc = props.data.professional_assoc;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(professionalAssoc) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(professionalAssoc)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(professionalAssoc, function (association) {
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, formatProfesssionalAssoc(association))
      );
    }))
  );
};

ProfessionalAssociation.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ProfessionalAssociation);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var formatPublishedWork = function formatPublishedWork(_ref) {
  var title = _ref.pw_title,
      citationOrPublisher = _ref.pw_citation_or_publisher,
      issue = _ref.pw_issue,
      year = _ref.pw_year;
  var publishedWork = title;

  if (citationOrPublisher) {
    publishedWork += ", ".concat(citationOrPublisher);
  }

  if (issue) {
    publishedWork += ", ".concat(issue);
  }

  if (year) {
    publishedWork += ", ".concat(year);
  }

  return publishedWork;
};

var PublishedWorks = function PublishedWorks(props) {
  var publishedWorks = props.data.published_works;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(publishedWorks) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(publishedWorks)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(publishedWorks, function (publishedWork) {
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, formatPublishedWork(publishedWork))
      );
    }))
  );
};

PublishedWorks.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PublishedWorks);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var formatPastPosition = function formatPastPosition(_ref) {
  var organizationName = _ref.pp_organization_name,
      positionTitle = _ref.pp_position_title,
      timePeriod = _ref.pp_time_period;
  var pastPosition = organizationName;

  if (positionTitle) {
    pastPosition += ", ".concat(positionTitle);
  }

  if (timePeriod) {
    pastPosition += ", ".concat(timePeriod);
  }

  return pastPosition;
};

var PastPositions = function PastPositions(props) {
  var pastPositions = props.data.past_positions;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(pastPositions) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(pastPositions)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(pastPositions, function (pastPosition) {
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, formatPastPosition(pastPosition))
      );
    }))
  );
};

PastPositions.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PastPositions);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var formatProBono = function formatProBono(_ref) {
  var activity = _ref.pb_activity,
      timePeriod = _ref.pb_time_period;
  var proBono = activity;

  if (timePeriod) {
    proBono += ", ".concat(timePeriod);
  }

  return proBono;
};

var ProBonos = function ProBonos(props) {
  var proBonos = props.data.pro_bonos;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(proBonos) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(proBonos)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(proBonos, function (proBono) {
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, formatProBono(proBono))
      );
    }))
  );
};

ProBonos.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ProBonos);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var Languages = function Languages(props) {
  var languages = props.data.languages;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(languages) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(languages)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(languages, function (_ref) {
      var languageDescription = _ref.la_language_description;
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, languageDescription)
      );
    }))
  );
};

Languages.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Languages);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var FraternitySororities = function FraternitySororities(props) {
  var fraternitySororities = props.data.fraternity_sororities;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(fraternitySororities) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(fraternitySororities)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(fraternitySororities, function (_ref) {
      var fraternitySorority = _ref.fs_fraternity_sorority;
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, fraternitySorority)
      );
    }))
  );
};

FraternitySororities.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FraternitySororities);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var References = function References(props) {
  var references = props.data.references;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(references) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(references)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(references, function (_ref) {
      var referenceName = _ref.re_reference_name;
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, referenceName)
      );
    }))
  );
};

References.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (References);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var formatRepresentativeCase = function formatRepresentativeCase(_ref) {
  var title = _ref.rc_case_title,
      citation = _ref.rc_citation,
      year = _ref.rc_year,
      court = _ref.rc_court,
      serialNumber = _ref.rc_serial_number;
  var representativeCase = title;

  if (citation) {
    representativeCase += ", ".concat(citation);
  }

  if (year) {
    representativeCase += ", ".concat(year);
  }

  if (court) {
    representativeCase += ", ".concat(court);
  }

  if (serialNumber) {
    representativeCase += ", ".concat(serialNumber);
  }

  return representativeCase;
};

var RepresentativeCases = function RepresentativeCases(props) {
  var representativeCases = props.data.representative_cases;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(representativeCases) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(representativeCases)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(representativeCases, function (representativeCase) {
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, formatRepresentativeCase(representativeCase))
      );
    }))
  );
};

RepresentativeCases.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (RepresentativeCases);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var formatSpecialty = function formatSpecialty(_ref) {
  var specDetail = _ref.sp_spec_detail,
      certifiedBy = _ref.sp_certified_by,
      certifiedYear = _ref.sp_certified_year;
  var specialty = specDetail;

  if (certifiedBy) {
    specialty += ", ".concat(certifiedBy);
  }

  if (certifiedYear) {
    specialty += ", ".concat(certifiedYear);
  }

  return specialty;
};

var Specialties = function Specialties(props) {
  var specialties = props.data.specialties;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(specialties) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(specialties)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(specialties, function (specialty) {
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, formatSpecialty(specialty))
      );
    }))
  );
};

Specialties.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Specialties);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var AncillaryBusinesses = function AncillaryBusinesses(props) {
  var ancillaryBusinesses = props.data.ancillary_businesses;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(ancillaryBusinesses) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(ancillaryBusinesses)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ancillaryBusinesses, function (_ref) {
      var ancillaryBusinessName = _ref.ab_ancillary_business_name;
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, ancillaryBusinessName)
      );
    }))
  );
};

AncillaryBusinesses.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AncillaryBusinesses);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var formatCurrentPosition = function formatCurrentPosition(_ref) {
  var title = _ref.cp_title,
      timePeriod = _ref.cp_time_period;
  var currentPosition = title;

  if (timePeriod) {
    currentPosition += ", ".concat(timePeriod);
  }

  return currentPosition;
};

var CurrentPositions = function CurrentPositions(props) {
  var currentPositions = props.data.current_positions;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(currentPositions) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(currentPositions)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(currentPositions, function (currentPosition) {
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, formatCurrentPosition(currentPosition))
      );
    }))
  );
};

CurrentPositions.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (CurrentPositions);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var RepresentativeClients = function RepresentativeClients(props) {
  var representativeClients = props.data.representative_clients;

  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(representativeClients) || __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(representativeClients)) {
    return null;
  }

  return (
    /*#__PURE__*/
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", {
      className: "bio-list"
    }, __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(representativeClients, function (_ref) {
      var name = _ref.rc_name;
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
          className: "bio-list__item",
          key: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqueId___default()('list-item-')
        }, name)
      );
    }))
  );
};

RepresentativeClients.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (RepresentativeClients);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);






function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FLSelect =
/*#__PURE__*/
function (_Component) {
  _inherits(FLSelect, _Component);

  function FLSelect() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, FLSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = FLSelect.__proto__ || Object.getPrototypeOf(FLSelect)).call.apply(_ref, [this].concat(args))), _this._onChange = function (event) {
      _this.props._onChange(_this.props.name, event.target.value);
    }, _this._init = function (value) {
      _this.props._onChange(_this.props.name, value);
    }, _temp));
  }

  _createClass(FLSelect, [{
    key: "render",
    value: function render() {
      var optionsData = this.props.fieldDefinition.options; // If there are no options, return an error message

      if (optionsData.length === 0) {
        var errorMessage = this.props.fieldDefinition.errors && this.props.fieldDefinition.errors.emptyOptions || 'options list is empty';
        return (
          /*#__PURE__*/
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", {
            className: "fl-select-error-msg"
          },
          /*#__PURE__*/
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", null, errorMessage))
        );
      } // The first option is selected by default if no value is provided or if the value is not in the options list


      var currentValue = this.props.value;
      var currentValueIsEmpty = currentValue.length === 0;
      var currentValueIsNotInOptions = Object.keys(optionsData).includes(currentValue) === false;

      if (currentValueIsEmpty || currentValueIsNotInOptions) {
        currentValue = Object.keys(optionsData)[0];

        this._init(currentValue);
      }

      var options = Object.keys(optionsData).map(function (id) {
        return (
          /*#__PURE__*/
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("option", {
            value: id,
            key: "fl-select-option-".concat(id)
          }, optionsData[id])
        );
      });
      return (
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("select", {
          id: "fl-select-".concat(this.props.name),
          name: this.props.name,
          value: currentValue,
          className: "fl-select",
          onChange: this._onChange,
          required: true
        }, options)
      );
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        _onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
        name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
        value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
        fieldDefinition: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
      };
    }
    /**
     * Handle input value change.
     *
     * @param {object} event
     * @private
     */

  }]);

  return FLSelect;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

FLSelect.slug = 'fl_select';
/* harmony default export */ __webpack_exports__["a"] = (FLSelect);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tools__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tests__ = __webpack_require__(303);


var state = {};
var instances = {};
var browsers = __WEBPACK_IMPORTED_MODULE_1__utils_tests__["a" /* browserTests */]();
/**
 * @function fitVideoToContainer
 * @description Background size cover implementation for any el, applied to the video
 */

var fitVideoToContainer = function fitVideoToContainer(id) {
  var container = __WEBPACK_IMPORTED_MODULE_0__utils_tools__["b" /* getNodes */]("#".concat(id), false, document, true)[0];

  if (!container) {
    return;
  }

  var template = __WEBPACK_IMPORTED_MODULE_0__utils_tools__["b" /* getNodes */]("[data-id=\"".concat(id, "\"]"), false, document, true)[0];
  var video = __WEBPACK_IMPORTED_MODULE_0__utils_tools__["b" /* getNodes */]('video', false, container, true)[0];
  var w = parseInt(template.dataset.width, 10);
  var h = parseInt(template.dataset.height, 10);
  var dH = container.offsetHeight;
  var dW = container.offsetWidth;
  var sW = dH / h * w;
  sW = sW >= dW ? sW : dW;
  var sH = dH;

  if (sW === dW) {
    sH = dW / w * h;
  }

  var left = sW === dW ? 0 : -(Math.abs(sW - dW) / 2);
  video.style.width = "".concat(sW, "px");
  video.style.height = "".concat(sH, "px");
  video.style.left = "".concat(left, "px");
};
/**
 * @function resizeBGVideo
 * @description resize the bg vids
 */


var resizeBGVideo = function resizeBGVideo(video) {
  return fitVideoToContainer(video.dataset.id);
};
/**
 * @function revealVideo
 * @description Crossfade video with video poster
 */


var revealVideo = function revealVideo(id) {
  var container = __WEBPACK_IMPORTED_MODULE_0__utils_tools__["b" /* getNodes */]("#".concat(id), false, document, true)[0];
  var wrapper = __WEBPACK_IMPORTED_MODULE_0__utils_tools__["a" /* closest */](container, '.et_pb_section_video_bg_brightcove');
  wrapper.classList.remove('loading');
};

var videoIsPlaying = function videoIsPlaying(video) {
  return !(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
};
/**
 * @function playVideo
 * @description After the supplied bc script has loaded, kickoff the init to get the video looping and reveal the
 * player
 */


var playVideo = function playVideo(videoId) {
  instances[videoId] = window.videojs(videoId, {});
  instances[videoId].on('loadedmetadata', function () {
    fitVideoToContainer(videoId);
    revealVideo(videoId);
  });

  if (!videoIsPlaying(instances[videoId])) {
    instances[videoId].play();
  }
};
/**
 * @function initVideo
 * @description Inject the script tag for a bc video and grab its custom script to inject
 */


var initVideo = function initVideo(video) {
  var script = document.createElement('script');
  video.insertAdjacentHTML('afterend', video.innerHTML);
  script.src = video.dataset.src;
  document.body.appendChild(script);
  state.currentPlayerID = video.dataset.id;

  script.onload = function () {
    playVideo(video.dataset.id);
  };
};
/**
 * @function findBGVideos
 * @description
 */


var findBGVideos = function findBGVideos() {
  return __WEBPACK_IMPORTED_MODULE_0__utils_tools__["b" /* getNodes */]('bc-bg-video', true).forEach(function (video) {
    return initVideo(video);
  });
};
/**
 * @function findBGVideos
 * @description
 */


var resizeBGVideos = function resizeBGVideos() {
  return __WEBPACK_IMPORTED_MODULE_0__utils_tools__["b" /* getNodes */]('bc-bg-video', true).forEach(function (video) {
    return resizeBGVideo(video);
  });
};
/**
 * @function executeResize
 * @description
 */


var executeResize = function executeResize() {
  resizeBGVideos();
};

var bindEvents = function bindEvents() {
  document.addEventListener('modern_tribe/resize_executed', executeResize);
};
/**
 * @function init
 * @description Kick off this modules functions. Do not load for mobiles
 */


var init = function init() {
  if (browsers.iosMobile || browsers.android) {
    return;
  }

  findBGVideos();
  bindEvents();
};

/* harmony default export */ __webpack_exports__["a"] = (init);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isJson */
/* unused harmony export canLocalStore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return browserTests; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__);


/**
 * @module
 * @description Some handy test for common issues.
 */
var isJson = function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};

var canLocalStore = function canLocalStore() {
  var mod;
  var result = false;

  try {
    mod = new Date();
    localStorage.setItem(mod, mod.toString());
    result = localStorage.getItem(mod) === mod.toString();
    localStorage.removeItem(mod);
    return result;
  } catch (_error) {
    console.error('This browser doesn\'t support local storage or is not allowing writing to it.');
    return result;
  }
};

var android = /(android)/i.test(navigator.userAgent);
var chrome = !!window.chrome;
var firefox = typeof InstallTrigger !== 'undefined';
var ie =
/* @cc_on!@ */
false || document.documentMode;
var edge = !ie && !!window.StyleMedia;
var ios = !!navigator.userAgent.match(/(iPod|iPhone|iPad)/i);
var iosMobile = !!navigator.userAgent.match(/(iPod|iPhone)/i);
var opera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
var safari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || !chrome && !opera && window.webkitAudioContext !== 'undefined'; // eslint-disable-line

var os = navigator.platform;

var browserTests = function browserTests() {
  return {
    android: android,
    chrome: chrome,
    edge: edge,
    firefox: firefox,
    ie: ie,
    ios: ios,
    iosMobile: iosMobile,
    opera: opera,
    safari: safari,
    os: os
  };
};



/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(53);
var defined = __webpack_require__(41);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(95);
__webpack_require__(12)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(9);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);


var bindEvents = function bindEvents() {
  $(document).ready(function () {
    // This block of code helps to understand if the last event was caused by keyboard
    var KEYCODE_TAB = 9;
    var KEYCODE_ESC = 27;
    var lastKeyCode = null;
    var isShiftUsed = null;
    $(document).on('click', '*', function () {
      lastKeyCode = null;
      isShiftUsed = null;
    });
    $(document).on('keydown', '*', function (e) {
      lastKeyCode = e.keyCode;
      isShiftUsed = e.shiftKey;
    });
    $(document).on('keyup', '*', function (e) {
      lastKeyCode = e.keyCode;
      isShiftUsed = e.shiftKey;
    });
    $('.menu-item-has-children a').on('blur', function (e) {
      var $parent = $(this).parent();
      var $activeElement = $(e.relatedTarget);

      if ($parent.not('.menu-item-has-children').is(':last-child') && !(isShiftUsed && lastKeyCode === KEYCODE_TAB)) {
        var nextMenuItem = $(this).parents('.menu-item-has-children').first().next('li.menu-item');
        $(this).parents('.menu-item-has-children').children('.da11y-submenu').attr('aria-expanded', 'false').trigger('mouseleave').siblings('.sub-menu').removeClass('da11y-submenu-show'); // Focus on the next menu item if it exists and the last pressed key was not ESC

        if (nextMenuItem && lastKeyCode !== KEYCODE_ESC) {
          nextMenuItem.trigger('mouseenter');
        }
      }

      if ($parent.hasClass('menu-item-has-children') && $parent.hasClass('et-show-dropdown') && !$.contains($parent[0], $activeElement[0])) {
        $parent.removeClass('et-show-dropdown et-hover').find('.sub-menu.da11y-submenu-show').removeClass('da11y-submenu-show');
      }
    });
  }); // We need to reset the mouseleave event with default delay

  $(window).on('load', function () {
    var ET_MENUS = $('ul.nav, ul.menu');
    ET_MENUS.each(function () {
      var $etMenu = $(this); // don't attach event handlers several times to the same menu

      $etMenu.find('li').off('mouseleave').on('mouseleave', function () {
        window.et_pb_toggle_nav_menu($(this), 'close');
      });
    });
  });
};
/**
 * @function init
 * @description Initializes modules.
 */


var init = function init() {
  bindEvents();
};

/* harmony default export */ __webpack_exports__["a"] = (init);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(26);
var IObject = __webpack_require__(78);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(19);
var asc = __webpack_require__(309);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(310);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var isArray = __webpack_require__(120);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split__);

var moduleList = ['.et_overlay', '.et_pb_button', '.et_pb_custom_button_icon', '.et_pb_more_button', '.et_pb_extra_overlay', '.et-pb-icon', '.et_pb_shop', '.et_pb_dmb_breadcrumbs li[data-icon]', '.et_pb_dmb_breadcrumbs a[data-icon]', '.dwd-slider-fullscreen button.slick-arrow', '.single_add_to_cart_button', '.dsm_icon_list_icon', '.dnxt-blurb-icon > span'];
var targetClasses = moduleList.join();

var initLoad = function initLoad() {
  setTimeout(function () {
    processIconsDFA();
  }, 100);
};
/**
 * Parse icon data and display icons on the front end.
 *
 * @since    1.4.0
 */


function processIconsDFA() {
  var module;
  var targetElement;
  var iconData;
  var iconModules = $(targetClasses); // Loop through modules and work with icon data.

  for (var i = 0; i < iconModules.length; i++) {
    module = iconModules[i];
    targetElement = $(module); // If the module isn't found, skip this iteration.

    if (targetElement.length) {
      // If the module has a 'data-icon' attribute set, we'll use it.
      if (targetElement.data('icon') !== undefined) {
        iconData = targetElement.attr('data-icon');
        iconData = iconData.split('~|');

        if (iconData.length >= 2) {
          targetElement.attr('data-icon', iconData[0]);
        } // Otherwise the icon information is in the html.

      } else {
        iconData = targetElement.html();
        iconData = iconData.split('~|');

        if (iconData.length >= 2) {
          targetElement.html(iconData[0]);
        }
      }

      targetElement.attr('data-family', iconData[2]);
      targetElement.removeClass('divi_font_awesome_icon divi_font_awesome_icon--elegant-themes divi_font_awesome_icon--font-awesome divi_font_awesome_icon--undefined');
      targetElement.addClass("divi_font_awesome_icon divi_font_awesome_icon--".concat(iconData[2]));

      if (targetElement.is('[data-family]')) {
        var thisFAM = targetElement.attr('data-family');

        if (!targetElement.hasClass("divi_font_awesome_icon--".concat(thisFAM))) {
          targetElement.addClass("divi_font_awesome_icon--".concat(thisFAM));
        }
      }
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (initLoad);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessible_submit_button__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contact_form_appends__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__send_test_form__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contact_forms_lazy_load__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ai_enhanced_form__ = __webpack_require__(332);





/**
 * @function init
 * @description Kick off this modules functions
 */

var init = function init() {
  if (window.siteFeatureToggles && parseInt(siteFeatureToggles.ENABLE_AI_ENHANCED_FORM, 10)) {
    Object(__WEBPACK_IMPORTED_MODULE_4__ai_enhanced_form__["a" /* default */])();
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__accessible_submit_button__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_1__contact_form_appends__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_2__send_test_form__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_3__contact_forms_lazy_load__["a" /* default */])();
};

/* harmony default export */ __webpack_exports__["a"] = (init);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessibility_focus_get_next_focusable__ = __webpack_require__(144);


var $ = jQuery;

var accessibleFormSubmitController = function accessibleFormSubmitController() {
  if (typeof Marionette !== 'undefined' && typeof nfForms !== 'undefined') {
    var formSubmitController = Marionette.Object.extend({
      initialize: function initialize() {
        this.listenTo(Backbone.Radio.channel('submit'), 'render:view', this.handleSubmit);
      },
      handleSubmit: function handleSubmit(model) {
        if (typeof model !== 'undefined') {
          var wrapper = $(model.el);
          var button = wrapper.find('.nf-field-element input');
          button.prop('disabled', false);
        }
      }
    });
    return new formSubmitController();
  }

  return null;
};
/**
 * @function init
 * @description Kick off this modules functions. Do not load for mobiles
 */


var init = function init() {
  $(document).on('nfFormReady', function (e, model) {
    accessibleFormSubmitController(model);
    document.addEventListener('nf-form-loaded-in-popup', accessibleFormSubmitController);
  });
  $(document).on('blur', '.ninja-forms-field', function (e) {
    setTimeout(function () {
      if (document.activeElement === document.body && e.relatedTarget !== document.body) {
        var nextFocusable = Object(__WEBPACK_IMPORTED_MODULE_1__accessibility_focus_get_next_focusable__["a" /* default */])(e.currentTarget);

        if (nextFocusable) {
          nextFocusable.focus();
        }
      }
    }, 50);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (init);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var $ = jQuery;

var init = function init() {
  $(document).on('nfFormReady', function () {
    nfRadio.channel('forms').on('before:submit', function (e) {
      var extra = e.get('extra');

      if (window.FL && window.FL.contactFormAppends) {
        if (window.FL.contactFormAppends.adobeTransactionId) {
          extra.adobeTransactionId = window.FL.contactFormAppends.adobeTransactionId;
        }

        if (window.FL.contactFormAppends.adobeVisitorId) {
          extra.adobeVisitorId = window.FL.contactFormAppends.adobeVisitorId;
        }

        if (window.FL.contactFormAppends.adobeReportSuites) {
          extra.adobeReportSuites = window.FL.contactFormAppends.adobeReportSuites;
        }
      }

      e.set('extra', extra);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (init);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);


var setStfEnabled = function setStfEnabled(stfData, stfBar, stfTitle, toggleText, enabled) {
  stfBar.toggleClass('stf-enabled', enabled);

  if (enabled) {
    stfTitle.text(stfData.stfEnabledText);
    toggleText.text(stfData.disableText);
  } else {
    stfTitle.text(stfData.stfDisabledText);
    toggleText.text(stfData.enableText);
  }
};

var init = function init() {
  if (typeof window.stfData === 'undefined') {
    return;
  }
  /* stfData object is defined on the page. */


  var stfData = window.stfData;
  var stfBar = jQuery('#wp-admin-bar-stf');
  var stfTitle = stfBar.find('.ab-item').first();
  var toggle = stfBar.find('#wp-admin-bar-stf-toggle').first();
  var toggleText = toggle.find('.ab-item').first();
  var inProgressClass = 'stf-in-progress';
  /* Set sending ajax query on click on the toggle. */

  toggle.on('click', function () {
    if (stfBar.hasClass(inProgressClass)) {
      return;
    }

    var enableAction = !stfBar.hasClass('stf-enabled');
    stfBar.addClass(inProgressClass);
    jQuery.ajax({
      url: stfData.ajaxurl,
      type: 'POST',
      data: {
        action: 'stf_toggle',
        enable: enableAction,
        _ajax_nonce: stfData.nonce
      }
    }).done(function (response) {
      setStfEnabled(stfData, stfBar, stfTitle, toggleText, response.data.enabled);
      stfBar.removeClass(inProgressClass);
    });
  });
  /* Reflect new STF status in admin bar after the submission's response. */

  jQuery(document).on('nfFormSubmitResponse', function () {
    setStfEnabled(stfData, stfBar, stfTitle, toggleText, false);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (init);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_resource_loader__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tools__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contact_forms_lazy_load_nf_tp__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contact_forms_lazy_load_email_me__ = __webpack_require__(331);



/**
 * This library used to lazy load ninja forms.
 *
 * The form content loaded by Ajax, dependencies needed to render the form composed in a way
 * to support a load of multiple forms on the page
 */





var evalExtraScriptData = function evalExtraScriptData(script, redirectId, postId) {
  if (script.extra && script.extra.data) {
    // Indirect eval works in the global scope rather than the local scope
    // eslint-disable-next-line no-eval
    var geval = eval;
    var nfForms = null;
    var nfMPSettings = null;
    geval(script.extra.data);

    if (nfForms) {
      window.nfForms = window.nfForms.concat(nfForms);
    }

    if (redirectId) {
      window.nfForms[window.nfForms.length - 1].extra = {
        redirect_id: redirectId
      };
    }

    if (postId) {
      window.nfForms[window.nfForms.length - 1].extra = {
        post_id: postId
      };
    }

    window.nfFrontEnd = window.nfFrontEnd || nfFrontEnd; // needed to support multi-part forms

    window.nfMPSettings = window.nfMPSettings || nfMPSettings;
  }
};

var allFormModules = function allFormModules() {
  return $('.nf_tp_module, .et_pb_email_attorney');
};
/**
 * Get settled promises
 * TODO remove the es6-promise and replace this method with Promise.getSettled
 */


var getSettled = function getSettled(promises) {
  return promises.map(function (p) {
    return p.then(function (element) {
      element.status = 'fulfilled';
      return element;
    }).catch(function (error) {
      error.status = 'rejected';
      return error;
    });
  });
};
/**
 * NF_TP and Email_Me forms lazy loading
 */


var loadAllForms = function loadAllForms() {
  // There is a chance that this function will be called twice, for example: ninja form is in viewport
  // and scroll event triggered in the same time
  // So, preventing the script from running POST queries twice
  if (loadAllForms.loaded) {
    return;
  }

  loadAllForms.loaded = true;
  var resourceLoader = new __WEBPACK_IMPORTED_MODULE_2__utils_resource_loader__["a" /* ResourceLoader */]();
  var loadPromises = [];
  allFormModules().each(function () {
    var element = $(this);
    var formLoader = element.hasClass('nf_tp_module') ? Object(__WEBPACK_IMPORTED_MODULE_4__contact_forms_lazy_load_nf_tp__["a" /* NFTPFormLoader */])(element) : Object(__WEBPACK_IMPORTED_MODULE_5__contact_forms_lazy_load_email_me__["a" /* emailMeFormLoader */])(element);
    loadPromises.push(formLoader);
  });
  Promise.all(getSettled(loadPromises)).then(function (formsData) {
    var nfLibraryScript = null;
    formsData.forEach(function (formData) {
      if (formData.status === 'rejected') {
        return;
      }

      if (formData.element.hasClass('nf_tp_module')) {
        Object(__WEBPACK_IMPORTED_MODULE_4__contact_forms_lazy_load_nf_tp__["b" /* NFTPFormProcessor */])(formData);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_5__contact_forms_lazy_load_email_me__["b" /* emailMeFormProcessor */])(formData);
      } // since the last item is always the ninja-form
      // and there is a chance that we have two or more forms on a page
      // we need to load libraries needed by these forms BEFORE we load the main ninja-form file
      // so extracting this script from scripts of actual response
      // In the same time we should also remember about extra variables stored in this dependency


      nfLibraryScript = formData.response.scripts.pop();
      evalExtraScriptData(nfLibraryScript, formData.element.data('redirect_id'), formData.element.data('post_id'));
      nfLibraryScript.extra = null;
      formData.response.styles.forEach(function (stylesheet) {
        return resourceLoader.insertStylesheet(stylesheet.src);
      });
    });
    formsData.forEach(function (formData) {
      if (formData.status === 'rejected') {
        return;
      }

      formData.response.scripts.forEach(function (script) {
        evalExtraScriptData(script);
        resourceLoader.scheduleScript(script.src);
      });
    });
    resourceLoader.scheduleScript(nfLibraryScript.src);
    resourceLoader.loadScripts(function () {
      // We need to call resize after the form is rendered
      // to recalculate the parallax bg properties
      $(window).resize();
      document.dispatchEvent(new CustomEvent('all-nf-forms-loaded'));
    });
  }).catch(function (e) {
    return console.log(e);
  });
};

var registerChangeFocusEvent = function registerChangeFocusEvent() {
  $(document).on('nfFormReady', function (e, layout) {
    var layoutId = $(layout.$el[0]);
    var currentNFModule = $(layoutId).parent();
    var preloader = null;
    var formContainer = null;
    var removePreloader = true;

    if (currentNFModule.hasClass('nf_tp_module')) {
      // Check preloader for NF TP form
      preloader = currentNFModule.prev('span[id^=nf_tp_preloader_nf_tp_module_]');
      formContainer = currentNFModule;
    } else {
      // Check preloader for Email Me form
      preloader = $('span[id=email_me_preloader]');
      formContainer = $('#email_attorney_content');
    } //Check whether preloading text having keyboard focus


    if ($(preloader).is(':focus')) {
      var firstInput = $(formContainer).find('.nf-form-layout form input').first();

      if ($(firstInput).length === 0) {
        removePreloader = false;
      } else {
        $(firstInput).focus();
      }
    }

    if (removePreloader) {
      $(preloader).remove();

      if (document.getElementsByClassName('ENABLE_EMAIL_ME_CONTACT_FORM_POP_UP_FIX').length !== 0) {
        if (formContainer[0].id === 'email_attorney_content') {
          Object(__WEBPACK_IMPORTED_MODULE_5__contact_forms_lazy_load_email_me__["d" /* registerKeyBoardFocusHandler */])();
        }
      }
    }
  });
};

var allFormsFieldsUpdate = function allFormsFieldsUpdate() {
  $(document).on('nfFormReady', function () {
    //added aria hidden for * symbol
    $('.ninja-forms-req-symbol').each(function () {
      $(this).attr('aria-hidden', true);
    }); //Handling the aria-invalid attribute according to the mandatory fields

    $('.nf-field-element input, .nf-field-element select, .nf-field-element textarea').each(function () {
      if (!$(this).prop('required')) {
        $(this).removeAttr('aria-invalid');
        $(this).removeAttr('aria-describedby');
      } else {
        $(this).attr('aria-invalid', false);
      }

      $(this).removeAttr('aria-labelledby');
    }); //Append the aria-label for privacy policy

    $('.nf-field-element .form-links a').each(function () {
      var linkInaTag = $(this).attr('href');

      if (linkInaTag.indexOf('privacy') !== -1) {
        $(this).attr('aria-label', 'Privacy Policy (opens in a new tab)');
      }
    }); //Append the aria-label for radio group

    $('.listradio-wrap ul').each(function () {
      $(this).attr('role', 'radiogroup');
      $(this).find('li label').css('display', 'inline-block');
    }); //radio button attribute changes

    $('.listradio-wrap ul li input').each(function () {
      $(this).removeAttr('tabindex');
    }); //Remove autocomplete attribute

    $('.nf-field-element textarea').each(function () {
      $(this).removeAttr('autocomplete');
    });
  });
}; //Apply autocomplete attribute according to the value


var FormsFieldsAutocompleteUpdate = function FormsFieldsAutocompleteUpdate(selector, labelFieldName, attributeValue) {
  var index = 1;
  $(selector).each(function () {
    var currentLabelText = $(this).text().trim().toLowerCase();

    if (currentLabelText.indexOf(labelFieldName) !== -1) {
      var currentFieldText = $(this).closest('.nf-field-label').next('.nf-field-element').children('input');
      var autocompleteValue = labelFieldName === 'address' ? "".concat(attributeValue).concat(index) : attributeValue;
      index++;
      currentFieldText.attr('autocomplete', autocompleteValue);
    }
  });
};

var FormsFieldsScreenReaderFixes = function FormsFieldsScreenReaderFixes() {
  //Code for resolve Screen reader problem
  $('.listcheckbox-wrap .nf-field-label span').each(function () {
    var currentLabelId = $(this).attr('id');
    var checkboxMainDiv = $(this).closest('.nf-field-label').next('.nf-field-element');

    if (checkboxMainDiv.length) {
      checkboxMainDiv.attr('role', 'group');
      checkboxMainDiv.attr('aria-labelledby', currentLabelId);
      checkboxMainDiv.find('ul li input').attr('style', 'width: 1px !important');
      checkboxMainDiv.find('ul li label').css('display', 'inline-block');
    }
  });
};

var allFormsFieldsUpdateAutocomplete = function allFormsFieldsUpdateAutocomplete() {
  $(document).on('nfFormReady', function () {
    FormsFieldsAutocompleteUpdate('.nf-field-label label', 'address', 'address-line');
    FormsFieldsAutocompleteUpdate('.nf-field-label label', 'company', 'organization');
    FormsFieldsScreenReaderFixes();
  });
};

var appendPreloader = function appendPreloader(nfFormContainer) {
  var preloaderElement = $('<span tabindex="0" class="nf_preloader">Loading Form...</span>');

  if ($(nfFormContainer).hasClass('nf_tp_module')) {
    // Preloading text for every NF TP forms
    var NFTPModuleId = $(nfFormContainer).attr('id');
    var preloaderId = "nf_tp_preloader_".concat(NFTPModuleId);
    preloaderElement.attr('id', preloaderId);
    $(nfFormContainer).before(preloaderElement);
    return;
  }

  if ($(nfFormContainer).hasClass('et_pb_email_attorney')) {
    // Preloading text for Email Me forms
    // It's not necessary to specify Email Me form ID since there is only one div container for Email Me forms loading
    var _preloaderId = 'email_me_preloader';
    preloaderElement.attr('id', _preloaderId);

    if ($("#".concat(_preloaderId)).length === 0) {
      $('#email_attorney_content').prepend(preloaderElement);
    }
  }
};

var initAllForms = function initAllForms() {
  var inViewPortHandlers = [];
  loadAllForms.loaded = false;
  Object(__WEBPACK_IMPORTED_MODULE_5__contact_forms_lazy_load_email_me__["c" /* maybeInitEmailMePopup */])();
  allFormModules().each(function () {
    var _this = this;

    var showIfInViewPort = function showIfInViewPort() {
      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_tools__["d" /* isMaybeCloseToView */])(_this, 2000) || Object(__WEBPACK_IMPORTED_MODULE_3__utils_tools__["c" /* isInViewport */])(_this)) {
        inViewPortHandlers.forEach(function (handler) {
          return document.removeEventListener('scroll', handler);
        });
        loadAllForms();
      }
    };

    inViewPortHandlers.push(showIfInViewPort);
    appendPreloader(this);
  });
  inViewPortHandlers.forEach(function (handler) {
    document.addEventListener('scroll', handler);
    handler();
  });
  registerChangeFocusEvent();

  if (coreAccessibility.enable_nf_fields_update_a11y) {
    allFormsFieldsUpdate();
  }

  if (coreAccessibility.enable_nf_fields_update_autocomplete_a11y) {
    allFormsFieldsUpdateAutocomplete();
  }
};

var init = function init() {
  /**
   * nfForms it is a global variable that used by ninja-forms. This array contains all forms needed on the page.
   */
  if (typeof window.nfForms === 'undefined') {
    window.nfForms = [];
  }

  if (typeof window.flNfFormsLoaded === 'undefined') {
    window.flNfFormsLoaded = {};
  }

  $(document).ready(function () {
    initAllForms();
  });
};

/* harmony default export */ __webpack_exports__["a"] = (init);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(26);
var call = __webpack_require__(145);
var isArrayIter = __webpack_require__(146);
var anObject = __webpack_require__(9);
var toLength = __webpack_require__(19);
var getIterFn = __webpack_require__(147);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var macrotask = __webpack_require__(148).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(31)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);
var newPromiseCapability = __webpack_require__(149);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(29);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var dP = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(16);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResourceLoader; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ResourceLoader =
/*#__PURE__*/
function () {
  function ResourceLoader() {
    _classCallCheck(this, ResourceLoader);

    this.scriptsQueue = [];
    this.alreadyLoadedResources = [];
    this.forceLoadedResources = [];
  }

  _createClass(ResourceLoader, [{
    key: "setForceLoadedResources",
    value: function setForceLoadedResources() {
      var forceLoadedResources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.forceLoadedResources = forceLoadedResources;
    }
  }, {
    key: "loadScripts",
    value: function loadScripts(cb) {
      var _this = this;

      if (this.scriptsQueue.length === 0) {
        if (cb) {
          cb();
        }

        return;
      }

      var script = document.createElement('script');
      script.setAttribute('src', this.scriptsQueue.shift());
      script.addEventListener('load', function () {
        _this.loadScripts(cb);
      });
      document.body.appendChild(script);
    }
  }, {
    key: "scheduleScript",
    value: function scheduleScript(src) {
      if (!src || this.alreadyLoadedResources.indexOf(src) >= 0 && this.forceLoadedResources.indexOf(src) === -1) {
        return;
      }

      this.alreadyLoadedResources.push(src);
      this.scriptsQueue.push(src);
    }
  }, {
    key: "insertStylesheet",
    value: function insertStylesheet(stylesheet) {
      var link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('type', 'text/css');
      link.setAttribute('media', 'all');
      link.setAttribute('href', stylesheet);

      if (this.alreadyLoadedResources.indexOf(stylesheet) >= 0) {
        return;
      }

      this.alreadyLoadedResources.push(stylesheet);
      document.body.appendChild(link);
    }
  }]);

  return ResourceLoader;
}();

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NFTPFormLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NFTPFormProcessor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(151);


var NFTPFormLoader = function NFTPFormLoader(element) {
  if ($('.ENABLE_CACHE_LAZY_FORMS').length > 0) {
    return new Promise(function (resolve, reject) {
      var formId = element.data('form_id');

      if (!formId) {
        reject(new Error('FormID is not defined'));
        return;
      }

      try {
        var formKey = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* getFormKey */])(formId);
        var redirectId = element.data('redirect_id') || 0; // Set the form subId to carry form duplications

        if (!Object.prototype.hasOwnProperty.call(window.flNfFormsLoaded, formKey)) {
          window.flNfFormsLoaded[formKey] = {
            counter: 0
          };
        } else {
          window.flNfFormsLoaded[formKey].counter += 1;
        }

        Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getForm */])(formId, window.flNfFormsLoaded[formKey].counter, {
          redirect_id: redirectId
        }).then(function (response) {
          return resolve({
            element: element,
            response: response
          });
        });
      } catch (error) {
        reject(error);
      }
    });
  } // Remove after AB#245834 in prod


  return new Promise(function (resolve, reject) {
    var formId = element.data('form_id');

    if (!formId) {
      reject(new Error('FormID is not defined'));
    }

    var formKey = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* getFormKey */])(formId);
    var redirectId = element.data('redirect_id') || 0; // Set the form subId to carry form duplications

    if (!Object.prototype.hasOwnProperty.call(window.flNfFormsLoaded, formKey)) {
      window.flNfFormsLoaded[formKey] = {
        counter: 0
      };
    } else {
      window.flNfFormsLoaded[formKey].counter += 1;
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getForm */])(formId, window.flNfFormsLoaded[formKey].counter, {
      redirect_id: redirectId
    }).then(function (response) {
      return resolve({
        element: element,
        response: response
      });
    });
  });
};
var NFTPFormProcessor = function NFTPFormProcessor(formData) {
  var container = $('body');
  formData.element.html(formData.response.form);
  var span = $('<span id="nf_tp_templates_container" />').css('visibility', 'hidden');
  span.html(formData.response.templates);
  container.append(span);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(12);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(330) });


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(16);
var getKeys = __webpack_require__(40);
var gOPS = __webpack_require__(81);
var pIE = __webpack_require__(54);
var toObject = __webpack_require__(32);
var IObject = __webpack_require__(78);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(25)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailMeFormLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emailMeFormProcessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return registerKeyBoardFocusHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return maybeInitEmailMePopup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accessibility_focus_connector__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__accessibility_focus_get_all_focusables__ = __webpack_require__(96);





var focusableDiv = null;
var focusableElements = null;
var firstFocusableElement = null;
var lastFocusableElement = null;
var keyBoardAccessHandler = null;
var emailMeFormLoader = function emailMeFormLoader(element) {
  if ($('.ENABLE_CACHE_LAZY_FORMS').length > 0) {
    return new Promise(function (resolve, reject) {
      var formId = element.data('form_id');

      if (!formId) {
        reject(new Error('FormID is not defined'));
        return;
      }

      var postId = element.data('post_id') ? element.data('post_id') : et_pb_custom.page_id;

      try {
        var formKey = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* getFormKey */])(formId);

        if (!Object.prototype.hasOwnProperty.call(window.flNfFormsLoaded, formKey)) {
          window.flNfFormsLoaded[formKey] = {
            counter: 0,
            email_me_loaded: true
          };
        } else if (!window.flNfFormsLoaded[formKey].email_me_loaded) {
          window.flNfFormsLoaded[formKey].counter += 1;
          window.flNfFormsLoaded[formKey].email_me_loaded = true;
        }

        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* getForm */])(formId, window.flNfFormsLoaded[formKey].counter, {
          post_id: postId
        }).then(function (response) {
          return resolve({
            element: element,
            response: response
          });
        });
      } catch (error) {
        reject(error);
      }
    });
  } // Remove after AB#245834 in prod


  return new Promise(function (resolve) {
    var formId = element.data('form_id');
    var postId = element.data('post_id') ? element.data('post_id') : et_pb_custom.page_id;
    var formKey = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* getFormKey */])(formId);

    if (!Object.prototype.hasOwnProperty.call(window.flNfFormsLoaded, formKey)) {
      window.flNfFormsLoaded[formKey] = {
        counter: 0,
        email_me_loaded: true
      };
    } else if (!window.flNfFormsLoaded[formKey].email_me_loaded) {
      window.flNfFormsLoaded[formKey].counter += 1;
      window.flNfFormsLoaded[formKey].email_me_loaded = true;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* getForm */])(formId, window.flNfFormsLoaded[formKey].counter, {
      post_id: postId
    }).then(function (response) {
      return resolve({
        element: element,
        response: response
      });
    });
  });
};
var emailMeFormProcessor = function emailMeFormProcessor(formData) {
  var container = $('body');
  var formId = formData.element.data('form_id');
  var formContainer = $("<div id=\"email_me_".concat(formId, "_container\" />")).css('display', 'none');
  container.append(formContainer); // Add the form HTML where it needs to go.

  formContainer.html(formData.response.form); // Add template files to the page.

  var span = $('<span id="email_me_templates_container" />').css('display', 'none');
  container.append(span);
  span.html(formData.response.templates);
};
var registerKeyBoardFocusHandler = function registerKeyBoardFocusHandler() {
  focusableDiv = document.querySelector('#email_attorney');
  focusableElements = Object(__WEBPACK_IMPORTED_MODULE_4__accessibility_focus_get_all_focusables__["a" /* default */])(focusableDiv);

  if (focusableElements.length) {
    firstFocusableElement = focusableElements[0];
    lastFocusableElement = focusableElements[focusableElements.length - 1];
    keyBoardAccessHandler = new __WEBPACK_IMPORTED_MODULE_3__accessibility_focus_connector__["a" /* default */](lastFocusableElement, firstFocusableElement);
    keyBoardAccessHandler.link();
  }
};

var unregisterKeyBoardFocusHandler = function unregisterKeyBoardFocusHandler() {
  keyBoardAccessHandler.unlink();
};

var getAttorneyName = function getAttorneyName() {
  var currentJsonValues = null;
  var currentAttorneyName = null;
  document.querySelectorAll('script[type="application/ld+json"]').forEach(function (allJsonLdValues) {
    currentJsonValues = JSON.parse(allJsonLdValues.textContent);

    if (currentJsonValues['@type'] === 'ProfilePage') {
      currentAttorneyName = currentJsonValues.mainEntity.name;
    }
  });
  return currentAttorneyName;
};

var maybeInitEmailMePopup = function maybeInitEmailMePopup() {
  var emailMeSelector = $('.et_pb_email_attorney');

  if (emailMeSelector.length === 0) {
    return;
  }

  var nfFormsLoaded = false;
  var currentFormId = null;

  var HTML = function HTML() {
    return "\n\t\t  <div id=\"email_attorney\" class=\"mfp-hide white-popup-block\">\n\t\t\t<div id=\"email_attorney_content\">\n\t\t\t\t<div class=\"nf-loading-spinner\"></div>\n\t\t\t</div>\n\t\t  </div>\n\t\t";
  };

  if (document.getElementsByClassName('ENABLE_EMAIL_ME_CONTACT_FORM_POP_UP_FIX').length !== 0) {
    var attorneyName = null;
    attorneyName = getAttorneyName();

    HTML = function HTML() {
      return "\n\t\t <div role=\"dialog\" id=\"email_attorney\" aria-label=\"Email ".concat(attorneyName, "\" aria-modal=\"true\" class=\"mfp-hide white-popup-block\">\t\t\t \n\t\t\t<h2 id=\"email_me_modal_heading\">Contact Form</h2>\t\t\t  \t\t    \n\t\t\t<div id=\"email_attorney_content\">\n\t\t\t\t<div class=\"nf-loading-spinner\"></div>\n\t\t\t</div>\n\t\t </div>\n\t\t");
    };
  } // Find container for HTML


  var container = null;

  if ($('body').length) {
    container = $('body');
  } else if ($('footer').length) {
    container = $('footer');
  } else if ($('#main-content').length) {
    container = $('#main-content');
  } else if ($('#page-container').length) {
    container = $('#page-container');
  }

  if (!container) {
    console.error('A container for an Email Me form is not found');
    return;
  }

  container.after(HTML);

  var showForm = function showForm() {
    nfFormsLoaded = true; // Remove preloader

    $('#email_attorney_content div[class="nf-loading-spinner"]').remove(); // Move the form to popup

    $("#email_me_".concat(currentFormId, "_container")).contents().appendTo('#email_attorney_content'); // Create a custom event to handle the form submit button behavior

    document.dispatchEvent(new CustomEvent('nf-form-loaded-in-popup'));
    document.removeEventListener('all-nf-forms-loaded', showForm);
  };

  var hideForm = function hideForm(formId) {
    if (document.getElementsByClassName('ENABLE_EMAIL_ME_CONTACT_FORM_POP_UP_FIX').length !== 0) {
      unregisterKeyBoardFocusHandler();
    } // Move the form from popup


    $('#email_attorney_content').contents().appendTo("#email_me_".concat(formId, "_container"));
  };

  emailMeSelector.magnificPopup({
    type: 'inline',
    preloader: true,
    showCloseBtn: true,
    closeBtnInside: true,
    callbacks: {
      open: function open() {
        currentFormId = $(this.currItem.el[0]).data('form_id');

        if (nfFormsLoaded) {
          showForm(currentFormId);

          if (document.getElementsByClassName('ENABLE_EMAIL_ME_CONTACT_FORM_POP_UP_FIX').length !== 0) {
            registerKeyBoardFocusHandler();
          }
        } else {
          document.addEventListener('all-nf-forms-loaded', showForm);
        }
      },
      close: function close() {
        if (nfFormsLoaded) {
          hideForm(currentFormId);
        }
      }
    }
  });
  $(document).on('click', '.popup-modal-dismiss', function (e) {
    e.preventDefault();

    if (document.getElementsByClassName('ENABLE_EMAIL_ME_CONTACT_FORM_POP_UP_FIX').length !== 0) {
      unregisterKeyBoardFocusHandler();
    }

    $.magnificPopup.close();
  });
  document.addEventListener('all-nf-forms-loaded', function () {
    nfFormsLoaded = true;
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_adobe_events__ = __webpack_require__(378);




function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }



var $ = jQuery;

var log = function log(message) {
  window.console.log("Business logic of AI Enhanced forms: ".concat(message));
};
/**
 *
 * Adds AI related fields to the form, see: https://dev.azure.com/tr-legal-tech/FindLaw/_workitems/edit/412294
 *
 * This script overloads the standard behavior of registering Ninja-Forms via `nfForms.push` call
 *
 * It also adds the conditions that control the UI of the form fields.
 *
 * The AI-related fields got injected into the form layout, before the disclaimer checkbox.
 *
 * @function init
 */


/* harmony default export */ __webpack_exports__["a"] = (function () {
  if ($('.ENABLE_AI_ENHANCED_FORM').length === 0) {
    return;
  }

  window.nfForms = window.nfForms || [];
  Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["k" /* nfFormsPushInterceptor */])(function (form) {
    log('start');

    if (window.siteFeatureToggles.ENABLE_AI_ENHANCED_FORM !== '1') {
      log('site level feature toggle is disabled, skipping AI enhancements');
      return form;
    }

    var formPrefixId = Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["j" /* getFormPrefixId */])(form.id);
    var enhancedForm = form;
    var messageKey = Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["h" /* findMessageKey */])(enhancedForm.fields); // skip the form if the message field is not found

    if (messageKey === false) {
      return enhancedForm;
    }

    if ($('.ENABLE_EDITABLE_LAYOUT_OF_AI_FORMS').length === 0) {
      // Inject the new fields into the form layout, before the disclaimer checkbox
      enhancedForm = Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["c" /* buildFormLayout */])(formPrefixId, enhancedForm); // Add the conditions that controls the UI of the form fields

      enhancedForm.settings.conditions = _toConsumableArray(enhancedForm.settings.conditions || []).concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["b" /* buildFormConditions */])(formPrefixId, Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["g" /* findDisclaimerKey */])(enhancedForm.fields), Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["f" /* findDisclaimerHtml */])(enhancedForm.fields).key, Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["i" /* findSubmitButtonKey */])(enhancedForm.fields)))); // Add the new AI-related fields to the form fields

      enhancedForm.fields = _toConsumableArray(enhancedForm.fields).concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["a" /* buildFields */])(formPrefixId)));
    } // Wait for the form to be ready


    $(document).one('nfFormReady', function () {
      var setStateHook = Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["e" /* buildSetStateHook */])(formPrefixId, form.fields);
      var adobeEvents = new __WEBPACK_IMPORTED_MODULE_4__utils_adobe_events__["a" /* AdobeEvents */]();

      try {
        var NextButtonController = Object(__WEBPACK_IMPORTED_MODULE_3__ai_enhanced_form_fields_index__["d" /* buildNextButtonControllerClass */])();
        var fields = enhancedForm.fields; // eslint-disable-next-line no-new

        new NextButtonController({
          formPrefixId: formPrefixId,
          fields: fields,
          adobeEvents: adobeEvents,
          formId: form.id
        }); // Set the state of the form to 'enabled' to trigger the conditions

        setStateHook('enabled');
        log('completed');
      } catch (error) {
        log("Error initializing Enhanced Forms: ".concat(error));
      }
    });
    log('initialized');
    return enhancedForm;
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(17);
var createDesc = __webpack_require__(37);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(90);
var step = __webpack_require__(335);
var Iterators = __webpack_require__(44);
var toIObject = __webpack_require__(30);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(336)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(39);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(29);
var hide = __webpack_require__(18);
var Iterators = __webpack_require__(44);
var $iterCreate = __webpack_require__(337);
var setToStringTag = __webpack_require__(52);
var getPrototypeOf = __webpack_require__(338);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(121);
var descriptor = __webpack_require__(37);
var setToStringTag = __webpack_require__(52);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(18)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(24);
var toObject = __webpack_require__(32);
var IE_PROTO = __webpack_require__(79)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nfFormsPushInterceptor__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buildFormLayout__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getFormPrefixId__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buildFormConditions__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buildSetStateHook__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buildFields__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__buildNextButtonController__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__source_form_locators__ = __webpack_require__(101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__buildSetStateHook__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__buildFields__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__buildFormLayout__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__buildFormConditions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__source_form_locators__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__source_form_locators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__source_form_locators__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__source_form_locators__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__nfFormsPushInterceptor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__getFormPrefixId__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__buildNextButtonController__["a"]; });










/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (callback) {
  var oldPush = window.nfForms.push;

  window.nfForms.push = function (item) {
    if (this !== window.nfForms) {
      // silently skipping
      return oldPush.call(this, item);
    } // Validate if an incoming object belongs to forms


    if (!item || !item.id || !item.settings || !item.fields) {
      window.console.log('Unable to recognize form object, skipping', item);
      return oldPush.call(this, item);
    }

    return oldPush.call(this, callback.call(this, item));
  };
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__source_form_locators__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_layout__ = __webpack_require__(370);





function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }




function findMessageFieldPosition(formContentData, messageKey) {
  if (messageKey) {
    for (var i = 0; i < formContentData.length; i++) {
      var row = formContentData[i];

      for (var j = 0; j < row.cells.length; j++) {
        var rowCells = row.cells[j];

        for (var k = 0; k < rowCells.fields.length; k++) {
          if (rowCells.fields[k] === messageKey) {
            return i;
          }
        }
      }
    }
  }

  return -1;
}

function prepareVariableNames(formPrefixId) {
  var formContentData = __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default()(__WEBPACK_IMPORTED_MODULE_5__resources_layout__["a" /* default */]);

  return formContentData.map(function (row) {
    var subId = row.subId + formPrefixId;
    row.cells[0].fields[0] = "".concat(row.cells[0].fields[0], "_").concat(subId);
    return row;
  });
}

function processPlainFormContentData(formContentData, messageKey, aiFields) {
  var messagePosition = findMessageFieldPosition(formContentData, messageKey); // Skip if the disclaimer field is not found

  if (messagePosition < 0) {
    return formContentData;
  }

  var resultFormContentData = _toConsumableArray(formContentData.slice(0, messagePosition + 1)).concat(_toConsumableArray(aiFields), _toConsumableArray(formContentData.slice(messagePosition + 1)));

  resultFormContentData.map(function (row, i) {
    row.order = i;
    return row;
  });
  return resultFormContentData;
}

/* harmony default export */ __webpack_exports__["a"] = (function (formPrefixId, form) {
  var aiFields = prepareVariableNames(formPrefixId);
  var messageKey = Object(__WEBPACK_IMPORTED_MODULE_4__source_form_locators__["d" /* findMessageKey */])(form.fields);

  if (!messageKey) {
    return form;
  } // Check if the layout contains multi-part form


  for (var i = 0; i < form.settings.formContentData.length; i++) {
    if (form.settings.formContentData[i].formContentData) {
      // Multi-part form
      form.settings.formContentData[i].formContentData = processPlainFormContentData(form.settings.formContentData[i].formContentData, messageKey, aiFields);
    } else {
      // Single part form
      form.settings.formContentData = processPlainFormContentData(form.settings.formContentData, messageKey, aiFields);
      return form;
    }
  }

  return form;
});

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(84),
    arrayEach = __webpack_require__(343),
    assignValue = __webpack_require__(68),
    baseAssign = __webpack_require__(344),
    baseAssignIn = __webpack_require__(345),
    cloneBuffer = __webpack_require__(348),
    copyArray = __webpack_require__(349),
    copySymbols = __webpack_require__(350),
    copySymbolsIn = __webpack_require__(351),
    getAllKeys = __webpack_require__(130),
    getAllKeysIn = __webpack_require__(352),
    getTag = __webpack_require__(43),
    initCloneArray = __webpack_require__(353),
    initCloneByTag = __webpack_require__(354),
    initCloneObject = __webpack_require__(359),
    isArray = __webpack_require__(3),
    isBuffer = __webpack_require__(49),
    isMap = __webpack_require__(361),
    isObject = __webpack_require__(14),
    isSet = __webpack_require__(363),
    keys = __webpack_require__(23);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(35),
    keys = __webpack_require__(23);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(35),
    keysIn = __webpack_require__(152);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14),
    isPrototype = __webpack_require__(36),
    nativeKeysIn = __webpack_require__(347);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 347 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(11);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)(module)))

/***/ }),
/* 349 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(35),
    getSymbols = __webpack_require__(88);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(35),
    getSymbolsIn = __webpack_require__(153);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(131),
    getSymbolsIn = __webpack_require__(153),
    keysIn = __webpack_require__(152);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(100),
    cloneDataView = __webpack_require__(355),
    cloneRegExp = __webpack_require__(356),
    cloneSymbol = __webpack_require__(357),
    cloneTypedArray = __webpack_require__(358);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(100);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(27);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(100);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(360),
    getPrototype = __webpack_require__(154),
    isPrototype = __webpack_require__(36);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(362),
    baseUnary = __webpack_require__(74),
    nodeUtil = __webpack_require__(75);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(43),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(364),
    baseUnary = __webpack_require__(74),
    nodeUtil = __webpack_require__(75);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(43),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findDisclaimerKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__);

function findDisclaimerKey(fields) {
  return fields.reduce(function (accumulator, item) {
    var found = item.admin_label === 'readDisclaimer' || item.key.match(/^i_have_read_the_disclaimer/);

    if (found) {
      return item.key;
    }

    return accumulator;
  }, false);
}

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findDisclaimerHtml;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__);

function findDisclaimerHtml(fields) {
  // eslint-disable-next-line object-curly-newline
  return fields.reduce(function (accumulator, _ref, currentIndex) {
    var type = _ref.type,
        value = _ref.value,
        key = _ref.key,
        id = _ref.id;
    var found = type === 'html' && (value.match(/Disclaimer/i) || key.match(/^disclaimer/));

    if (found) {
      return {
        id: id,
        key: key,
        position: currentIndex
      };
    }

    return accumulator;
  }, false);
}

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findSubmitButtonKey;
function findSubmitButtonKey(fields) {
  return fields.reduce(function (accumulator, item) {
    if (item.type === 'submit') {
      return item.key;
    }

    return accumulator;
  }, false);
}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findMessageKey;
function findMessageKey(fields) {
  // eslint-disable-next-line object-curly-newline
  return fields.reduce(function (accumulator, _ref) {
    var type = _ref.type,
        admin_label = _ref.admin_label,
        key = _ref.key;
    // eslint-disable-next-line camelcase
    var found = type === 'textarea' && admin_label === 'formComment';

    if (found) {
      // eslint-disable-next-line camelcase
      return key;
    }

    return accumulator;
  }, false);
}

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findMessageId;
function findMessageId(fields) {
  return fields.reduce(function (accumulator, _ref) {
    var type = _ref.type,
        admin_label = _ref.admin_label,
        id = _ref.id;
    // eslint-disable-next-line camelcase
    var found = type === 'textarea' && admin_label === 'formComment';

    if (found) {
      // eslint-disable-next-line camelcase
      return id;
    }

    return accumulator;
  }, false);
}

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(46);

var AI_FORM_CONTENT_DATA = [{
  order: 1,
  subId: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
  cells: [{
    order: 0,
    fields: [__WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */]],
    width: '100'
  }]
}, {
  order: 2,
  subId: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PROCESSING_LABEL_ID */],
  cells: [{
    order: 0,
    fields: [__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PROCESSING_LABEL_KEY */]],
    width: '100'
  }]
}, {
  order: 3,
  subId: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EXPLANATION_TEXT_ID */],
  cells: [{
    order: 0,
    fields: [__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EXPLANATION_TEXT_KEY */]],
    width: '100'
  }]
}, {
  order: 4,
  subId: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AI_QUESTION1_ID */],
  cells: [{
    order: 0,
    fields: [__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* AI_QUESTION1_KEY */]],
    width: '100'
  }]
}, {
  order: 5,
  subId: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* AI_QUESTION2_ID */],
  cells: [{
    order: 0,
    fields: [__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* AI_QUESTION2_KEY */]],
    width: '100'
  }]
}, {
  order: 6,
  subId: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* NEXT_BUTTON_ID */],
  cells: [{
    order: 0,
    fields: [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* NEXT_BUTTON_KEY */]],
    width: '100'
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (AI_FORM_CONTENT_DATA);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// this variable used to support multiple forms with same id on the same page
var internalCounter = 0;
/* harmony default export */ __webpack_exports__["a"] = (function (formId) {
  internalCounter++;
  return parseInt(formId, 10) * 1000 + internalCounter * 100;
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildFormConditions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_conditions__ = __webpack_require__(373);


function buildFormConditions(formPrefixId, disclaimerCheckboxKey, disclaimerHtmlKey, submitButtonKey) {
  var result = __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(__WEBPACK_IMPORTED_MODULE_1__resources_conditions__["a" /* default */]);

  var processSubIds = function processSubIds(item) {
    if (item.subId) {
      var subIdWithPrefix = item.subId + formPrefixId;
      item.key = "".concat(item.key, "_").concat(subIdWithPrefix);
    } else {
      if (item.key === '{disclaimer_html}') {
        item.key = disclaimerHtmlKey;
      }

      if (item.key === '{i_have_read_the_disclaimer}') {
        item.key = disclaimerCheckboxKey;
      }

      if (item.key === '{send}') {
        item.key = submitButtonKey;
      }
    }

    return item;
  };

  return result.map(function (item) {
    item.when.map(processSubIds);
    item.then.map(processSubIds);
    return item;
  });
}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(46);

var AI_CONDITIONS = [{
  collapsed: false,
  process: 1,
  connector: 'all',
  when: [{
    connector: 'AND',
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
    comparator: 'equal',
    value: 'disabled',
    type: 'field',
    modelType: 'when'
  }],
  then: [{
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PROCESSING_LABEL_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PROCESSING_LABEL_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EXPLANATION_TEXT_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EXPLANATION_TEXT_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* AI_QUESTION1_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AI_QUESTION1_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* AI_QUESTION2_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* AI_QUESTION2_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{disclaimer_html}',
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{i_have_read_the_disclaimer}',
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{send}',
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* NEXT_BUTTON_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* NEXT_BUTTON_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }],
  else: []
}, {
  collapsed: false,
  process: 1,
  connector: 'all',
  when: [{
    connector: 'AND',
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
    comparator: 'equal',
    value: 'enabled',
    type: 'field',
    modelType: 'when'
  }],
  then: [{
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PROCESSING_LABEL_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PROCESSING_LABEL_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EXPLANATION_TEXT_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EXPLANATION_TEXT_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* AI_QUESTION1_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AI_QUESTION1_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* AI_QUESTION2_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* AI_QUESTION2_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{disclaimer_html}',
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{i_have_read_the_disclaimer}',
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{send}',
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* NEXT_BUTTON_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* NEXT_BUTTON_ID */],
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }],
  else: []
}, {
  collapsed: false,
  process: 1,
  connector: 'all',
  when: [{
    connector: 'AND',
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
    comparator: 'equal',
    value: 'processing',
    type: 'field',
    modelType: 'when'
  }],
  then: [{
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PROCESSING_LABEL_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PROCESSING_LABEL_ID */],
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EXPLANATION_TEXT_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EXPLANATION_TEXT_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* AI_QUESTION1_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AI_QUESTION1_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* AI_QUESTION2_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* AI_QUESTION2_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{disclaimer_html}',
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{i_have_read_the_disclaimer}',
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{send}',
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* NEXT_BUTTON_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* NEXT_BUTTON_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }],
  else: []
}, {
  collapsed: false,
  process: 1,
  connector: 'all',
  when: [{
    connector: 'AND',
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
    comparator: 'equal',
    value: 'questions',
    type: 'field',
    modelType: 'when'
  }],
  then: [{
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PROCESSING_LABEL_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PROCESSING_LABEL_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EXPLANATION_TEXT_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EXPLANATION_TEXT_ID */],
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* AI_QUESTION1_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AI_QUESTION1_ID */],
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* AI_QUESTION2_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* AI_QUESTION2_ID */],
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{disclaimer_html}',
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{i_have_read_the_disclaimer}',
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{send}',
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* NEXT_BUTTON_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* NEXT_BUTTON_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }],
  else: []
}, {
  collapsed: false,
  process: 1,
  connector: 'all',
  when: [{
    connector: 'AND',
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
    comparator: 'equal',
    value: 'no_questions',
    type: 'field',
    modelType: 'when'
  }],
  then: [{
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PROCESSING_LABEL_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PROCESSING_LABEL_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EXPLANATION_TEXT_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EXPLANATION_TEXT_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* AI_QUESTION1_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AI_QUESTION1_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* AI_QUESTION2_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* AI_QUESTION2_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{disclaimer_html}',
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{i_have_read_the_disclaimer}',
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: '{send}',
    trigger: 'show_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }, {
    key: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* NEXT_BUTTON_KEY */],
    subId: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* NEXT_BUTTON_ID */],
    trigger: 'hide_field',
    value: '',
    type: 'field',
    modelType: 'then'
  }],
  else: []
}];
/* harmony default export */ __webpack_exports__["a"] = (AI_CONDITIONS);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = buildSetStateHook;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(46);


/**
 * A generator function that builds a setState hook for the given form.
 * @param formPrefixId
 * @param fields
 * @returns {(function(*): void)|*}
 */

function buildSetStateHook(formPrefixId, fields) {
  return function (state) {
    if ($('.ENABLE_EDITABLE_LAYOUT_OF_AI_FORMS').length === 1) {
      var stateField = fields.find(function (field) {
        return field.key === __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* STATE_KEY */];
      });
      nfRadio.channel('fields').request('get:field', stateField.id).set('value', state).trigger('field:change').trigger('reRender');
    } else {
      nfRadio.channel('fields').request('get:field', formPrefixId + __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* STATE_ID */]).set('value', state).trigger('field:change').trigger('reRender');
    }
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildFields; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_fields__ = __webpack_require__(376);



function buildFields(formPrefixId) {
  var fields = __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(__WEBPACK_IMPORTED_MODULE_1__resources_fields__["a" /* default */]);

  fields.map(function (field) {
    field.id += formPrefixId;
    field.key = "".concat(field.key, "_").concat(field.id);
    return field;
  });
  return fields;
}



/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(46);

var EXPLANATION_TEXT_HTML = '<div class=\"ai-enhanced-form explanation-text\"><b>These last two optional questions below will help our firm gain a clearer understanding of your case.</b><\/div>';
var AI_FIELDS = [{
  'objectType': 'Field',
  'objectDomain': 'fields',
  'editActive': false,
  'order': 5,
  'idAttribute': 'id',
  'type': 'listselect',
  'label': 'AI Enhancement Status',
  'key': __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* STATE_KEY */],
  'label_pos': 'above',
  'required': false,
  'options': [{
    errors: [],
    max_options: 0,
    label: 'Disabled',
    value: 'disabled',
    calc: '',
    selected: 0,
    order: 0,
    settingModel: {
      settings: false,
      hide_merge_tags: false,
      error: false,
      name: 'options',
      type: 'option-repeater',
      label: 'Options <a href="#" class=\nf-add-new">Add New<\/a> <a href="#" class="extra nf-open-import-tooltip"><i class="fa fa-sign-in" aria-hidden="true"><\/i> Import<\/a>',
      width: 'full',
      group: '',
      value: [{
        label: 'One',
        value: 'one',
        calc: '',
        selected: 0,
        order: 0
      }, {
        label: 'Two',
        value: 'two',
        calc: '',
        selected: 0,
        order: 1
      }, {
        label: 'Three',
        value: 'three',
        calc: '',
        selected: 0,
        order: 2
      }],
      columns: {
        label: {
          header: 'label',
          default: ''
        },
        value: {
          header: 'value',
          default: ''
        },
        calc: {
          header: 'Calc Value',
          default: ''
        },
        selected: {
          header: '<span class="dashicons dashicons-yes"><\/span>',
          default: 0
        }
      }
    },
    manual_value: true
  }, {
    errors: [],
    max_options: 0,
    label: 'Enabled (Initial State)',
    value: 'enabled',
    calc: 1,
    selected: 1,
    order: 1,
    settingModel: {
      settings: false,
      hide_merge_tags: false,
      error: false,
      name: 'options',
      type: 'option-repeater',
      label: 'Options <a href="#" class="nf-add-new">Add New<\/a> <a href="#" class="extra nf-open-import-tooltip"><i class="fa fa-sign-in" aria-hidden="true"><\/i> Import<\/a>',
      width: 'full',
      group: '',
      value: [{
        label: 'One',
        value: 'one',
        calc: '',
        selected: 0,
        order: 0
      }, {
        label: 'Two',
        value: 'two',
        calc: '',
        selected: 0,
        order: 1
      }, {
        label: 'Three',
        value: 'three',
        calc: '',
        selected: 0,
        order: 2
      }],
      columns: {
        label: {
          header: 'label',
          default: ''
        },
        value: {
          header: 'value',
          default: ''
        },
        calc: {
          header: 'Calc Value',
          default: ''
        },
        selected: {
          header: '<span class="dashicons dashicons-yes"><\/span>',
          default: 0
        }
      }
    },
    manual_value: true
  }, {
    errors: [],
    max_options: 0,
    label: 'Processing',
    value: 'processing',
    calc: 2,
    selected: 0,
    order: 2,
    settingModel: {
      settings: false,
      hide_merge_tags: false,
      error: false,
      name: 'options',
      type: 'option-repeater'
    },
    manual_value: true
  }, {
    errors: [],
    max_options: 0,
    label: 'Enabled (Questions)',
    value: 'ai_enhanced',
    calc: 3,
    selected: 0,
    order: 3,
    settingModel: {
      settings: false,
      hide_merge_tags: false,
      error: false,
      name: 'options',
      type: 'option-repeater',
      label: 'Options <a href="#" class="nf-add-new">Add New<\/a> <a href="#" class="extra nf-open-import-tooltip"><i class="fa fa-sign-in" aria-hidden="true"><\/i> Import<\/a>',
      width: 'full',
      group: '',
      value: [{
        label: 'One',
        value: 'one',
        calc: '',
        selected: 0,
        order: 0
      }, {
        label: 'Two',
        value: 'two',
        calc: '',
        selected: 0,
        order: 1
      }, {
        label: 'Three',
        value: 'three',
        calc: '',
        selected: 0,
        order: 2
      }],
      columns: {
        label: {
          header: 'label',
          default: ''
        },
        value: {
          header: 'value',
          default: ''
        },
        calc: {
          header: 'Calc Value',
          default: ''
        },
        selected: {
          header: '<span class="dashicons dashicons-yes"><\/span>',
          default: 0
        }
      }
    },
    manual_value: true
  }, {
    errors: [],
    max_options: 0,
    order: 4,
    new: false,
    options: [],
    label: 'Enabled (No Questions)',
    value: 'no_questions',
    calc: 4,
    selected: 0,
    settingModel: {
      settings: false,
      hide_merge_tags: false,
      error: false,
      name: 'options',
      type: 'option-repeater',
      label: 'Options <a href="#" class="nf-add-new">Add New<\/a> <a href="#" class="extra nf-open-import-tooltip"><i class="fa fa-sign-in" aria-hidden="true"><\/i> Import<\/a>',
      width: 'full',
      group: '',
      value: [{
        label: 'One',
        value: 'one',
        calc: '',
        selected: 0,
        order: 0
      }, {
        label: 'Two',
        value: 'two',
        calc: '',
        selected: 0,
        order: 1
      }, {
        label: 'Three',
        value: 'three',
        calc: '',
        selected: 0,
        order: 2
      }],
      columns: {
        label: {
          header: 'label',
          default: ''
        },
        value: {
          header: 'value',
          default: ''
        },
        calc: {
          header: 'Calc Value',
          default: ''
        },
        selected: {
          header: '<span class="dashicons dashicons-yes"><\/span>',
          default: 0
        }
      }
    },
    manual_value: true
  }],
  'container_class': '',
  'element_class': '',
  'admin_label': '',
  'help_text': '',
  'wrap_styles_border': '',
  'wrap_styles_width': '',
  'wrap_styles_margin': '',
  'wrap_styles_padding': '',
  'wrap_styles_float': '',
  'wrap_styles_show_advanced_css': 0,
  'label_styles_border': '',
  'label_styles_width': '',
  'label_styles_font-size': '',
  'label_styles_margin': '',
  'label_styles_padding': '',
  'label_styles_float': '',
  'label_styles_show_advanced_css': 0,
  'element_styles_border': '',
  'element_styles_width': '',
  'element_styles_font-size': '',
  'element_styles_margin': '',
  'element_styles_padding': '',
  'element_styles_float': '',
  'element_styles_show_advanced_css': 0,
  'cellcid': 'c4062',
  'drawerDisabled': false,
  'id': __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* STATE_ID */],
  'beforeField': '',
  'afterField': '',
  'value': '1',
  'parentType': 'list',
  'element_templates': ['listselect', 'input'],
  'old_classname': 'list-select',
  'wrap_template': 'wrap'
}, {
  'objectType': 'Field',
  'objectDomain': 'fields',
  'editActive': false,
  'order': 10,
  'idAttribute': 'id',
  'type': 'html',
  'label': 'Processing •••',
  'default': '',
  'container_class': 'ai-enhanced-form processing-field-container',
  'element_class': '',
  'wrap_styles_show_advanced_css': 0,
  'label_styles_show_advanced_css': 0,
  'element_styles_show_advanced_css': 0,
  'cellcid': 'c3758',
  'key': __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PROCESSING_LABEL_KEY */],
  'drawerDisabled': false,
  'field_label': '',
  'field_key': __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* PROCESSING_LABEL_KEY */],
  'admin_label': '',
  'wrap_styles_border': '',
  'wrap_styles_width': '',
  'wrap_styles_margin': '',
  'wrap_styles_padding': '',
  'wrap_styles_float': '',
  'label_styles_border': '',
  'label_styles_width': '',
  'label_styles_font-size': '',
  'label_styles_margin': '',
  'label_styles_padding': '',
  'label_styles_float': '',
  'element_styles_border': '',
  'element_styles_width': '',
  'element_styles_font-size': '',
  'element_styles_margin': '',
  'element_styles_padding': '',
  'element_styles_float': '',
  'id': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PROCESSING_LABEL_ID */],
  'beforeField': '',
  'afterField': '',
  'value': '',
  'label_pos': 'above',
  'parentType': 'html',
  'element_templates': ['html', 'input'],
  'old_classname': '',
  'wrap_template': 'wrap'
}, {
  'objectType': 'Field',
  'objectDomain': 'fields',
  'editActive': false,
  'order': 6,
  'idAttribute': 'id',
  'type': 'textbox',
  'label': 'AI Question 1',
  'key': __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* AI_QUESTION1_KEY */],
  'label_pos': 'above',
  'required': false,
  'default': '',
  'placeholder': '',
  'container_class': '',
  'element_class': '',
  'input_limit': '',
  'input_limit_type': 'characters',
  'input_limit_msg': 'Character(s) left',
  'manual_key': false,
  'admin_label': '',
  'help_text': '',
  'mask': '',
  'custom_mask': '',
  'custom_name_attribute': '',
  'personally_identifiable': '',
  'wrap_styles_border': '',
  'wrap_styles_width': '',
  'wrap_styles_margin': '',
  'wrap_styles_padding': '',
  'wrap_styles_float': '',
  'wrap_styles_show_advanced_css': 0,
  'label_styles_border': '',
  'label_styles_width': '',
  'label_styles_font-size': '',
  'label_styles_margin': '',
  'label_styles_padding': '',
  'label_styles_float': '',
  'label_styles_show_advanced_css': 0,
  'element_styles_border': '',
  'element_styles_width': '',
  'element_styles_font-size': '',
  'element_styles_margin': '',
  'element_styles_padding': '',
  'element_styles_float': '',
  'element_styles_show_advanced_css': 0,
  'cellcid': 'c4399',
  'value': '',
  'id': __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AI_QUESTION1_ID */],
  'beforeField': '',
  'afterField': '',
  'parentType': 'textbox',
  'element_templates': ['textbox', 'input'],
  'old_classname': '',
  'wrap_template': 'wrap'
}, {
  'objectType': 'Field',
  'objectDomain': 'fields',
  'editActive': false,
  'order': 7,
  'idAttribute': 'id',
  'type': 'textbox',
  'label': 'AI Question 2',
  'key': __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* AI_QUESTION2_KEY */],
  'label_pos': 'above',
  'required': false,
  'default': '',
  'placeholder': '',
  'container_class': '',
  'element_class': '',
  'input_limit': '',
  'input_limit_type': 'characters',
  'input_limit_msg': 'Character(s) left',
  'manual_key': false,
  'admin_label': '',
  'help_text': '',
  'mask': '',
  'custom_mask': '',
  'custom_name_attribute': '',
  'personally_identifiable': '',
  'wrap_styles_border': '',
  'wrap_styles_width': '',
  'wrap_styles_margin': '',
  'wrap_styles_padding': '',
  'wrap_styles_float': '',
  'wrap_styles_show_advanced_css': 0,
  'label_styles_border': '',
  'label_styles_width': '',
  'label_styles_font-size': '',
  'label_styles_margin': '',
  'label_styles_padding': '',
  'label_styles_float': '',
  'label_styles_show_advanced_css': 0,
  'element_styles_border': '',
  'element_styles_width': '',
  'element_styles_font-size': '',
  'element_styles_margin': '',
  'element_styles_padding': '',
  'element_styles_float': '',
  'element_styles_show_advanced_css': 0,
  'cellcid': 'c7815',
  'value': '',
  'drawerDisabled': false,
  'id': __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* AI_QUESTION2_ID */],
  'beforeField': '',
  'afterField': '',
  'parentType': 'textbox',
  'element_templates': ['textbox', 'input'],
  'old_classname': '',
  'wrap_template': 'wrap'
}, {
  'objectType': 'Field',
  'objectDomain': 'fields',
  'editActive': false,
  'order': 12,
  'idAttribute': 'id',
  'type': 'submit',
  'label': 'Next',
  'processing_label': 'Processing',
  'container_class': '',
  'element_class': '',
  'key': __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* NEXT_BUTTON_KEY */],
  'wrap_styles_show_advanced_css': 0,
  'element_styles_show_advanced_css': 0,
  'submit_element_hover_styles_show_advanced_css': 0,
  'cellcid': 'c9683',
  'drawerDisabled': '',
  'field_label': 'Next',
  'field_key': __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* NEXT_BUTTON_KEY */],
  'admin_label': '',
  'wrap_styles_border': '',
  'wrap_styles_width': '',
  'wrap_styles_margin': '',
  'wrap_styles_padding': '',
  'wrap_styles_float': '',
  'element_styles_border': '',
  'element_styles_width': '',
  'element_styles_font-size': '',
  'element_styles_margin': '',
  'element_styles_padding': '',
  'element_styles_float': '',
  'submit_element_hover_styles_border': '',
  'submit_element_hover_styles_width': '',
  'submit_element_hover_styles_font-size': '',
  'submit_element_hover_styles_margin': '',
  'submit_element_hover_styles_padding': '',
  'submit_element_hover_styles_float': '',
  'id': __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* NEXT_BUTTON_ID */],
  'beforeField': '',
  'afterField': '',
  'value': '',
  'label_pos': 'above',
  'parentType': 'textbox',
  'element_templates': ['submit', 'button', 'input'],
  'old_classname': '',
  'wrap_template': 'wrap-no-label'
}, {
  'objectType': 'Field',
  'objectDomain': 'fields',
  'editActive': false,
  'order': 10,
  'idAttribute': 'id',
  'type': 'html',
  'label': '',
  'default': EXPLANATION_TEXT_HTML,
  'container_class': '',
  'element_class': '',
  'wrap_styles_show_advanced_css': 0,
  'label_styles_show_advanced_css': 0,
  'element_styles_show_advanced_css': 0,
  'cellcid': 'c3758',
  'key': __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EXPLANATION_TEXT_KEY */],
  'drawerDisabled': false,
  'field_label': '',
  'field_key': __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EXPLANATION_TEXT_KEY */],
  'admin_label': '',
  'wrap_styles_border': '',
  'wrap_styles_width': '',
  'wrap_styles_margin': '',
  'wrap_styles_padding': '',
  'wrap_styles_float': '',
  'label_styles_border': '',
  'label_styles_width': '',
  'label_styles_font-size': '',
  'label_styles_margin': '',
  'label_styles_padding': '',
  'label_styles_float': '',
  'element_styles_border': '',
  'element_styles_width': '',
  'element_styles_font-size': '',
  'element_styles_margin': '',
  'element_styles_padding': '',
  'element_styles_float': '',
  'id': __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EXPLANATION_TEXT_ID */],
  'beforeField': '',
  'afterField': '',
  'value': EXPLANATION_TEXT_HTML,
  'label_pos': 'above',
  'parentType': 'html',
  'element_templates': ['html', 'input'],
  'old_classname': '',
  'wrap_template': 'wrap'
}];
/* harmony default export */ __webpack_exports__["a"] = (AI_FIELDS);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_starts_with__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__source_form_locators__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(46);





function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }



var USE_APP = document.getElementsByClassName('ENABLE_AI_SUGGESTION_APP').length === 1;
var ENDPOINT_URL = '/wp-json/tr/site-endpoints/v2/ai/v1/suggestions';
var HTTP_TIMEOUT = 5;
var $ = jQuery;
/**
 * @returns {*}
 */

function buildNextButtonControllerClass() {
  return window.Marionette.Object.extend({
    adobeEvents: null,
    stateField: null,
    messageField: null,
    aiQuestion1Field: null,
    aiQuestion2Field: null,
    nextButtonField: null,
    suggestionsCalled: false,
    formPrefixId: null,
    formId: null,
    initialize: function initialize(_ref) {
      var formId = _ref.formId,
          formPrefixId = _ref.formPrefixId,
          fields = _ref.fields,
          adobeEvents = _ref.adobeEvents;
      this.adobeEvents = adobeEvents;
      this.formPrefixId = formPrefixId;
      this.messageField = this.getField(Object(__WEBPACK_IMPORTED_MODULE_4__source_form_locators__["c" /* findMessageId */])(fields));

      if ($('.ENABLE_EDITABLE_LAYOUT_OF_AI_FORMS').length === 1) {
        this.stateField = this.getFieldByKey(fields, __WEBPACK_IMPORTED_MODULE_5__constants__["l" /* STATE_KEY */]);
        this.aiQuestion1Field = this.getFieldByKey(fields, __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* AI_QUESTION1_KEY */]);
        this.aiQuestion2Field = this.getFieldByKey(fields, __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* AI_QUESTION2_KEY */]);
        this.nextButtonField = this.getFieldByKey(fields, __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* NEXT_BUTTON_KEY */]);
      } else {
        this.stateField = this.getField(this.formPrefixId + __WEBPACK_IMPORTED_MODULE_5__constants__["k" /* STATE_ID */]);
        this.aiQuestion1Field = this.getField(this.formPrefixId + __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* AI_QUESTION1_ID */]);
        this.aiQuestion2Field = this.getField(this.formPrefixId + __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* AI_QUESTION2_ID */]);
        this.nextButtonField = this.getField(this.formPrefixId + __WEBPACK_IMPORTED_MODULE_5__constants__["g" /* NEXT_BUTTON_ID */]);
      }

      this.formId = formId; // on submit, we need to inject the AI fields

      var formChannel = nfRadio.channel("form-".concat(formId));
      this.listenTo(formChannel, 'before:submit', this.injectAIFieldsIntoRequest); // on the Field's model value change...

      var fieldsChannel = Backbone.Radio.channel('fields');
      this.listenTo(fieldsChannel, 'change:modelValue', this.submitForSuggestions); // prepare the next button

      this.setupNextButton();
    },
    getField: function getField(fieldId) {
      return nfRadio.channel('fields').request('get:field', fieldId);
    },
    getFieldByKey: function getFieldByKey(fields, key) {
      var found = false;

      for (var i = 0; i < fields.length; i += 1) {
        if (fields[i].key === key || fields[i].admin_label === key) {
          found = i;
          break;
        }

        if (fields[i].key.startsWith(key)) {
          found = i;
          break;
        }
      }

      if (found === false) {
        throw new Error("Field with key ".concat(key, " not found"));
      }

      return this.getField(fields[found].id);
    },
    injectAIFieldsIntoRequest: function injectAIFieldsIntoRequest(formModel) {
      if (this.stateField.get('value') === 'questions') {
        var extra = formModel.get('extra');
        extra.aiQuestions = {};
        extra.aiQuestions[this.aiQuestion1Field.get('label')] = this.aiQuestion1Field.get('value');
        extra.aiQuestions[this.aiQuestion2Field.get('label')] = this.aiQuestion2Field.get('value');
        formModel.set('extra', extra);
      }
    },
    setupNextButton: function setupNextButton() {
      Backbone.Radio.channel("field-".concat(this.nextButtonField.get('id'))).off('click:field');
      var self = this;
      $(document).on('click', "#nf-field-".concat(this.nextButtonField.get('id')), function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.stateField.set('value', 'processing');
        self.stateField.trigger('reRender');
        self.adobeEvents.trackNextButtonClicked();
        return false;
      });
    },
    responseCallBack: function responseCallBack(_ref2) {
      var _adobeEvents;

      var choices = _ref2.data.response.choices;
      var questions = [];
      var content = choices[0].message.content;
      var fieldId = false;

      if (content) {
        questions = this.normaliseQuestions(content);
      }

      if (questions.length) {
        this.aiQuestion1Field.set('label', questions[0]);
        this.aiQuestion2Field.set('label', questions[1]);
        this.aiQuestion1Field.trigger('reRender');
        this.aiQuestion2Field.trigger('reRender');
        this.stateField.set('value', 'questions');
        fieldId = this.aiQuestion1Field.get('id');
      } else {
        this.stateField.set('value', 'no_questions');
        fieldId = this.messageField.get('id');
      }

      this.stateField.trigger('reRender'); // Inform outer scripts (for example a11y scripts) about update of the form

      jQuery(document).trigger('aiEnhancedFormUpdate', {
        $el: [$("#nf-form-".concat(this.formId, "-cont")).get(0)]
      });

      (_adobeEvents = this.adobeEvents).trackSmartQuestionsAsked.apply(_adobeEvents, _toConsumableArray(questions));

      var selector = "#nf-field-".concat(fieldId);
      jQuery(selector).focus();
    },
    submitForSuggestions: function submitForSuggestions(model) {
      var isMatchingField = model.id === this.stateField.get('id') && model.get('value') === 'processing';

      if (!isMatchingField) {
        return;
      }

      if (this.suggestionsCalled) {
        window.console.log('Skipping the Suggestions: already called once');
        return;
      }

      this.suggestionsCalled = true;
      var self = this;
      var postData = {
        message: this.messageField.get('value')
      };

      if (USE_APP) {
        postData = JSON.stringify({
          data: {
            user_message: this.messageField.get('value')
          }
        });
      }

      $.ajax(USE_APP ? flGlobalSettings.AI_SUGGESTIONS_ENDPOINT_APP : ENDPOINT_URL, {
        method: 'POST',
        data: postData,
        timeout: HTTP_TIMEOUT * 1000
      }).done(function (data) {
        return self.responseCallBack(data);
      }).fail(function (jqXHR, textStatus, errorThrown) {
        console.log('Captured error while doing Ajax call: ', jqXHR, textStatus, errorThrown);
        var emptyDataSet = {
          data: {
            response: {
              choices: [{
                message: {
                  content: '[]'
                }
              }]
            }
          }
        };
        return self.responseCallBack(emptyDataSet);
      });
    },
    normaliseQuestions: function normaliseQuestions(content) {
      try {
        var incomingQuestions = JSON.parse(content);

        if (!USE_APP) {
          return incomingQuestions;
        }

        var questions = [];

        if (incomingQuestions.Question1) {
          questions.push(incomingQuestions.Question1);
        }

        if (incomingQuestions.Question2) {
          questions.push(incomingQuestions.Question2);
        }

        return questions;
      } catch (e) {
        return [];
      }
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (buildNextButtonControllerClass);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdobeEvents; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AdobeEvents =
/*#__PURE__*/
function () {
  function AdobeEvents() {
    _classCallCheck(this, AdobeEvents);
  }

  _createClass(AdobeEvents, [{
    key: "trackNextButtonClicked",

    /**
     * @returns void
     */
    value: function trackNextButtonClicked() {
      this._trackEvent('contact-form-next-button-clicked');
    }
    /**
     * @param questions Array<string>
     * @returns void
     */

  }, {
    key: "trackSmartQuestionsAsked",
    value: function trackSmartQuestionsAsked() {
      var result = {
        questions: []
      };

      for (var _len = arguments.length, questions = new Array(_len), _key = 0; _key < _len; _key++) {
        questions[_key] = arguments[_key];
      }

      for (var i = 0; i < questions.length; i++) {
        if (questions[i].length !== 0) {
          result.questions.push(questions[i]);
        }
      }

      this._trackEvent('contact-form-smart-questions-asked', result);
    }
    /**
     *
     * @param event string
     * @param args
     * @private
     * @returns void
     */

  }, {
    key: "_trackEvent",
    value: function _trackEvent(event) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!(window._satellite instanceof Object)) {
        return;
      }

      window._satellite.track(event, args);
    }
  }]);

  return AdobeEvents;
}();

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bloom_controllers_bloom_close_button__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_controllers_mobile_menu__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation_controllers_desktop_menu__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bloom_controllers_fix_keyboard_issue_in_popups__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bloom_controllers_bloom_email_input__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__divi_controllers_accordion__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nf_controllers_fix_disclaimer__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__divi_controllers_descriptive_links__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__navigation_controllers_provide_aria_expanded_in_submenus__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__focus_back_to_top_link__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__search_search_form__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__search_search_form_enhanced__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__slider_controllers_slider_improvements__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__slider_controllers_slider_tab_order__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__footer_controllers_fix_social_media_buttons__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__navigation_controllers_focus_hamburger_menu_on_closing_menu__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__focus_breadcrumbs_focus__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__remove_anchor_role_attribute__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__practice_area_accordion__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__attorney_tabs__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__divi_controllers_attorney_toggle__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__navigation_controllers_provide_aria_expanded_for_parentmenus__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__divi_controllers_bio_accordion__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__navigation_controllers_enable_aria_label_nav_mega_menu__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__navigation_controllers_enable_aria_lable_nf_fields__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__navigation_controllers_enable_focus_on_elements_on_tab_navigation__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__slider_controllers_auto_rotating_slider_improvement__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__navigation_controllers_prevent_header_nav_menu_arrow_icons_screen_reader__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__nf_controllers_nf_a11y_validation__ = __webpack_require__(417);
/**
 * @function init
 * @description Kick off this modules functions
 */





























var $ = jQuery;

var init = function init() {
  if ($('.ENABLE_SEARCH_FORM_CLEAR_BUTTON').length > 0 && coreAccessibility.enable_search_form_clear_button) {
    Object(__WEBPACK_IMPORTED_MODULE_11__search_search_form_enhanced__["a" /* default */])();
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_10__search_search_form__["a" /* default */])();
  }

  var mobileMenu = new __WEBPACK_IMPORTED_MODULE_1__navigation_controllers_mobile_menu__["a" /* default */]();
  mobileMenu.start();
  var desktopMenu = new __WEBPACK_IMPORTED_MODULE_2__navigation_controllers_desktop_menu__["a" /* default */]();
  desktopMenu.start();
  var bloomCloseButton = new __WEBPACK_IMPORTED_MODULE_0__bloom_controllers_bloom_close_button__["a" /* default */]();
  bloomCloseButton.start();
  var fixKeyboardFocusInPopups = new __WEBPACK_IMPORTED_MODULE_3__bloom_controllers_fix_keyboard_issue_in_popups__["a" /* default */]();
  fixKeyboardFocusInPopups.start();
  var bloomEmailInput = new __WEBPACK_IMPORTED_MODULE_4__bloom_controllers_bloom_email_input__["a" /* default */]();
  bloomEmailInput.start();
  var accordion = new __WEBPACK_IMPORTED_MODULE_5__divi_controllers_accordion__["a" /* default */]();
  accordion.start();
  var fixDisclaimer = new __WEBPACK_IMPORTED_MODULE_6__nf_controllers_fix_disclaimer__["a" /* default */]();

  if ($('.ENABLE_NF_DISCLAIMER_A11Y').length > 0 && coreAccessibility.enable_nf_disclaimer_a11y) {
    fixDisclaimer.fixDisclaimerA11y();
  } else {
    fixDisclaimer.start();
  }

  var descriptiveLinks = new __WEBPACK_IMPORTED_MODULE_7__divi_controllers_descriptive_links__["a" /* default */]();
  descriptiveLinks.start();
  var sliderImprovements = new __WEBPACK_IMPORTED_MODULE_12__slider_controllers_slider_improvements__["a" /* default */]();
  sliderImprovements.start();
  var sliderTabOrder = new __WEBPACK_IMPORTED_MODULE_13__slider_controllers_slider_tab_order__["a" /* default */]();
  sliderTabOrder.start();
  var fixSocialMediaButtons = new __WEBPACK_IMPORTED_MODULE_14__footer_controllers_fix_social_media_buttons__["a" /* default */]();
  fixSocialMediaButtons.start();
  var breadcrumbsFocus = new __WEBPACK_IMPORTED_MODULE_16__focus_breadcrumbs_focus__["a" /* default */]();
  breadcrumbsFocus.start();
  Object(__WEBPACK_IMPORTED_MODULE_8__navigation_controllers_provide_aria_expanded_in_submenus__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_9__focus_back_to_top_link__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_15__navigation_controllers_focus_hamburger_menu_on_closing_menu__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_17__remove_anchor_role_attribute__["a" /* default */])();

  if ($('.ENABLE_ARIA_LABEL_MEGA_MENU_NAV_A11Y').length > 0 && coreAccessibility.enable_aria_label) {
    Object(__WEBPACK_IMPORTED_MODULE_23__navigation_controllers_enable_aria_label_nav_mega_menu__["a" /* default */])();
  } // Practice Area Accordion Module


  var accordions = document.querySelectorAll('.menu.practice_area_menu_accordion .fl-accordion');
  accordions.forEach(function (accordionEl) {
    var practiceAreaAccordion = new __WEBPACK_IMPORTED_MODULE_18__practice_area_accordion__["a" /* default */]();
    practiceAreaAccordion.start(accordionEl);
  });
  var tabLists = document.querySelectorAll('[role=tablist].fl-tabs');

  if (tabLists.length > 0) {
    tabLists.forEach(function (tabEl) {
      var attorneyTabElement = new __WEBPACK_IMPORTED_MODULE_19__attorney_tabs__["a" /* default */]();
      attorneyTabElement.start(tabEl);
    });
  }

  var attorneytoggle = new __WEBPACK_IMPORTED_MODULE_20__divi_controllers_attorney_toggle__["a" /* default */]();
  attorneytoggle.start();

  if (coreAccessibility.parentsubmenu_aria_expand_issue_fix) {
    Object(__WEBPACK_IMPORTED_MODULE_21__navigation_controllers_provide_aria_expanded_for_parentmenus__["a" /* default */])();
  }

  if (coreAccessibility.enable_attorney_page_accordion_fix) {
    var bioAccordion = new __WEBPACK_IMPORTED_MODULE_22__divi_controllers_bio_accordion__["a" /* default */]();
    bioAccordion.start();
  }

  if (coreAccessibility.enable_nf_field_generic_fix) {
    Object(__WEBPACK_IMPORTED_MODULE_24__navigation_controllers_enable_aria_lable_nf_fields__["a" /* default */])();
  }

  if ($('.ENABLE_FOCUS_ON_ELEMENTS_ON_TAB_NAVIGATION_FIX').length > 0 && coreAccessibility.enable_focus_on_elements_on_tab_nav_fix) {
    Object(__WEBPACK_IMPORTED_MODULE_25__navigation_controllers_enable_focus_on_elements_on_tab_navigation__["a" /* default */])();
  }

  if (coreAccessibility.enable_auto_rotating_slider_issue_fix) {
    var autoRotatingSliderImprovement = new __WEBPACK_IMPORTED_MODULE_26__slider_controllers_auto_rotating_slider_improvement__["a" /* default */]();
    autoRotatingSliderImprovement.start();
  }

  Object(__WEBPACK_IMPORTED_MODULE_27__navigation_controllers_prevent_header_nav_menu_arrow_icons_screen_reader__["a" /* default */])();
  var nfFomErrorValidation = new __WEBPACK_IMPORTED_MODULE_28__nf_controllers_nf_a11y_validation__["a" /* default */]();

  if ($('.ENABLE_NF_FORM_ERROR_VALIDATION_A11Y_ISSUE_FIX').length > 0 && coreAccessibility.enable_nf_error_validation_issue_fix) {
    nfFomErrorValidation.start();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (init);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BloomCloseButton; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BloomCloseButton =
/*#__PURE__*/
function () {
  function BloomCloseButton() {
    _classCallCheck(this, BloomCloseButton);
  }

  _createClass(BloomCloseButton, [{
    key: "start",
    value: function start() {
      this.attachEventListeners();
    }
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      this.pressButtonEvent();
    }
  }, {
    key: "pressButtonEvent",
    value: function pressButtonEvent() {
      var _this = this;

      // Close modal with Enter key when keyboard focus is on close icon
      $('body').on('keydown', BloomCloseButton.SELECTOR, function (e) {
        if (e.key === 'Enter') {
          _this.closeModal(BloomCloseButton.SELECTOR);
        }
      });

      if (coreAccessibility.enable_bloom_a11y_fixes) {
        // Close the modal with the Escape key
        document.addEventListener('keydown', function (e) {
          if (e.code === 'Escape') {
            _this.closeModal(BloomCloseButton.SELECTOR);
          }
        });
      }
    }
  }, {
    key: "closeModal",
    value: function closeModal(element) {
      var $ = jQuery;
      var $popupContainer = $(element).parents().filter('.et_bloom_optin.et_bloom_flyin, .et_bloom_optin.et_bloom_popup').first();
      $popupContainer.addClass('et_bloom_exit_animation');
      setTimeout(function () {
        if ($popupContainer.hasClass('et_bloom_trigger_click')) {
          $popupContainer.removeClass('et_bloom_visible et_bloom_animated et_bloom_exit_animation');
        } else {
          $popupContainer.remove();
        }
      }, 400);
      $('body').removeClass('et_bloom_popup_active');
    }
  }]);

  return BloomCloseButton;
}();

BloomCloseButton.SELECTOR = 'span.et_bloom_close_button';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_observer__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__obervers_element_attribute_oberver__ = __webpack_require__(102);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var MobileMenu =
/*#__PURE__*/
function () {
  function MobileMenu() {
    _classCallCheck(this, MobileMenu);
  }

  _createClass(MobileMenu, [{
    key: "start",
    value: function start() {
      var $ = jQuery; //check if mobile menu is presented on the page

      if (!$(MobileMenu.SELECTOR).length) {
        return;
      }

      this.observer = new __WEBPACK_IMPORTED_MODULE_1__menu_observer__["a" /* default */]($(MobileMenu.SELECTOR).get(0));
      this.attachEventListeners();
    }
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      this.observer.onRender(function () {
        var $ = jQuery;

        if (!coreAccessibility.parentsubmenu_aria_expand_issue_fix) {
          $(MobileMenu.SELECTOR).find('.menu-item-has-children').children('a:eq(0)').removeAttr('aria-expanded').removeAttr('aria-haspopup');
          $(MobileMenu.SELECTOR).find('.menu-item-has-children').children('a:eq(0)').get().forEach(function (item) {
            var itemObserver = new __WEBPACK_IMPORTED_MODULE_2__obervers_element_attribute_oberver__["a" /* default */](item);
            itemObserver.onUpdate(function () {
              $(item).removeAttr('aria-expanded').removeAttr('aria-haspopup');
            });
          });
        }
        /**
         * Re-write the behaviour of changing aria-labels of mobile menu bar
         */


        $('.mobile_menu_bar').attr({
          'role': 'button',
          'aria-expanded': 'false',
          'aria-label': 'Open Menu',
          'tabindex': 0
        });
        $('.mobile_menu_bar').off('click').on('click', function () {
          if ($(this).hasClass('a11y-mobile-menu-open')) {
            $(this).removeClass('a11y-mobile-menu-open').attr('aria-expanded', 'false');
            $(this).attr('aria-label', 'Open Menu');
          } else {
            $(this).addClass('a11y-mobile-menu-open').attr('aria-expanded', 'true');
            $(this).attr('aria-label', 'Close Menu');
          }
        });
        /**
         * Closes mobile menu with the Esc key
         */

        $(document).keyup(function (event) {
          // The ESC key is pressed
          if (event.keyCode === 27) {
            $('.mobile_nav.opened').each(function () {
              if ($(this).find('.mobile_menu_bar:visible').is(':focus')) {
                $(this).find('.mobile_menu_bar:visible').trigger('click');
              } else {
                $(this).find('.mobile_menu_bar:visible').focus();
              }
            });
          }
        });
        /**
         * Closes mobile menu when it loses focus.
         */

        $(document).on('focusin', function () {
          $('.mobile_nav.opened').each(function () {
            if (!$(this).find(':focus').length) {
              $(this).find('.mobile_menu_bar:visible').trigger('click');
            }
          });
        });
      });
    }
  }]);

  return MobileMenu;
}();

MobileMenu.SELECTOR = '.mobile_nav';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _class; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _class =
/*#__PURE__*/
function () {
  function _class(selector) {
    _classCallCheck(this, _class);

    this.element = selector;
    this.handlers = {
      render: []
    };
    this.initObserver();
  }

  _createClass(_class, [{
    key: "initObserver",
    value: function initObserver() {
      var _this = this;

      var config = {
        childList: true,
        subTree: true
      };

      var callback = function callback(mutationsList) {
        var $ = jQuery;
        mutationsList.forEach(function (mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes) {
            mutation.addedNodes.forEach(function (element) {
              if ($(element).hasClass('et_mobile_menu')) {
                _this.emit('render');
              }
            });
          }
        });
      };

      this.observer = new MutationObserver(callback);
      this.observer.observe(this.element, config);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.observer.disconnect();
    }
  }, {
    key: "onRender",
    value: function onRender(handler) {
      this.handlers.render.push(handler);
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this2 = this;

      this.handlers[event].forEach(function (item) {
        item.call(_this2, event);
      });
    }
  }]);

  return _class;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DesktopMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__obervers_element_attribute_oberver__ = __webpack_require__(102);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var DesktopMenu =
/*#__PURE__*/
function () {
  function DesktopMenu() {
    _classCallCheck(this, DesktopMenu);
  }

  _createClass(DesktopMenu, [{
    key: "start",
    value: function start() {
      this.attachEventListeners();
    }
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      var $ = jQuery;

      if (!coreAccessibility.parentsubmenu_aria_expand_issue_fix) {
        $('.menu-item-has-children').children('a:eq(0)').removeAttr('aria-expanded').removeAttr('aria-haspopup');
        $('.menu-item-has-children').children('a:eq(0)').get().forEach(function (item) {
          var menuItemObserver = new __WEBPACK_IMPORTED_MODULE_0__obervers_element_attribute_oberver__["a" /* default */](item);
          menuItemObserver.onUpdate(function () {
            $(item).removeAttr('aria-expanded').removeAttr('aria-haspopup');
          });
        });
      }
    }
  }]);

  return DesktopMenu;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FixKeyboardIssueInPopups; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observer__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__focus_connector__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__focus_const__ = __webpack_require__(64);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var $ = jQuery;
/**
 * Stores the original focus when optin shows
 * Restores the original focus when optin hides
 * Automatically shifts keyboard focus to the optin when it shows
 * For popups and flyins:
 *
 *  - contraints focus to popup focusables
 *  - the availability of popup announced to the screen reader
 */

var FixKeyboardIssueInPopups =
/*#__PURE__*/
function () {
  function FixKeyboardIssueInPopups() {
    _classCallCheck(this, FixKeyboardIssueInPopups);

    this.flyinObserver = null;
    this.flyinConnector = null;
    this.popupObserver = null;
    this.popupConnector = null;
    this.originalFocusable = null;
    this.firstPopupFocusable = null;
    this.lastPopupFocusable = null;
    this.firstFlyinFocusable = null;
    this.lastFlyinFocusable = null;
  }

  _createClass(FixKeyboardIssueInPopups, [{
    key: "isPopup",
    value: function isPopup() {
      return jQuery(FixKeyboardIssueInPopups.POPUP_SELECTOR).length > 0;
    }
  }, {
    key: "isFlyin",
    value: function isFlyin() {
      return jQuery(FixKeyboardIssueInPopups.FLYIN_SELECTOR).length > 0;
    }
  }, {
    key: "storeOriginalFocus",
    value: function storeOriginalFocus() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (force) {
        this.originalFocusable = null;
      } // Store it only once


      if (!this.originalFocusable) {
        this.originalFocusable = document.activeElement;
      }
    }
  }, {
    key: "restoreOriginalFocus",
    value: function restoreOriginalFocus() {
      if (this.originalFocusable) {
        this.originalFocusable.focus();
        this.originalFocusable = null;
      }
    }
  }, {
    key: "announcePopup",
    value: function announcePopup() {
      // Find the header of opt-in
      var header = $(FixKeyboardIssueInPopups.POPUP_SELECTOR).find('h1,h2').get(0); // Provide the header

      if (!header.id) {
        header.id = 'bloom_popup_header';
      } // Provide aria attributes


      $(FixKeyboardIssueInPopups.POPUP_SELECTOR).attr('aria-modal', 'true').attr('role', 'dialog').attr('aria-labelledby', header.id);
    }
  }, {
    key: "announceFlyin",
    value: function announceFlyin() {
      // Find the header of opt-in
      var header = $(FixKeyboardIssueInPopups.FLYIN_SELECTOR).find('h1,h2').get(0); // Provide the header

      if (!header.id) {
        header.id = 'bloom_flyin_header';
      } // Provide aria attributes


      $(FixKeyboardIssueInPopups.FLYIN_SELECTOR).attr('aria-modal', 'true').attr('role', 'dialog').attr('aria-labelledby', header.id);
    }
  }, {
    key: "start",
    value: function start() {
      // Check if bloom flyin presents on the page
      if (!$(FixKeyboardIssueInPopups.SELECTOR).length) {
        return;
      } // only one time, we need to update attributes of popup opt-in


      if (this.isPopup()) {
        this.announcePopup();
        this.popupObserver = new __WEBPACK_IMPORTED_MODULE_1__observer__["a" /* default */]($(FixKeyboardIssueInPopups.POPUP_SELECTOR).get(0));
      }

      if (this.isFlyin()) {
        this.announceFlyin();
        this.flyinObserver = new __WEBPACK_IMPORTED_MODULE_1__observer__["a" /* default */]($(FixKeyboardIssueInPopups.FLYIN_SELECTOR).get(0));
      }

      this.attachEventListeners();
    }
    /**
     * Locates first and last focusables that belong only to popup opt-in
     */

  }, {
    key: "locatePopupFocusablesForRedirection",
    value: function locatePopupFocusablesForRedirection() {
      var focusableElements = $(FixKeyboardIssueInPopups.POPUP_SELECTOR).find(__WEBPACK_IMPORTED_MODULE_3__focus_const__["b" /* VISIBLE_FOCUSABLE */]);
      this.firstPopupFocusable = focusableElements.get(0);
      this.lastPopupFocusable = focusableElements.get(focusableElements.length - 1);
    }
  }, {
    key: "locateFlyinFocusablesForRedirection",
    value: function locateFlyinFocusablesForRedirection() {
      var focusableElements = $(FixKeyboardIssueInPopups.FLYIN_SELECTOR).find(__WEBPACK_IMPORTED_MODULE_3__focus_const__["b" /* VISIBLE_FOCUSABLE */]);
      this.firstFlyinFocusable = focusableElements.get(0);
      this.lastFlyinFocusable = focusableElements.get(focusableElements.length - 1);
    }
    /**
     * Locates first focusable that belongs to flyin and popup opt-ins. Once located the element receives focus.
     */

  }, {
    key: "focusFirstFocusable",
    value: function focusFirstFocusable() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var focusableElements = $(FixKeyboardIssueInPopups.SELECTOR).find(__WEBPACK_IMPORTED_MODULE_3__focus_const__["b" /* VISIBLE_FOCUSABLE */]);
      var firstFocusable = focusableElements.get(0);

      if (firstFocusable) {
        this.storeOriginalFocus(force);
        firstFocusable.focus();
      }
    }
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      var self = this;

      if (this.popupObserver) {
        this.popupObserver.onShow(function () {
          self.locatePopupFocusablesForRedirection();
          self.popupConnector = new __WEBPACK_IMPORTED_MODULE_2__focus_connector__["a" /* default */](self.lastPopupFocusable, self.firstPopupFocusable);
          self.popupConnector.link(); // Popup should always store actual focusable

          self.focusFirstFocusable(true);
        });
        this.popupObserver.onClose(function () {
          self.popupConnector.unlink();
          self.restoreOriginalFocus();
        });
      }

      if (this.flyinObserver) {
        this.flyinObserver.onShow(function () {
          self.locateFlyinFocusablesForRedirection();
          self.flyinConnector = new __WEBPACK_IMPORTED_MODULE_2__focus_connector__["a" /* default */](self.lastFlyinFocusable, self.firstFlyinFocusable);
          self.flyinConnector.link();
          self.focusFirstFocusable();
        });
        this.flyinObserver.onClose(function () {
          self.flyinConnector.unlink();
          self.restoreOriginalFocus();
        });
      }
    }
  }]);

  return FixKeyboardIssueInPopups;
}();

FixKeyboardIssueInPopups.SELECTOR = '.et_bloom_popup, .et_bloom_flyin';
FixKeyboardIssueInPopups.POPUP_SELECTOR = '.et_bloom_popup';
FixKeyboardIssueInPopups.FLYIN_SELECTOR = '.et_bloom_flyin';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _class; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes__);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _class =
/*#__PURE__*/
function () {
  function _class(selector) {
    _classCallCheck(this, _class);

    this.element = selector;
    this.handlers = {
      show: [],
      close: []
    };
    this.initObserver();
  }

  _createClass(_class, [{
    key: "initObserver",
    value: function initObserver() {
      var _this = this;

      var config = {
        attributes: true,
        attributeOldValue: true,
        childList: true
      };

      var isClassAdded = function isClassAdded(mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') {
          return false;
        }

        var exists = _this.element.className.includes('et_bloom_animated');

        var existed = mutation.oldValue.includes('et_bloom_animated');
        return exists && !existed;
      };

      var isClassRemoved = function isClassRemoved(mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') {
          return false;
        }

        var exists = _this.element.className.includes('et_bloom_exit_animation');

        var existed = mutation.oldValue.includes('et_bloom_animated');
        return exists && existed;
      };

      var callback = function callback(mutationsList) {
        if (!document.body.contains(_this.element)) {
          _this.destroy();
        }

        for (var i = 0; i < mutationsList.length; i++) {
          var mutation = mutationsList[i];

          if (isClassAdded(mutation)) {
            _this.emit('show');
          }

          if (isClassRemoved(mutation)) {
            _this.emit('close');
          }
        }
      };

      this.observer = new MutationObserver(callback);
      this.observer.observe(this.element, config);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.observer.disconnect();
      this.emit('close');
    }
  }, {
    key: "onShow",
    value: function onShow(handler) {
      this.handlers.show.push(handler);
    }
  }, {
    key: "onClose",
    value: function onClose(handler) {
      this.handlers.close.push(handler);
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this2 = this;

      this.handlers[event].forEach(function (item) {
        item.call(_this2, event);
      });
    }
  }]);

  return _class;
}();



/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BloomEmailInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_observer__ = __webpack_require__(387);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var BloomEmailInput =
/*#__PURE__*/
function () {
  function BloomEmailInput() {
    _classCallCheck(this, BloomEmailInput);
  }

  _createClass(BloomEmailInput, [{
    key: "start",
    value: function start() {
      this.attachEventListeners();
    }
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      this.onInvalidEmailError();
      this.onPressSubscriptionButton();
    }
  }, {
    key: "onInvalidEmailError",
    value: function onInvalidEmailError() {
      var $ = jQuery;

      if (!$(BloomEmailInput.FORM_SELECTOR).length) {
        return;
      }

      $(BloomEmailInput.FORM_SELECTOR).get().forEach(function (element) {
        var observe = new __WEBPACK_IMPORTED_MODULE_1__form_observer__["a" /* default */](element);
        observe.onValidationError(function () {
          $(BloomEmailInput.FORM_VALIDATION_ERROR_SELECTOR).attr('role', 'alert').attr('aria-live', 'assertive');

          if (coreAccessibility.enable_bloom_a11y_fixes) {
            $(BloomEmailInput.INPUT_SELECTOR).addClass('et_bloom_warn_required_field').focus();
            $(BloomEmailInput.FORM_SELECTOR).addClass('fl-bloom-error');
          }
        });
      });
    }
  }, {
    key: "onPressSubscriptionButton",
    value: function onPressSubscriptionButton() {
      var $ = jQuery;
      $(BloomEmailInput.SUBSCRIPTION_BUTTON_SELECTOR).on('click', function (event) {
        var $formFields = $(event.target).parents(BloomEmailInput.FORM_FIELDS_SELECTOR);
        var $input = $formFields.find(BloomEmailInput.INPUT_SELECTOR);
        $input.removeClass('et_bloom_warn_required_field');

        if (coreAccessibility.enable_bloom_a11y_fixes) {
          $(BloomEmailInput.FORM_SELECTOR).removeClass('fl-bloom-error');
        }

        $formFields.parent().find(BloomEmailInput.FORM_VALIDATION_ERROR_SELECTOR).remove();

        if ($input.val() === '') {
          $input.addClass('et_bloom_warn_required_field');
          var errorMessage = document.createElement('h2');
          errorMessage.innerText = 'Enter your email address';
          errorMessage.classList.add('et_bloom_error_message');
          $(errorMessage).insertBefore($formFields.get());
        }
      });
    }
  }]);

  return BloomEmailInput;
}();

BloomEmailInput.INPUT_SELECTOR = '.et_bloom_popup_input.et_bloom_subscribe_email input';
BloomEmailInput.FORM_SELECTOR = '.et_bloom_optin form';
BloomEmailInput.SUBSCRIPTION_BUTTON_SELECTOR = '.et_bloom_optin form button';
BloomEmailInput.FORM_VALIDATION_ERROR_SELECTOR = '.et_bloom_error_message';
BloomEmailInput.FORM_FIELDS_SELECTOR = '.et_bloom_fields';
BloomEmailInput.INPUT_LABEL_SELECTOR = '.et_bloom_popup_input.et_bloom_subscribe_email .floating_label';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _class; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _class =
/*#__PURE__*/
function () {
  function _class(element) {
    _classCallCheck(this, _class);

    this.element = element;
    this.handlers = {
      validationError: []
    };
    this.initObserver();
  }

  _createClass(_class, [{
    key: "initObserver",
    value: function initObserver() {
      var _this = this;

      var config = {
        childList: true,
        subTree: true
      };

      var callback = function callback(mutationsList) {
        var $ = jQuery;
        mutationsList.forEach(function (mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes) {
            mutation.addedNodes.forEach(function (element) {
              if ($(element).hasClass('et_bloom_error_message')) {
                _this.emit('validationError');
              }
            });
          }
        });
      };

      this.observer = new MutationObserver(callback);
      this.observer.observe(this.element, config);
    }
  }, {
    key: "onValidationError",
    value: function onValidationError(handler) {
      this.handlers.validationError.push(handler);
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this2 = this;

      this.handlers[event].forEach(function (item) {
        item.call(_this2, event);
      });
    }
  }]);

  return _class;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Accordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__obervers_element_attribute_oberver__ = __webpack_require__(102);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var Accordion =
/*#__PURE__*/
function () {
  function Accordion() {
    _classCallCheck(this, Accordion);
  }

  _createClass(Accordion, [{
    key: "start",
    value: function start() {
      if (!$(Accordion.TOGGLE_ITEM_SELECTOR).length) {
        return;
      }

      this.attachListeners();
    }
  }, {
    key: "attachListeners",
    value: function attachListeners() {
      this.toggleExpand();
      this.toggleAttributeChanged();
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      var $ = jQuery;
      $(Accordion.TOGGLE_SELECTOR).on('keypress', function (event) {
        if (event.key === 'Enter') {
          $(this).click();
        }
      });
      $(Accordion.TOGGLE_SELECTOR).on('click', function () {
        var $element = $(this);

        if ($element.parent().parent().hasClass('et_pb_toggle_close')) {
          $element.attr('aria-expanded', 'true');
        } else {
          $element.attr('aria-expanded', 'false');
        }
      });
    }
  }, {
    key: "toggleAttributeChanged",
    value: function toggleAttributeChanged() {
      var $ = jQuery;
      $(Accordion.TOGGLE_ITEM_SELECTOR).get().forEach(function (item) {
        var itemObserver = new __WEBPACK_IMPORTED_MODULE_0__obervers_element_attribute_oberver__["a" /* default */](item);
        itemObserver.onUpdate(function () {
          $(item).removeAttr('tabindex');
        });
      });
    }
  }]);

  return Accordion;
}();

Accordion.TOGGLE_BUTTON_SELECTOR = '.et_pb_toggle.et_pb_toggle_item div:first-child';
Accordion.TOGGLE_ITEM_SELECTOR = '.et_pb_toggle.et_pb_toggle_item';
Accordion.TOGGLE_SELECTOR = '.et_pb_toggle.et_pb_toggle_item h5';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FixDisclaimer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom_color_contrast__ = __webpack_require__(390);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var FixDisclaimer =
/*#__PURE__*/
function () {
  function FixDisclaimer() {
    _classCallCheck(this, FixDisclaimer);
  }

  _createClass(FixDisclaimer, [{
    key: "start",
    value: function start() {
      if ($('.ENABLE_FIX_DISCLAIMER_ACCESSIBILITY').length === 0) {
        return;
      }

      this.fixDisclaimer();
      this.fixDisclaimerLinks();
    }
  }, {
    key: "fixDisclaimer",
    value: function fixDisclaimer() {
      $(document).on('nfFormReady  aiEnhancedFormUpdate', function () {
        var disclaimerLink = $(FixDisclaimer.DISCLAIMER_LINK_SELECTOR);
        var disclaimerText = $(FixDisclaimer.DISCLAIMER_TEXT_SELECTOR);
        disclaimerLink.removeAttr('title');
        disclaimerLink.attr(FixDisclaimer.ARIA_EXPANDED_ATTRIBUTE, 'false');
        disclaimerText.attr(FixDisclaimer.ARIA_HIDDEN_ATTRIBUTE, 'true');
        disclaimerLink.on('click', function () {
          var disclaimerTextStatus = disclaimerText.hasClass('active');

          if (!disclaimerTextStatus) {
            disclaimerLink.attr(FixDisclaimer.ARIA_EXPANDED_ATTRIBUTE, 'true');
            disclaimerText.attr(FixDisclaimer.ARIA_HIDDEN_ATTRIBUTE, 'false');
          } else {
            disclaimerLink.attr(FixDisclaimer.ARIA_EXPANDED_ATTRIBUTE, 'false');
            disclaimerText.attr(FixDisclaimer.ARIA_HIDDEN_ATTRIBUTE, 'true');
          }
        });
      });
    }
  }, {
    key: "fixDisclaimerLinks",
    value: function fixDisclaimerLinks() {
      var _this = this;

      var cleanLinkStyles = ' text-decoration: underline !important; font-weight: inherit !important; font-family:inherit !important; font-size: inherit !important; letter-spacing: inherit; background-image: none !important; letter-spacing: inherit !important; text-transform: inherit !important; border-bottom: none !important; box-shadow: none !important; line-height: inherit !important;';
      $(document).on('nfFormReady aiEnhancedFormUpdate', function (e, layout) {
        var currentForm = $(layout.$el[0]);
        currentForm.find('.fl-disclaimer a').each(function (i, link) {
          var linkColor = _this.maybeChangeLinkColor($(link)); // @todo This part needs to be revisited when the disclaimer will be moved into the platform.


          $(link).css('cssText', "color: ".concat(linkColor, " !important; ").concat(cleanLinkStyles)); // A workaround for hovered links - hardcode the black color for the hovered links

          $(link).on('mouseenter', function () {
            $(link).css('cssText', "color: #000 !important; ".concat(cleanLinkStyles));
          }).on('mouseleave', function () {
            $(link).css('cssText', "color: ".concat(linkColor, " !important; ").concat(cleanLinkStyles));
          });
        });
      });
    }
  }, {
    key: "maybeChangeLinkColor",
    value: function maybeChangeLinkColor($link) {
      var backgroundColor = $link.parent().css('background-color');
      var currentColor = $link.css('color');

      if (backgroundColor && currentColor) {
        var isAcceptableContrast = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom_color_contrast__["a" /* contrastRatio */])(currentColor, backgroundColor).passes.AA_normal;

        if (!isAcceptableContrast) {
          // Returns either white or black, depending on which provides better contrast with the background color
          return Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom_color_contrast__["b" /* highestContrastColor */])(['#fff', '#000'], backgroundColor);
        }
      }

      return currentColor;
    } // AB#359170 Disclaimer Link Keyboard Accessibility Enhancements

  }, {
    key: "fixDisclaimerA11y",
    value: function fixDisclaimerA11y() {
      var _this2 = this;

      jQuery(document).on('nfFormReady aiEnhancedFormUpdate', function (e, layout) {
        // Current NF Element
        var currentForm = $(layout.$el[0]); // Elements selected from current NF Element

        var disclaimerLink = currentForm.find('.form-disclaimer-trigger');
        var infoBox = currentForm.find('.fl-disclaimer');
        var closeBtn = currentForm.find('.fl-disclaimer__close');
        var nextLink = currentForm.find('.privacy-policy-link'); // Proceed only if all elements are found

        var shouldProceed = window.siteFeatureToggles.ENABLE_AI_ENHANCED_FORM ? disclaimerLink.length && infoBox.length && closeBtn.length : disclaimerLink.length && infoBox.length && closeBtn.length && nextLink.length;

        if (shouldProceed) {
          disclaimerLink.on('click', function (event) {
            event.preventDefault();

            _this2.toggleInfoBox(infoBox, disclaimerLink, closeBtn);
          });
          disclaimerLink.on('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();

              _this2.toggleInfoBox(infoBox, disclaimerLink, closeBtn);
            } else if (event.key === 'Tab' && !event.shiftKey && infoBox.style.display === 'block') {
              event.preventDefault();
              closeBtn.focus();
            }
          });
          closeBtn.on('click', function () {
            _this2.closeInfoBox(infoBox, disclaimerLink);
          });
          closeBtn.on('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();

              _this2.closeInfoBox(infoBox, disclaimerLink);
            } else if (event.key === 'Escape') {
              event.preventDefault();

              _this2.closeInfoBox(infoBox, disclaimerLink);

              disclaimerLink.focus();
            } else if (event.key === 'Tab' && !event.shiftKey) {
              event.preventDefault();

              _this2.closeInfoBox(infoBox, disclaimerLink);

              nextLink.focus();
            } else if (event.key === 'Tab' && event.shiftKey) {
              event.preventDefault();

              _this2.closeInfoBox(infoBox, disclaimerLink);

              disclaimerLink.focus();
            }
          });
        }
      });
    }
  }, {
    key: "toggleInfoBox",
    value: function toggleInfoBox(infoBox, disclaimerLink, closeBtn) {
      if (infoBox.css('display') === 'none' || infoBox.css('display') === '') {
        infoBox.css('display', 'block');
        disclaimerLink.attr('aria-expanded', 'true');
        infoBox.attr('aria-hidden', 'false');
        closeBtn.focus();
      } else {
        this.closeInfoBox(infoBox, disclaimerLink);
      }
    }
  }, {
    key: "closeInfoBox",
    value: function closeInfoBox(infoBox, disclaimerLink) {
      infoBox.css('display', 'none');
      disclaimerLink.attr('aria-expanded', 'false');
      infoBox.attr('aria-hidden', 'true');
      disclaimerLink.focus();
    }
  }]);

  return FixDisclaimer;
}();

FixDisclaimer.DISCLAIMER_LINK_SELECTOR = '#form-disclaimer-trigger';
FixDisclaimer.DISCLAIMER_TEXT_SELECTOR = '#fl-disclaimer';
FixDisclaimer.ARIA_EXPANDED_ATTRIBUTE = 'aria-expanded';
FixDisclaimer.ARIA_HIDDEN_ATTRIBUTE = 'aria-hidden';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contrastRatio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return highestContrastColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_string_starts_with__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__);








function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var WCAG_AA_NORMAL_RATIO = 4.5;
var WCAG_AA_LARGE_RATIO = 3.0;
var WCAG_AAA_NORMAL_RATIO = 7.0;
var WCAG_AAA_LARGE_RATIO = 4.5;
/**
 * Parse a color string (#RRGGBB, #RGB, rgb(), rgba()) into
 * normalized RGBA components (each between 0 and 1).
 */

function parseColor(color) {
  if (color.startsWith('#')) {
    // Expand shorthand #RGB to #RRGGBB
    var hex = color.slice(1);
    if (hex.length === 3) hex = hex.split('').map(function (x) {
      return x + x;
    }).join('');
    if (hex.length === 6) hex += 'ff'; // assume fully opaque if alpha missing

    var num = parseInt(hex, 16);
    return [num / Math.pow(256, 3) % 256 / 255, // Red
    num / Math.pow(256, 2) % 256 / 255, // Green
    num / 256 % 256 / 255, // Blue
    num % 256 / 255];
  } // Parse rgba() or rgb() formats


  var rgba = color.match(/[\d.]+/g).map(Number);
  return [rgba[0] / 255, // Red
  rgba[1] / 255, // Green
  rgba[2] / 255, // Blue
  rgba[3] !== undefined ? rgba[3] : 1];
}
/**
 * Blend two RGBA colors using the standard alpha compositing formula
 * @see https://en.wikipedia.org/wiki/Alpha_compositing
 */


function blend(fg, bg) {
  // Extract RGB and Alpha values for foreground (fg) and background (bg)
  var _fg = _slicedToArray(fg, 4),
      fgR = _fg[0],
      fgG = _fg[1],
      fgB = _fg[2],
      fgA = _fg[3];

  var _bg = _slicedToArray(bg, 4),
      bgR = _bg[0],
      bgG = _bg[1],
      bgB = _bg[2],
      bgA = _bg[3]; // Compute the output alpha (outA)


  var outA = fgA + bgA * (1 - fgA); // Compute blended R, G, B components

  var r = (fgR * fgA + bgR * bgA * (1 - fgA)) / outA;
  var g = (fgG * fgA + bgG * bgA * (1 - fgA)) / outA;
  var b = (fgB * fgA + bgB * bgA * (1 - fgA)) / outA;
  return [r, g, b, outA];
}
/**
 * Convert sRGB values (0–1) to relative luminance (L).
 * @see https://www.w3.org/TR/WCAG22/#dfn-relative-luminance
 */


function luminance(r, g, b) {
  // converts sRGB values into linear RGB values
  var toLin = function toLin(c) {
    return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  };

  return 0.2126 * toLin(r) + 0.7152 * toLin(g) + 0.0722 * toLin(b);
}
/**
 * Compute WCAG contrast ratio between foreground and background colors.
 *
 * WCAG 2.2 Contrast Thresholds:
 *  - AA normal text: ≥ 4.5:1
 *  - AA large text: ≥ 3.0:1
 *  - AAA normal text: ≥ 7.0:1
 *  - AAA large text: ≥ 4.5:1
 *
 * Reference:
 * - https://www.w3.org/TR/WCAG22/#contrast-minimum
 * - https://www.w3.org/TR/WCAG22/#dfn-relative-luminance
 */


function contrastRatio(fgColor, bgColor) {
  var baseColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#ffffff';
  var fg = parseColor(fgColor);
  var bg = parseColor(bgColor);
  var base = parseColor(baseColor); // Blend background (if transparent) over the opaque base first

  var blendedBg = bg[3] < 1 ? blend(bg, base) : bg; // Then blend foreground (if transparent) over that result

  var blendedFg = fg[3] < 1 ? blend(fg, blendedBg) : fg; // Compute luminance values (per WCAG formula)

  var L1 = luminance.apply(void 0, _toConsumableArray(blendedFg));
  var L2 = luminance.apply(void 0, _toConsumableArray(blendedBg)); // Contrast ratio formula (WCAG §1.4.3)

  var ratio = (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05); // Evaluate pass/fail for different WCAG levels

  var passes = {
    AA_normal: ratio >= WCAG_AA_NORMAL_RATIO,
    AA_large: ratio >= WCAG_AA_LARGE_RATIO,
    AAA_normal: ratio >= WCAG_AAA_NORMAL_RATIO,
    AAA_large: ratio >= WCAG_AAA_LARGE_RATIO
  };
  return {
    ratio: +ratio.toFixed(2),
    passes: passes
  };
}
/**
 * Selects the color with the highest contract ratio
 */


function highestContrastColor(fgColors, bgColor) {
  var baseColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#ffffff';
  return __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default()(fgColors, function (x) {
    return contrastRatio(x, bgColor, baseColor).ratio;
  });
}



/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(392),
    baseGt = __webpack_require__(393),
    baseIteratee = __webpack_require__(83);

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
    : undefined;
}

module.exports = maxBy;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(33);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescriptiveLinks; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DescriptiveLinks =
/*#__PURE__*/
function () {
  function DescriptiveLinks() {
    _classCallCheck(this, DescriptiveLinks);
  }

  _createClass(DescriptiveLinks, [{
    key: "start",
    value: function start() {
      $(DescriptiveLinks.LINKS_SELECTOR).each(function (i, element) {
        $(element).attr(DescriptiveLinks.NEW_ATTRIBUTE, "Open  ".concat($(element).html(), " posts"));
      });
    }
  }]);

  return DescriptiveLinks;
}();

DescriptiveLinks.LINKS_SELECTOR = 'article[id^="post"] .post-meta > a';
DescriptiveLinks.NEW_ATTRIBUTE = 'aria-label';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__submenu_observer__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__submenu_tools__ = __webpack_require__(157);


var $ = jQuery;
/**
 * please see CMS-4980 for details on this script
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
  // Loading on windows.onload since custom javascript could
  // add its code, after DomReady event but before window.load event
  $(window).on('load', function () {
    // Wait for 2 seconds, since custom JS can take up to 1 second
    setTimeout(function () {
      $('.menu-item-has-children').each(function () {
        var _this = this;

        // Disclosure button can belong to custom JS (fl-toggle-icon or toggle-menu clases)
        // or to the platform (button element)
        var disclosureButtons = $(this).children('a.fl-toggle-icon,a.toggle-menu,button');
        disclosureButtons.attr('aria-expanded', false); // if we inside mobile menu with custom toggle icon next item will be
        // a disclosure button we need to disable default disclosure button

        if (disclosureButtons.length >= 2) {
          disclosureButtons.filter('button').hide();
        } // Provide aria-label for sites with customized disclosure button


        disclosureButtons.filter('a.toggle-menu,a.fl-toggle-icon').each(function () {
          var label = $(this).prev().text();
          label += ' Submenu';
          $(this).attr('aria-label', label);
        });
        var observer = new __WEBPACK_IMPORTED_MODULE_0__submenu_observer__["a" /* default */](this);
        observer.onShow(function () {
          disclosureButtons.attr('aria-expanded', true);
          Object(__WEBPACK_IMPORTED_MODULE_1__submenu_tools__["b" /* restoreFocusForSubmenu */])(_this);
        });
        observer.onHide(function () {
          disclosureButtons.attr('aria-expanded', false);
          Object(__WEBPACK_IMPORTED_MODULE_1__submenu_tools__["a" /* disableFocusForSubmenu */])(_this);
        });
        observer.connect();
      });
      $('.fl-menu-toggle-only').each(function () {
        if (!this.hasAttribute('href')) {
          $(this).attr('href', '#');
        }
      }); // Because of custom JS some sites having issues with opening
      // burger menu using the keyboard

      $('.mobile_nav').off('keydown');
      $('.mobile_menu_bar').off('keyup');
      $('.mobile_menu_bar').on('keydown', function (event) {
        if (event.keyCode === 13 || event.keyCode === 32) {
          event.preventDefault();
          $(this).click();
        }
      });
    }, 2000);
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _class; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _class =
/*#__PURE__*/
function () {
  function _class() {
    _classCallCheck(this, _class);

    this.eventHandlers = {};
  }

  _createClass(_class, [{
    key: "on",
    value: function on(eventName, handler) {
      if (!this.eventHandlers[eventName]) {
        this.eventHandlers[eventName] = [];
      }

      this.eventHandlers[eventName].push(handler);
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this = this;

      this.eventHandlers[event].forEach(function (item) {
        item.call(_this, event);
      });
    }
  }]);

  return _class;
}();



/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var $ = jQuery;
/* harmony default export */ __webpack_exports__["a"] = (function () {
  $(window).load(function () {
    var backToButton = $('.et_pb_scroll_top');
    var skipToContent = $('.skip-link');

    if ($(backToButton).length && $(skipToContent).length) {
      backToButton.off('click');
      backToButton.on('click', function () {
        $('html, body').animate({
          scrollTop: 0
        }, 800);
        skipToContent.focus();
      });
    }

    backToButton.attr('role', 'button').attr('tabindex', '0').attr('aria-label', 'Back To Top');
    backToButton.on('keydown', function (event) {
      if (event.which === 13) {
        event.preventDefault();
        $(this).click();
      }
    });
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);

var $ = jQuery;
var selectors = {
  visibleSearchForm: 'form[role=search]:visible',
  searchForm: 'form[role=search]',
  divi: {
    searchForm: 'form[role=search].et_pb_searchform,form[role=search].et_pb_menu__search-form',
    searchFormContainer: {
      displayCSSBased: '.fl-search',
      etPbClass: '.et_pb_menu__search-container'
    },
    searchFormIcon: ['.fl-search .et-pb-icon, .fl-search .fa-search', '.fl-search-links', '.et_pb_menu__search-button', '#et_search_icon,.fl-search,.fl-search-button,.fl-search-btn'],
    cleanupNodes: '.fl-search-close'
  }
};

var allSearchForms = function allSearchForms() {
  return $(selectors.searchForm);
};

var getVisibleSearchForm = function getVisibleSearchForm() {
  return $(selectors.visibleSearchForm);
};

var getVisibleSearchInput = function getVisibleSearchInput() {
  return getVisibleSearchForm().find('input[name=s]');
};

var getSearchIcon = function getSearchIcon() {
  for (var i = 0; i < selectors.divi.searchFormIcon.length; i++) {
    if ($(selectors.divi.searchFormIcon[i]).length) {
      var result = $($(selectors.divi.searchFormIcon[i]));

      if (!result.find('form[role=search]').length) {
        return result;
      }
    }
  }

  return $([]);
};

var getEtPbMenuWrap = function getEtPbMenuWrap(form) {
  return $(form).closest('.et_pb_module').find('.et_pb_menu__wrap').first();
};

var hideDiviSearchFormContainer = function hideDiviSearchFormContainer() {
  var s = selectors.divi.searchFormContainer;
  allSearchForms().each(function () {
    if ($(this).parents(s.displayCSSBased).length) {
      $(this).parents(s.displayCSSBased).hide();
    } else if ($(this).parents(s.etPbClass).length) {
      $(this).parents(s.etPbClass).removeClass('et_pb_menu__search-container--visible').addClass('et_pb_menu__search-container--hidden').addClass('et_pb_menu__search-container--disabled');
      getEtPbMenuWrap(this).removeClass('et_pb_menu__wrap--hidden').addClass('et_pb_menu__wrap--visible');
    } else {
      $(this).parent().hide();
    }
  });
};

var showDiviSearchFormContainer = function showDiviSearchFormContainer() {
  var s = selectors.divi.searchFormContainer;
  allSearchForms().each(function () {
    if ($(this).parents(s.displayCSSBased).length) {
      $(this).parents(s.displayCSSBased).show();
    } else if ($(this).parents(s.etPbClass).length) {
      $(this).parents(s.etPbClass).removeClass('et_pb_menu__search-container--hidden').removeClass('et_pb_menu__search-container--disabled').addClass('et_pb_menu__search-container--visible');
      getEtPbMenuWrap(this).addClass('et_pb_menu__wrap--hidden').removeClass('et_pb_menu__wrap--visible');
    } else {
      $(this).parent().show();
    }
  });
};

var injectStyle = function injectStyle(content) {
  var stylesheet = document.createElement('style');
  stylesheet.innerHTML = content;
  document.body.appendChild(stylesheet);
};

var fixButtonAndInputOffsets = function fixButtonAndInputOffsets(form) {
  var searchInput = $(form).find('input[name=s]');
  var searchCloseButton = $(form).find('button[type=reset]');
  var searchButton = $(form).find('input[type=submit]:visible');
  var pixelShift = 0;
  var paddingRight = 0;
  var right = $(form).offset().left + $(form).outerWidth();
  right -= searchInput.offset().left + searchInput.outerWidth();

  if (searchButton.length) {
    if (searchInput.offset().left < searchButton.offset().left) {
      pixelShift = searchInput.offset().left + searchInput.outerWidth() - searchButton.offset().left;
      pixelShift = Math.max(pixelShift, 0);
      paddingRight += pixelShift;
      right += pixelShift;
    }
  }

  var isLegacySearchInput = searchInput.hasClass('search-field');

  if (searchCloseButton.is(':visible') || isLegacySearchInput) {
    paddingRight += searchCloseButton.outerWidth();
  }

  if ($(form).parents('.et_pb_menu__search-container').length === 0) {
    searchCloseButton.get(0).style.setProperty('right', "".concat(right, "px"), 'important');
  }

  searchInput.get(0).style.setProperty('padding-right', "".concat(paddingRight, "px"), 'important');
};

var forceLoadHandler = function forceLoadHandler(handler) {
  handler(); // Custom JS starts after timeout

  window.setTimeout(function () {
    handler();
  }, 1000); // Divi re-adds handlers on page resize

  $(window).on('resize', function () {
    handler();
  });
};

var cleanupExtraNodes = function cleanupExtraNodes() {
  $(selectors.divi.cleanupNodes).remove();
};

var init = function init() {
  var _this = this;

  var IS_SEARCH_FORM_VISIBLE_BY_DEFAULT = getVisibleSearchForm().length > 0;
  var IS_DIVI_WIDGET_SEARCH_FORM = $(selectors.divi.searchForm).length > 0;

  if ($('.menu-item-has-children > a').length) {
    $('.menu-item-has-children > a').addClass('da11y-submenu');
    $('.menu-item-has-children > a').attr('aria-expanded', 'false');
  }

  $('.da11y-submenu').on('focus', function () {
    $(this).not('.sub-menu a').attr('aria-expanded', 'true');
    $(this).siblings('.sub-menu').addClass('da11y-submenu-show');
    $(this).trigger('mouseenter');
  }); // This block of code helps to understand if the last event was caused by keyboard

  var KEYCODE_TAB = 9;
  var KEYCODE_ESC = 27;
  var lastKeyCode = null;
  var isShiftUsed = null;
  $(document).on('click', '*', function () {
    lastKeyCode = null;
    isShiftUsed = null;
  });
  $(document).on('keydown', '*', function (e) {
    lastKeyCode = e.keyCode;
    isShiftUsed = e.shiftKey;
  });
  $(document).on('keyup', '*', function (e) {
    lastKeyCode = e.keyCode;
    isShiftUsed = e.shiftKey;
  });
  $('.menu-item-has-children a').on('focusout', function () {
    if ($(this).parent().not('.menu-item-has-children').is(':last-child') && !(isShiftUsed && lastKeyCode === KEYCODE_TAB)) {
      var nextMenuItem = $(this).parents('.menu-item-has-children').first().next('li.menu-item');
      $(this).parents('.menu-item-has-children').children('.da11y-submenu').attr('aria-expanded', 'false').trigger('mouseleave').siblings('.sub-menu').removeClass('da11y-submenu-show'); // Focus on the next menu item if it exists and the last pressed key was not ESC

      if (nextMenuItem && lastKeyCode !== KEYCODE_ESC) {
        nextMenuItem.trigger('mouseenter');
      }
    }
  });
  $('.menu-item-has-children a').keyup(function (event) {
    if (event.keyCode === 27) {
      var menuParent = $(this).parents('.menu-item-has-children').last();

      if (menuParent.length) {
        menuParent.children('a').focus();
        menuParent.find('.da11y-submenu').attr('aria-expanded', 'false').trigger('mouseleave').siblings('.sub-menu').removeClass('da11y-submenu-show');
      }
    }
  });

  function setSearchTabIndex(value) {
    $(selectors.searchForm).find('input.et-search-field,input[name=s],button,input[type=submit]').filter(function () {
      return $(this).parents('.widget_search form[role=search], .page-blog #main-content form.et_pb_searchform').length === 0;
    }).attr('tabindex', value);

    if (value >= 0) {
      setTimeout(function () {
        getVisibleSearchInput().focus();
      }, 100);
    }
  }
  /**
   * @Todo re-write using observers
   */


  function toggleSearchTabIndex() {
    setTimeout(function () {
      setSearchTabIndex(getVisibleSearchForm().length >= 1 ? 0 : -1);
    }, 100);
  }

  function setInitialTabIndex() {
    if (IS_DIVI_WIDGET_SEARCH_FORM) {
      if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
        setSearchTabIndex(-1);
      }

      return;
    }

    setSearchTabIndex(-1);
  }
  /**
   * Hide the search.
   *
   * @since Divi v3.0.23
   */


  function hideSearch() {
    if (IS_DIVI_WIDGET_SEARCH_FORM) {
      if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
        hideDiviSearchFormContainer();
        setSearchTabIndex(-1);
      }

      return;
    }

    if ($('.et_search_form_container').hasClass('et_pb_is_animating')) {
      return;
    }

    $('.et_menu_container').removeClass('et_pb_menu_hidden et_pb_no_animation').addClass('et_pb_menu_visible');
    $('.et_search_form_container').removeClass('et_pb_search_visible et_pb_no_animation').addClass('et_pb_search_form_hidden et_pb_is_animating');
    setTimeout(function () {
      $('.et_menu_container').addClass('et_pb_no_animation');
      $('.et_search_form_container').addClass('et_pb_no_animation').removeClass('et_pb_is_animating');
    }, 1000);
    setSearchTabIndex(-1);
  }

  setInitialTabIndex();

  var refreshStateOfCloseSearchButton = function refreshStateOfCloseSearchButton(formNode) {
    var searchCloseButton = $(formNode).find('button[type=reset]');

    if ($(formNode).find('input[name=s]').val()) {
      searchCloseButton.show(0, function () {
        return fixButtonAndInputOffsets(formNode);
      });
    } else {
      searchCloseButton.hide(0, function () {
        return fixButtonAndInputOffsets(formNode);
      });
    }
  };
  /**
   * Add unique ID to search module input with matching label.
   *
   * @divi-module  Search
   */


  $('.et-search-field').each(function (e) {
    $(this).attr('id', "et_pb_search_module_input_".concat(e));
    $("#et_pb_search_module_input_".concat(e)).before("<label class=\"da11y-screen-reader-text\" for=\"et_pb_search_module_input_".concat(e, "\">Search for...</label>"));
    $("#et_pb_search_module_input_".concat(e)).after('<button type="submit" class="" aria-label="Submit Search"></button>');
  });

  if (!IS_DIVI_WIDGET_SEARCH_FORM) {
    // Moving the close search button before the submit
    // Refresing the state of close search button
    $('.et_close_search_field').each(function () {
      $(this).attr('type', 'reset');
      $(this).parent().find('form').find('button[type=submit]').before(this);
    });
  }
  /**
   * Add unique ID to contact module input with matching label.
   *
   * @divi-module  Contact
   */


  $('.et_pb_contact_form').each(function () {
    $(_this).find('.et_pb_contact_captcha_question').parent().wrap('<label></label>');
  }); // Make the non-standard search buttons keyboard accessible

  if (IS_DIVI_WIDGET_SEARCH_FORM) {
    getSearchIcon().each(function () {
      var _this2 = this;

      if (!$(this).attr('aria-label')) {
        $(this).attr('aria-label', 'Open Search');
      }

      if ($(this).closest('a').length) {
        $(this).parents('a').on('keydown', function (e) {
          if (e.key === 'Enter' || e.key === 'Space') {
            e.preventDefault();
            $(_this2).click();
          }
        });
        return;
      }

      $(this).attr('tabindex', '0');
      $(this).on('keydown', function (e) {
        if (e.key === 'Enter') {
          $(_this2).click();
        }
      });
    });
    var searchButton = $('form[role=search] input[type=submit]');
    var searchInput = $('form[role=search] input[name=s]');
    searchButton.each(function () {
      if (!$(this).attr('aria-label')) {
        $(this).attr('aria-label', 'Submit Search');
      }
    });
    searchInput.each(function () {
      if ($(this).attr('type') === 'search') {
        $(this).attr('type', 'text');
      }

      if (!$(this).attr('placeholder')) {
        $(this).attr('placeholder', 'Search');
      }

      $(this).after('<button type="reset" role="button" class="et_close_search_field" aria-label="Clear Search" style="display:none;"></button>');
    });
    var searchCloseButton = $('.et_close_search_field');
    searchCloseButton.css('color', searchInput.css('color'));

    if (searchButton.css('display') === 'none' && searchButton.closest('.et_pb_hide_search_button').length === 0) {
      searchButton.val("\uF002").addClass('fas fa').css('color', 'inherit !important');
      searchButton.css('display', 'block');
    } // Setting position for the close button
    // There are three possible cases:
    // - Case 1, Case when search button implemented as a pseudo element of the search form, in this case we should also fix
    //   the search button
    // - Case 2, Case when search button positioned as an absolute element and the input search field has wrong right padding
    // - Case 3, Default case, search input and search button positioned correctly and they are separate elements


    var form = $('form[role=search]').get(0);
    var isCase1 = getComputedStyle(form, 'after') && getComputedStyle(form, 'after').position === 'absolute';

    if (isCase1) {
      // case 1
      // transforming the state to case 1
      searchButton.val("\uF002").addClass('fas fa').css('color', 'inherit !important');
      injectStyle('.fl-search:after {content: none !important}');
    }

    if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
      showDiviSearchFormContainer();
    }

    allSearchForms().each(function () {
      $(this).find('input[name=s]').on('focus', function () {
        fixButtonAndInputOffsets($(this).parents('form').get(0));
      });
      var legacySearchInput = $(this).find('input.search-field').get(0);

      if (legacySearchInput) {
        fixButtonAndInputOffsets(this);
      }
    });

    if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
      hideDiviSearchFormContainer();
    }
  }

  forceLoadHandler(function () {
    // Re-write the behaviour of search close button
    // now it is a search clear button
    $('.et_close_search_field').off('click').click(function (e) {
      e.preventDefault();
      getVisibleSearchInput().val('').focus().trigger('keyup');
    });
    cleanupExtraNodes();
    $('.et_pb_menu__close-search-button').attr('aria-label', 'Close Search');
  });
  allSearchForms().each(function () {
    var self = this;
    $(this).find('input[name=s]').on('keyup', function () {
      refreshStateOfCloseSearchButton(self);
    });
  });
  $(document).off('blur', '.et_pb_menu__search-input'); // Close the search form if any of its elements lost the focus

  $(selectors.searchForm).parent().on('focusout', function (e) {
    if (!$.contains(this, e.relatedTarget)) {
      hideSearch();
    }
  });
  getSearchIcon().click(function () {
    toggleSearchTabIndex();
  });
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  $(init);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);

var $ = jQuery;
var selectors = {
  visibleSearchForm: 'form[role=search]:visible',
  searchForm: 'form[role=search]',
  divi: {
    searchForm: 'form[role=search].et_pb_searchform,form[role=search].et_pb_menu__search-form',
    searchFormContainer: {
      displayCSSBased: '.fl-search',
      etPbClass: '.et_pb_menu__search-container'
    },
    searchFormIcon: ['.fl-search .et-pb-icon, .fl-search .fa-search', '.fl-search-links', '.et_pb_menu__search-button', '#et_search_icon,.fl-search,.fl-search-button,.fl-search-btn'],
    cleanupNodes: '.fl-search-close'
  }
};

var allSearchForms = function allSearchForms() {
  return $(selectors.searchForm);
};

var getVisibleSearchForm = function getVisibleSearchForm() {
  return $(selectors.visibleSearchForm);
};

var getVisibleSearchInput = function getVisibleSearchInput() {
  return getVisibleSearchForm().find('input[name=s]');
};

var getSearchIcon = function getSearchIcon() {
  for (var i = 0; i < selectors.divi.searchFormIcon.length; i++) {
    if ($(selectors.divi.searchFormIcon[i]).length) {
      var result = $($(selectors.divi.searchFormIcon[i]));

      if (!result.find('form[role=search]').length) {
        return result;
      }
    }
  }

  return $([]);
};

var getEtPbMenuWrap = function getEtPbMenuWrap(form) {
  return $(form).closest('.et_pb_module').find('.et_pb_menu__wrap').first();
};

var hideDiviSearchFormContainer = function hideDiviSearchFormContainer() {
  var s = selectors.divi.searchFormContainer;
  allSearchForms().each(function () {
    if ($(this).parents(s.displayCSSBased).length) {
      $(this).parents(s.displayCSSBased).hide();
    } else if ($(this).parents(s.etPbClass).length) {
      $(this).parents(s.etPbClass).removeClass('et_pb_menu__search-container--visible').addClass('et_pb_menu__search-container--hidden').addClass('et_pb_menu__search-container--disabled');
      getEtPbMenuWrap(this).removeClass('et_pb_menu__wrap--hidden').addClass('et_pb_menu__wrap--visible');
    } else {
      $(this).parent().hide();
    }
  });
};

var showDiviSearchFormContainer = function showDiviSearchFormContainer() {
  var s = selectors.divi.searchFormContainer;
  allSearchForms().each(function () {
    if ($(this).parents(s.displayCSSBased).length) {
      $(this).parents(s.displayCSSBased).show();
    } else if ($(this).parents(s.etPbClass).length) {
      $(this).parents(s.etPbClass).removeClass('et_pb_menu__search-container--hidden').removeClass('et_pb_menu__search-container--disabled').addClass('et_pb_menu__search-container--visible');
      getEtPbMenuWrap(this).addClass('et_pb_menu__wrap--hidden').removeClass('et_pb_menu__wrap--visible');
    } else {
      $(this).parent().show();
    }
  });
};

var injectStyle = function injectStyle(content) {
  var stylesheet = document.createElement('style');
  stylesheet.innerHTML = content;
  document.body.appendChild(stylesheet);
};

var fixButtonAndInputOffsets = function fixButtonAndInputOffsets(form) {
  var searchInput = $(form).find('input[name=s]');
  var searchCloseButton = $(form).find('button[type=reset]');
  var searchButton = $(form).find('input[type=submit]:visible');
  var pixelShift = 0;
  var paddingRight = 0;
  var right = $(form).offset().left + $(form).outerWidth();
  right -= searchInput.offset().left + searchInput.outerWidth();

  if (searchButton.length) {
    if (searchInput.offset().left < searchButton.offset().left) {
      pixelShift = searchInput.offset().left + searchInput.outerWidth() - searchButton.offset().left;
      pixelShift = Math.max(pixelShift, 0);
      paddingRight += pixelShift;
      right += pixelShift;
    }
  }

  var isLegacySearchInput = searchInput.hasClass('search-field');

  if (searchCloseButton.is(':visible') || isLegacySearchInput) {
    paddingRight += searchCloseButton.outerWidth();
  }

  if (searchCloseButton.length > 0 && $(form).parents('.et_pb_menu__search-container').length === 0) {
    searchCloseButton.get(0).style.setProperty('right', "".concat(right, "px"), 'important');
  }

  searchInput.get(0).style.setProperty('padding-right', "".concat(paddingRight, "px"), 'important');
};

var forceLoadHandler = function forceLoadHandler(handler) {
  handler(); // Custom JS starts after timeout

  window.setTimeout(function () {
    handler();
  }, 1000); // Divi re-adds handlers on page resize

  $(window).on('resize', function () {
    handler();
  });
};

var cleanupExtraNodes = function cleanupExtraNodes() {
  $(selectors.divi.cleanupNodes).remove();
};

var init = function init() {
  var _this = this;

  var IS_SEARCH_FORM_VISIBLE_BY_DEFAULT = getVisibleSearchForm().length > 0;
  var IS_DIVI_WIDGET_SEARCH_FORM = $(selectors.divi.searchForm).length > 0;

  if ($('.menu-item-has-children > a').length) {
    $('.menu-item-has-children > a').addClass('da11y-submenu');
    $('.menu-item-has-children > a').attr('aria-expanded', 'false');
  }

  $('.da11y-submenu').on('focus', function () {
    $(this).not('.sub-menu a').attr('aria-expanded', 'true');
    $(this).siblings('.sub-menu').addClass('da11y-submenu-show');
    $(this).trigger('mouseenter');
  }); // This block of code helps to understand if the last event was caused by keyboard

  var KEYCODE_TAB = 9;
  var KEYCODE_ESC = 27;
  var lastKeyCode = null;
  var isShiftUsed = null;
  $(document).on('click', '*', function () {
    lastKeyCode = null;
    isShiftUsed = null;
  });
  $(document).on('keydown', '*', function (e) {
    lastKeyCode = e.keyCode;
    isShiftUsed = e.shiftKey;
  });
  $(document).on('keyup', '*', function (e) {
    lastKeyCode = e.keyCode;
    isShiftUsed = e.shiftKey;
  });
  $('.menu-item-has-children a').on('focusout', function () {
    if ($(this).parent().not('.menu-item-has-children').is(':last-child') && !(isShiftUsed && lastKeyCode === KEYCODE_TAB)) {
      var nextMenuItem = $(this).parents('.menu-item-has-children').first().next('li.menu-item');
      $(this).parents('.menu-item-has-children').children('.da11y-submenu').attr('aria-expanded', 'false').trigger('mouseleave').siblings('.sub-menu').removeClass('da11y-submenu-show'); // Focus on the next menu item if it exists and the last pressed key was not ESC

      if (nextMenuItem && lastKeyCode !== KEYCODE_ESC) {
        nextMenuItem.trigger('mouseenter');
      }
    }
  });
  $('.menu-item-has-children a').keyup(function (event) {
    if (event.keyCode === 27) {
      var menuParent = $(this).parents('.menu-item-has-children').last();

      if (menuParent.length) {
        menuParent.children('a').focus();
        menuParent.find('.da11y-submenu').attr('aria-expanded', 'false').trigger('mouseleave').siblings('.sub-menu').removeClass('da11y-submenu-show');
      }
    }
  });

  function setSearchTabIndex(value) {
    $(selectors.searchForm).find('input.et-search-field,input[name=s],button,input[type=submit]').filter(function () {
      return $(this).parents('.widget_search form[role=search], .page-blog #main-content form.et_pb_searchform').length === 0;
    }).attr('tabindex', value);

    if (value >= 0) {
      setTimeout(function () {
        getVisibleSearchInput().focus();
      }, 100);
    }
  }
  /**
   * @Todo re-write using observers
   */


  function toggleSearchTabIndex() {
    setTimeout(function () {
      setSearchTabIndex(getVisibleSearchForm().length >= 1 ? 0 : -1);
    }, 100);
  }

  function setInitialTabIndex() {
    if (IS_DIVI_WIDGET_SEARCH_FORM) {
      if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
        setSearchTabIndex(-1);
      }

      return;
    }

    setSearchTabIndex(-1);
  }
  /**
   * Hide the search.
   *
   * @since Divi v3.0.23
   */


  function hideSearch() {
    if (IS_DIVI_WIDGET_SEARCH_FORM) {
      if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
        hideDiviSearchFormContainer();
        setSearchTabIndex(-1);
      }

      return;
    }

    if ($('.et_search_form_container').hasClass('et_pb_is_animating')) {
      return;
    }

    $('.et_menu_container').removeClass('et_pb_menu_hidden et_pb_no_animation').addClass('et_pb_menu_visible');
    $('.et_search_form_container').removeClass('et_pb_search_visible et_pb_no_animation').addClass('et_pb_search_form_hidden et_pb_is_animating');
    setTimeout(function () {
      $('.et_menu_container').addClass('et_pb_no_animation');
      $('.et_search_form_container').addClass('et_pb_no_animation').removeClass('et_pb_is_animating');
    }, 1000);
    setSearchTabIndex(-1);
  }

  setInitialTabIndex();

  var refreshStateOfCloseSearchButton = function refreshStateOfCloseSearchButton(formNode) {
    var searchCloseButton = $(formNode).find('button[type=reset]').empty();

    if ($(formNode).find('input[name=s]').val()) {
      searchCloseButton.show(0, function () {
        return fixButtonAndInputOffsets(formNode);
      });
    } else {
      searchCloseButton.hide(0, function () {
        return fixButtonAndInputOffsets(formNode);
      });
    }
  };
  /**
   * Add unique ID to search module input with matching label.
   *
   * @divi-module  Search
   */


  $('.et-search-field').each(function (e) {
    $(this).attr('id', "et_pb_search_module_input_".concat(e));
    $("#et_pb_search_module_input_".concat(e)).before("<label class=\"da11y-screen-reader-text\" for=\"et_pb_search_module_input_".concat(e, "\">Search for...</label>"));
    $("#et_pb_search_module_input_".concat(e)).after('<button type="submit" class="" aria-label="Submit Search"></button>');
  }); // Moving the close search button before the submit
  // Refreshing the state of close search button

  $('.et_close_search_field').each(function () {
    $(this).attr('type', 'reset');
    $(this).parent().find('form').find('button[type=submit]').before(this);
  });
  /**
   * Add unique ID to contact module input with matching label.
   *
   * @divi-module  Contact
   */

  $('.et_pb_contact_form').each(function () {
    $(_this).find('.et_pb_contact_captcha_question').parent().wrap('<label></label>');
  }); // Make the non-standard search buttons keyboard accessible

  getSearchIcon().each(function () {
    var _this2 = this;

    if (!$(this).attr('aria-label')) {
      $(this).attr('aria-label', 'Open Search');
    }

    if ($(this).closest('a').length) {
      $(this).parents('a').on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === 'Space') {
          e.preventDefault();
          $(_this2).click();
        }
      });
      return;
    }

    $(this).attr('tabindex', '0');
    $(this).on('keydown', function (e) {
      if (e.key === 'Enter') {
        $(_this2).click();
      }
    });
  });
  var searchButton = $('form[role=search] input[type=submit]');
  var searchInput = $('form[role=search] input[name=s]');
  searchButton.each(function () {
    if (!$(this).attr('aria-label')) {
      $(this).attr('aria-label', 'Submit Search');
    }
  });
  searchInput.each(function () {
    if (!$(this).attr('placeholder')) {
      $(this).attr('placeholder', 'Search');
    }

    if ($(this).siblings('button[type="reset"]').length === 0) {
      $(this).after('<button type="reset" class="et_close_search_field" aria-label="Clear Search" style="display:none;">&nbsp;</button>');
    }
  });
  var searchCloseButton = $('.et_close_search_field');
  searchCloseButton.css('color', searchInput.css('color'));

  if (searchButton.css('display') === 'none' && searchButton.closest('.et_pb_hide_search_button').length === 0) {
    searchButton.val("\uF002").addClass('fas fa').css('color', 'inherit !important');
    searchButton.css('display', 'block');
  }

  if (IS_DIVI_WIDGET_SEARCH_FORM) {
    // Setting position for the close button
    // There are three possible cases:
    // - Case 1, Case when search button implemented as a pseudo element of the search form, in this case we should also fix
    //   the search button
    // - Case 2, Case when search button positioned as an absolute element and the input search field has wrong right padding
    // - Case 3, Default case, search input and search button positioned correctly and they are separate elements
    var form = $('form[role=search]').get(0);
    var isCase1 = getComputedStyle(form, 'after') && getComputedStyle(form, 'after').position === 'absolute';

    if (isCase1) {
      // Case 1
      // Transforming the state to case 1
      searchButton.val("\uF002").addClass('fas fa').css('color', 'inherit !important');
      injectStyle('.fl-search:after {content: none !important}');
    }
  }

  if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
    showDiviSearchFormContainer();
  }

  allSearchForms().each(function () {
    $(this).find('input[name=s]').on('focus', function () {
      fixButtonAndInputOffsets($(this).parents('form').get(0));
    });
    var legacySearchInput = $(this).find('input.search-field').get(0);

    if (legacySearchInput) {
      fixButtonAndInputOffsets(this);
    }
  });

  if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
    hideDiviSearchFormContainer();
  }

  forceLoadHandler(function () {
    // Re-write the behaviour of search close button
    // now it is a search clear button
    $('.et_close_search_field').off('click').click(function (e) {
      e.preventDefault();
      getVisibleSearchInput().val('').focus().trigger('keyup');
    });
    cleanupExtraNodes();
    $('.et_pb_menu__close-search-button').attr('aria-label', 'Close Search');
  });
  allSearchForms().each(function () {
    var self = this;
    $(this).find('input[name=s]').on('keyup', function () {
      refreshStateOfCloseSearchButton(self);
    });
  });
  $(document).off('blur', '.et_pb_menu__search-input'); // Close the search form if any of its elements lost the focus

  $(selectors.searchForm).parent().on('focusout', function (e) {
    if (!$.contains(this, e.relatedTarget)) {
      hideSearch();
    }
  });
  getSearchIcon().click(function () {
    toggleSearchTabIndex();
  });
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  $(init);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SliderImprovements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find__);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SliderImprovements =
/*#__PURE__*/
function () {
  function SliderImprovements() {
    _classCallCheck(this, SliderImprovements);
  }

  _createClass(SliderImprovements, [{
    key: "start",
    value: function start() {
      if ($('.ENABLE_SLIDER_CONTROL_IMPROVEMENTS').length === 0) {
        return;
      }

      this.sliderImprovements();
    }
  }, {
    key: "sliderImprovements",
    value: function sliderImprovements() {
      var _this = this;

      $(window).on('load', function () {
        $('.et_pb_slider').each(function (i, slider) {
          var sliderObj = $(slider);

          _this.anchors2Buttons(sliderObj);

          _this.addSliderAttributes(sliderObj);
        });
      });
    }
  }, {
    key: "anchors2Buttons",
    value: function anchors2Buttons(slider) {
      this.arrows2Button(slider);
      this.bullets2Button(slider);
    }
  }, {
    key: "arrows2Button",
    value: function arrows2Button(slider) {
      var sliderArrows = slider.find('.et-pb-slider-arrows'); //ARROWS - <a> to <button>

      if (sliderArrows.find('a').length) {
        sliderArrows.html(sliderArrows.html().replace(/<a\b/g, '<button').replace(/<\/a>/g, '</button>'));
        this.addArrowsTriggerEvent(slider);
      }
    }
  }, {
    key: "bullets2Button",
    value: function bullets2Button(slider) {
      var _this2 = this;

      var slides = slider.find('.et_pb_slide');
      var sliderControllersAnchor = slider.find(slider.find('.et-pb-controllers a')); // BULLETS - <a> to <button>

      if (sliderControllersAnchor.length && slides.find('.et_pb_slide')) {
        sliderControllersAnchor.each(function (k) {
          slider.find('.et-pb-controllers').append("<button>".concat(k + 1, "</button>"));
        });
        var buttonStyle = this.getInitialButtonsStyle(slider);
        this.setButtonStyle(slider, buttonStyle); //copy the bullets <a> events to <button>

        var events = $._data(slider.find('.et-pb-controllers a:first').get(0), 'events');

        if (typeof events !== 'undefined') {
          var buttons = slider.find('.et-pb-controllers button');
          buttons.bind(events.click[0].type, events.click[0].handler);
        } //remove the <a> tag after their events was saved and applied to buttons


        sliderControllersAnchor.remove(); //create functionality for buttons similar with a tag

        slider.find('.et-pb-controllers button:first').addClass('et-pb-active-control');
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function () {
            var activeSlideIndex = slider.find('.et-pb-active-slide').index();

            _this2.createBulletsFunctionality(slider, activeSlideIndex);
          });
        });
        observer.observe(slider[0], {
          attributes: 'true',
          attributeFilter: ['class']
        });
      }
    }
  }, {
    key: "createBulletsFunctionality",
    value: function createBulletsFunctionality(slider, activeSlideIndex) {
      slider.find('.et-pb-active-control').removeClass().attr('aria-selected', 'false');
      slider.find(".et-pb-controllers button:eq(".concat(activeSlideIndex, ")")).addClass('et-pb-active-control').attr('aria-selected', 'true');
    }
  }, {
    key: "setButtonStyle",
    value: function setButtonStyle(slider, style) {
      $(style).insertAfter('style:last');
    }
  }, {
    key: "getInitialButtonsStyle",
    value: function getInitialButtonsStyle(slider) {
      var computedStyle = window.getComputedStyle(slider.find('.et-pb-controllers a:last').get(0));
      var simpleColor = computedStyle.getPropertyValue('background-color');
      var simpleOpacity = computedStyle.getPropertyValue('opacity');
      var computedActiveStyle = window.getComputedStyle(slider.find('.et-pb-controllers a.et-pb-active-control').get(0));
      var activeColor = computedActiveStyle.getPropertyValue('background-color');
      var activeOpacity = computedActiveStyle.getPropertyValue('opacity');
      var css = '';
      css += "background-color: ".concat(simpleColor, " !important; ");
      css += "opacity: ".concat(simpleOpacity, " !important; ");
      var cssActive = '';
      cssActive += "background-color: ".concat(activeColor, " !important; ");
      cssActive += "opacity: ".concat(activeOpacity, " !important; ");
      var cssSliderSelector = ".".concat(slider.attr('class').replace(/ /g, '.'));
      var buttonStyle = "<style id=\"neewstyle\">".concat(cssSliderSelector, " .et-pb-controllers button {").concat(css, "}\n\t\t\t").concat(cssSliderSelector, " .et-pb-controllers .et-pb-active-control {").concat(cssActive, "}</style>");
      return buttonStyle;
    }
  }, {
    key: "addSliderAttributes",
    value: function addSliderAttributes(slider) {
      slider.attr('aria-roledescription', 'carousel');
      slider.attr('aria-label', 'Slideshow');
      $('.et-pb-arrow-prev').attr('aria-label', 'Previous Slide').attr('role', 'button');
      $('.et-pb-arrow-next').attr('aria-label', 'Next Slide').attr('role', 'button');
      var nrSlides = slider.find('.et_pb_slide').length;
      slider.find('.et-pb-controllers button').each(function (i, circle) {
        $(circle).attr('aria-label', "Slide ".concat(i + 1)).attr('aria-selected', 'false');
      });
      slider.find('.et-pb-active-control').attr('aria-selected', 'true');
      slider.find('.et_pb_slide').each(function (i, slide) {
        $(slide).attr('role', 'group').attr('aria-roledescription', 'slide').attr('aria-label', "".concat(i + 1, " of ").concat(nrSlides));
      });
    }
  }, {
    key: "addArrowsTriggerEvent",
    value: function addArrowsTriggerEvent(slider) {
      slider.find('.et-pb-arrow-prev').keypress(function (event) {
        if (jQuery.inArray(event.which, [13, 32]) !== -1) {
          slider.find('.et-pb-slider-arrows .et-pb-arrow-prev').trigger('click');
        }
      });
      slider.find('.et-pb-arrow-next').keypress(function (event) {
        if (jQuery.inArray(event.which, [13, 32]) !== -1) {
          slider.find('.et-pb-slider-arrows .et-pb-arrow-next').trigger('click');
        }
      });
    }
  }]);

  return SliderImprovements;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SliderTabOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__focus_connector__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__focus_get_previous_focusable__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__focus_get_next_focusable__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__focus_const__ = __webpack_require__(64);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }






var SliderTabOrder =
/*#__PURE__*/
function () {
  function SliderTabOrder() {
    _classCallCheck(this, SliderTabOrder);
  }

  _createClass(SliderTabOrder, [{
    key: "start",
    value: function start() {
      if ($('.ENABLE_SLIDER_TAB_ORDER').length === 0) {
        return;
      }

      this.sliderTabOrder();
    }
  }, {
    key: "sliderTabOrder",
    value: function sliderTabOrder() {
      $(window).on('load', function () {
        $(SliderTabOrder.SLIDER_SELECTOR).each(function (sliderIndex, slider) {
          var sliderObj = $(slider);
          var existingItems = [];
          var connectorElements = [];

          var linkFocusConnectors = function linkFocusConnectors() {
            var getAllFocusableFromActiveSlide = function getAllFocusableFromActiveSlide() {
              return sliderObj.find(SliderTabOrder.SLIDE_ACTIVE_SELECTOR).find(__WEBPACK_IMPORTED_MODULE_4__focus_const__["b" /* VISIBLE_FOCUSABLE */]);
            };

            var selectors = ["#".concat(SliderTabOrder.FIRST_FOCUS_ELEMENT_SELECTOR).concat(sliderIndex), SliderTabOrder.ARROW_PREV_SELECTOR, SliderTabOrder.ARROW_NEXT_SELECTOR, SliderTabOrder.SLIDE_ACTIVE_SELECTOR, getAllFocusableFromActiveSlide(), SliderTabOrder.CONTROLLERS_BUTTON_SELECTOR, "#".concat(SliderTabOrder.LAST_FOCUS_ELEMENT_SELECTOR).concat(sliderIndex)];
            existingItems = [];
            selectors.forEach(function (item) {
              var items;

              if (typeof item === 'string') {
                items = sliderObj.find(item);
              } else {
                items = item;
              }

              for (var i = 0; i < items.length; i++) {
                existingItems.push(items.get(i));
              } //make all existing elements focusable programmatically


              sliderObj.find(SliderTabOrder.SLIDE_ACTIVE_SELECTOR).attr('tabindex', -1);
            });

            for (var i = 1; i < existingItems.length; i++) {
              connectorElements[i - 1] = new __WEBPACK_IMPORTED_MODULE_1__focus_connector__["a" /* default */](existingItems[i - 1], existingItems[i]);
              connectorElements[i - 1].link();
            }
          };

          var treatFocusInsideSlide = function treatFocusInsideSlide() {
            if ($(':focus').parents().is(sliderObj.find(SliderTabOrder.SLIDES_SELECTOR))) {
              sliderObj.find(SliderTabOrder.SLIDE_ACTIVE_SELECTOR).get(0).focus();
            }
          }; //add first and list additional elements to be able to manipulate the slide order


          sliderObj.prepend("<div id=\"".concat(SliderTabOrder.FIRST_FOCUS_ELEMENT_SELECTOR).concat(sliderIndex, "\" tabindex=\"0\"></div>"));
          sliderObj.append("<div id=\"".concat(SliderTabOrder.LAST_FOCUS_ELEMENT_SELECTOR).concat(sliderIndex, "\" tabindex=\"0\"></div>"));
          linkFocusConnectors();

          if (existingItems.length > 1) {
            //redirect focus to the first element from slider
            $("#".concat(SliderTabOrder.FIRST_FOCUS_ELEMENT_SELECTOR).concat(sliderIndex)).on('focus', function (e) {
              if ($(e.relatedTarget).parents().is(sliderObj)) {
                Object(__WEBPACK_IMPORTED_MODULE_2__focus_get_previous_focusable__["a" /* default */])(this).focus();
              } else {
                $(existingItems[1]).get(0).focus();
              }
            }); //redirect focus to the last element from slider

            $("#".concat(SliderTabOrder.LAST_FOCUS_ELEMENT_SELECTOR).concat(sliderIndex)).on('focus', function (e) {
              if ($(e.relatedTarget).parents().is(sliderObj)) {
                Object(__WEBPACK_IMPORTED_MODULE_3__focus_get_next_focusable__["a" /* default */])(this).focus();
              } else {
                $(existingItems[existingItems.length - 2]).get(0).focus();
              }
            }); //refresh the tab order after each change of the slider

            var observer = new MutationObserver(function () {
              for (var i = 0; i < connectorElements.length; i++) {
                connectorElements[i].unlink();
              }

              connectorElements = [];
              linkFocusConnectors();
              treatFocusInsideSlide();
            });
            observer.observe(sliderObj[0], {
              attributes: 'true',
              attributeFilter: ['class']
            });
          }
        });
      });
    }
  }]);

  return SliderTabOrder;
}();

SliderTabOrder.SLIDER_SELECTOR = '.et_pb_slider';
SliderTabOrder.ARROW_PREV_SELECTOR = '.et-pb-arrow-prev';
SliderTabOrder.ARROW_NEXT_SELECTOR = '.et-pb-arrow-next';
SliderTabOrder.SLIDES_SELECTOR = '.et_pb_slides';
SliderTabOrder.SLIDE_ACTIVE_SELECTOR = '.et-pb-active-slide';
SliderTabOrder.CONTROLLERS_BUTTON_SELECTOR = '.et-pb-controllers button';
SliderTabOrder.FIRST_FOCUS_ELEMENT_SELECTOR = 'first-focus-element-';
SliderTabOrder.LAST_FOCUS_ELEMENT_SELECTOR = 'last-focus-element-';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_all_focusables__ = __webpack_require__(96);

/* harmony default export */ __webpack_exports__["a"] = (function (element) {
  var focusableElements = Object(__WEBPACK_IMPORTED_MODULE_0__get_all_focusables__["a" /* default */])();
  var targetIndex = focusableElements.indexOf(element);

  if (targetIndex === -1) {
    var errorMessage = 'Previous focusable not found, is the argument  focusable?';
    throw errorMessage;
  }

  return targetIndex > 0 ? focusableElements[targetIndex - 1] : focusableElements[focusableElements.length - 1];
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FixSocialMediaButtons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FixSocialMediaButtons =
/*#__PURE__*/
function () {
  function FixSocialMediaButtons() {
    _classCallCheck(this, FixSocialMediaButtons);
  }

  _createClass(FixSocialMediaButtons, [{
    key: "start",
    value: function start() {
      if ($('.ENABLE_FIX_SOCIAL_MEDIA_BUTTONS').length === 0) {
        return;
      }

      this.fixSocialMediaButtons();
    }
  }, {
    key: "fixSocialMediaButtons",
    value: function fixSocialMediaButtons() {
      $(window).on('load', function () {
        var socialButtons = $(FixSocialMediaButtons.SOCIAL_MEDIA_BUTTONS_SELECTOR);

        if (socialButtons.length) {
          var title = '';
          socialButtons.each(function (i, button) {
            title = $(button).attr('title');
            $(button).attr('target', '_blank').removeAttr('title').removeAttr('role').find('span').removeAttr(FixSocialMediaButtons.ARIA_HIDDEN_ATTRIBUTE).html("".concat(title, ", opens in a new window"));
          });
        }
      });
    }
  }]);

  return FixSocialMediaButtons;
}();

FixSocialMediaButtons.SOCIAL_MEDIA_BUTTONS_SELECTOR = '.et_pb_social_media_follow a';
FixSocialMediaButtons.ARIA_HIDDEN_ATTRIBUTE = 'aria-hidden';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__focus_const__ = __webpack_require__(64);


var $ = jQuery; // In the end, this block of code helps to understand if the last event was caused by keyboard

var isKeyboard = false;
$(document).on('click', '*', function () {
  isKeyboard = false;
});
$(document).on('keydown', '*', function () {
  isKeyboard = true;
});
$(document).on('keyup', '*', function () {
  isKeyboard = true;
});
/* harmony default export */ __webpack_exports__["a"] = (function () {
  // check if hamburger menu presents on the page
  if (!$('.mobile_menu_bar').length) {
    return;
  } // add observer for each mobile menu


  var forceLoadHandler = function forceLoadHandler(handler) {
    $(window).on('load', function () {
      // giving one second Divi to generate mobile menus
      setTimeout(handler, 1000);
    });
  };

  var handler = function handler() {
    $('.et_mobile_menu').each(function () {
      var _this = this;

      $(this).find(__WEBPACK_IMPORTED_MODULE_1__focus_const__["a" /* FOCUSABLE */]).on('blur', function (e) {
        // if the element loses the focus by keyboard
        // and the focus goes outside mobile menu,
        // then shift the focus to hamburger menu
        if (!$(_this).has(e.relatedTarget).length && isKeyboard) {
          e.preventDefault();
          $(_this).parent().find('.mobile_menu_bar').click();
        }
      });
    });
  };

  forceLoadHandler(handler);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadcrumbsFocus; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BreadcrumbsFocus =
/*#__PURE__*/
function () {
  function BreadcrumbsFocus() {
    _classCallCheck(this, BreadcrumbsFocus);
  }

  _createClass(BreadcrumbsFocus, [{
    key: "start",
    value: function start() {
      if ($('.ENABLE_BREADCRUMBS_FOCUS').length === 0) {
        return;
      }

      this.fixBreadcrumbsFocus();
    }
  }, {
    key: "fixBreadcrumbsFocus",
    value: function fixBreadcrumbsFocus() {
      $(window).on('load', function () {
        $('#page-container .dcsbcm_divi_breadcrumb a').on('focus', function () {
          var breadcrumbColor = $(this).css('color');
          $(this).attr('style', "outline-color: ".concat(breadcrumbColor, " !important; outline-offset: 2px !important;"));
        });
        $('#page-container .dcsbcm_divi_breadcrumb a').on('focusout', function () {
          $(this).removeAttr('style');
        });
      });
    }
  }]);

  return BreadcrumbsFocus;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeAnchorRoleAttribute;
function removeAnchorRoleAttribute() {
  window.onload = function () {
    document.querySelectorAll('a[role="link"]').forEach(function (link) {
      link.removeAttribute('role');
    });
  };
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PracticeAreaAccordion; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   Simple accordion pattern example
 */
var PracticeAreaAccordion =
/*#__PURE__*/
function () {
  function PracticeAreaAccordion() {
    _classCallCheck(this, PracticeAreaAccordion);
  }

  _createClass(PracticeAreaAccordion, [{
    key: "start",
    value: function start(domNode) {
      this.rootEl = domNode;
      this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');
      var controlsId = this.buttonEl.getAttribute('aria-controls');
      this.contentEl = document.getElementById(controlsId);
      this.open = this.buttonEl.getAttribute('aria-expanded') === 'true'; // add event listeners

      this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick() {
      this.toggle(!this.open);
    }
  }, {
    key: "toggle",
    value: function toggle(open) {
      // Don't do anything if the open state doesn't change
      if (open === this.open) {
        return;
      } // Update the internal state


      this.open = open; // Handle DOM updates

      this.buttonEl.setAttribute('aria-expanded', "".concat(open));

      if (open) {
        this.buttonEl.querySelector('.icon-modify').classList.remove('fa-plus');
        this.buttonEl.querySelector('.icon-modify').classList.add('fa-minus');
        this.contentEl.removeAttribute('hidden');
      } else {
        this.buttonEl.querySelector('.icon-modify').classList.remove('fa-minus');
        this.buttonEl.querySelector('.icon-modify').classList.add('fa-plus');
        this.contentEl.setAttribute('hidden', '');
      }
    } // Add public open and close methods for convenience

  }, {
    key: "open",
    value: function open() {
      this.toggle(true);
    }
  }, {
    key: "close",
    value: function close() {
      this.toggle(false);
    }
  }]);

  return PracticeAreaAccordion;
}();



/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttorneyTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_from__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   File:   attorney-tabs.js
 *   Desc:   This widget implements ARIA Authoring Practices to Tab Element
 */
var AttorneyTabs =
/*#__PURE__*/
function () {
  function AttorneyTabs() {
    _classCallCheck(this, AttorneyTabs);
  }

  _createClass(AttorneyTabs, [{
    key: "start",
    value: function start(groupNode) {
      this.tablistNode = groupNode;
      this.orientation = this.tablistNode.getAttribute('aria-orientation');
      this.tabs = [];
      this.firstTab = null;
      this.lastTab = null;
      this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
      this.tabpanels = [];

      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];
        var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));
        tab.tabIndex = -1;
        tab.setAttribute('aria-selected', 'false');
        this.tabpanels.push(tabpanel);
        tab.addEventListener('keydown', this.onKeydown.bind(this));
        tab.addEventListener('click', this.onClick.bind(this));

        if (!this.firstTab) {
          this.firstTab = tab;
        }

        this.lastTab = tab;
      }

      this.setSelectedTab(this.firstTab);
    }
  }, {
    key: "setSelectedTab",
    value: function setSelectedTab(currentTab) {
      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];

        if (currentTab === tab) {
          tab.setAttribute('aria-selected', 'true');
          tab.tabIndex = 0;
          this.tabpanels[i].classList.remove('is-hidden');
          this.tabpanels[i].tabIndex = 0;
        } else {
          tab.setAttribute('aria-selected', 'false');
          tab.tabIndex = -1;
          this.tabpanels[i].classList.add('is-hidden');
          this.tabpanels[i].tabIndex = -1;
        }
      }
    }
  }, {
    key: "moveFocusToTab",
    value: function moveFocusToTab(currentTab) {
      currentTab.focus();
    }
  }, {
    key: "moveFocusToPreviousTab",
    value: function moveFocusToPreviousTab(currentTab) {
      var index;

      if (currentTab === this.firstTab) {
        this.moveFocusToTab(this.lastTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.moveFocusToTab(this.tabs[index - 1]);
      }
    }
  }, {
    key: "moveFocusToNextTab",
    value: function moveFocusToNextTab(currentTab) {
      var index;

      if (currentTab === this.lastTab) {
        this.moveFocusToTab(this.firstTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.moveFocusToTab(this.tabs[index + 1]);
      }
    }
    /* EVENT HANDLERS */

  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      var tgt = event.currentTarget;
      var flag = false;

      switch (event.key) {
        case 'ArrowLeft':
          if (this.orientation === 'horizontal') {
            this.moveFocusToPreviousTab(tgt);
            flag = true;
          }

          break;

        case 'ArrowRight':
          if (this.orientation === 'horizontal') {
            this.moveFocusToNextTab(tgt);
            flag = true;
          }

          break;

        case 'ArrowUp':
          if (this.orientation === 'vertical') {
            this.moveFocusToPreviousTab(tgt);
            flag = true;
          }

          break;

        case 'ArrowDown':
          if (this.orientation === 'vertical') {
            this.moveFocusToNextTab(tgt);
            flag = true;
          }

          break;

        case 'Home':
          this.moveFocusToTab(this.firstTab);
          flag = true;
          break;

        case 'End':
          this.moveFocusToTab(this.lastTab);
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    } // Since buttons are being used for the tabs, the click also is activated
    // with the space and enter keys

  }, {
    key: "onClick",
    value: function onClick(event) {
      this.setSelectedTab(event.currentTarget);
    }
  }]);

  return AttorneyTabs;
}();



/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttorneyToggle; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 *   File:   attorney-toggle.js
 *   Desc:   apply the aria-expand attribute properly according to the status of the toggle
 */
var AttorneyToggle =
/*#__PURE__*/
function () {
  function AttorneyToggle() {
    _classCallCheck(this, AttorneyToggle);
  }

  _createClass(AttorneyToggle, [{
    key: "start",
    value: function start() {
      if (!$(AttorneyToggle.TOGGLE_ITEM_SELECTOR).length) {
        return;
      }

      this.attachListeners();
    }
  }, {
    key: "attachListeners",
    value: function attachListeners() {
      this.toggleExpand();
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      var $ = jQuery;
      $(window).load(function () {
        $(AttorneyToggle.TOGGLE_SELECTOR).on('click', function () {
          var $element = $(this);

          if ($element.parent().parent().hasClass('et_pb_toggle_close')) {
            $element.attr('aria-expanded', 'true');
          } else {
            $element.attr('aria-expanded', 'false');
          }
        });
      });
    }
  }]);

  return AttorneyToggle;
}();

AttorneyToggle.TOGGLE_ITEM_SELECTOR = '.et_pb_toggle.et_pb_toggle_item';
AttorneyToggle.TOGGLE_SELECTOR = '.et_pb_toggle.et_pb_toggle_item .et_pb_toggle_title';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__submenu_observer__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__submenu_tools__ = __webpack_require__(157);


var $ = jQuery;
/* harmony default export */ __webpack_exports__["a"] = (function () {
  // Loading on windows.onload since custom javascript could
  // add its code, after DomReady event but before window.load event
  $(window).on('load', function () {
    // Wait for 2 seconds, since custom JS can take up to 1 second
    setTimeout(function () {
      $('.menu-item-has-children').each(function () {
        var _this = this;

        var parentofSubmenu = $(this).children('a.da11y-submenu');

        if ((!parentofSubmenu.attr('href') || parentofSubmenu.attr('href') === '#') && parentofSubmenu.siblings('.sub-menu').length > 0) {
          parentofSubmenu.attr('role', 'button');
        }

        parentofSubmenu.attr('aria-expanded', false);
        var observer = new __WEBPACK_IMPORTED_MODULE_0__submenu_observer__["a" /* default */](this);
        observer.onShow(function () {
          parentofSubmenu.attr('aria-expanded', true);
          Object(__WEBPACK_IMPORTED_MODULE_1__submenu_tools__["b" /* restoreFocusForSubmenu */])(_this);
        });
        observer.onHide(function () {
          parentofSubmenu.attr('aria-expanded', false);
          Object(__WEBPACK_IMPORTED_MODULE_1__submenu_tools__["a" /* disableFocusForSubmenu */])(_this);
        });
        observer.connect();
      });
    }, 2000);
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BioAccordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BioAccordion =
/*#__PURE__*/
function () {
  function BioAccordion() {
    _classCallCheck(this, BioAccordion);
  }

  _createClass(BioAccordion, [{
    key: "start",
    value: function start() {
      if (!$(BioAccordion.TOGGLE_ITEM_SELECTOR).length) {
        return;
      }

      this.attachListeners();
    }
  }, {
    key: "attachListeners",
    value: function attachListeners() {
      this.toggleExpand();
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      var _this = this;

      var $ = jQuery;
      $(window).load(function () {
        $(BioAccordion.TOGGLE_SELECTOR).on('keypress', function (event) {
          if (event.which === 13 || event.which === 32) {
            $(_this).trigger('click');
          }
        });
        $(BioAccordion.TOGGLE_ITEM_SELECTOR).each(function (index) {
          var toggle = $(this);
          toggle.closest('div').children().first().removeAttr('role');
          var title = toggle.find('.et_pb_toggle_title');
          var titleContent = title.text();
          var ariaExpandValue;
          var panel = toggle.find('.et_pb_toggle_content');

          if (toggle.hasClass('et_pb_toggle_open')) {
            ariaExpandValue = 'true';
          } else {
            ariaExpandValue = 'false';
          }

          $(title).replaceWith("<h3 class='fl-accordion-heading et_pb_toggle_title'>\n\t\t\t\t<button type='button' class='fl-accordion-button' aria-expanded=".concat(ariaExpandValue, " aria-controls=et_pb_toggle_content_").concat(index, ">\n                <span class='accordion-title'>\n                  ").concat(titleContent, "\n                  <span class='accordion-icon' aria-hidden='true'></span>\n                </span>\n              </button>\n\t\t\t\t</h3>"));
          panel.attr('id', "et_pb_toggle_content_".concat(index));
        });
        $(BioAccordion.TOGGLE_SELECTOR).on('click', function () {
          var clickedToggleElement = $(this); // Make the accordions closable and set the aria attributes on the clicked toggle

          var clickedToggle = $(this).closest('.et_pb_toggle');

          if (clickedToggle.hasClass('et_pb_toggle_open')) {
            clickedToggle.find('.et_pb_toggle_content').slideToggle(700, function () {
              clickedToggle.removeClass('et_pb_toggle_open').addClass('et_pb_toggle_close');
            });
            clickedToggleElement.attr('aria-expanded', 'false');
          } else {
            clickedToggleElement.attr('aria-expanded', 'true');
          }
        });
      });
    }
  }]);

  return BioAccordion;
}();

BioAccordion.TOGGLE_ITEM_SELECTOR = '.et_pb_accordion_closeable .et_pb_toggle.et_pb_accordion_item';
BioAccordion.TOGGLE_SELECTOR = '.et_pb_accordion_closeable .et_pb_toggle.et_pb_accordion_item .fl-accordion-button';

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (immutable) */ __webpack_exports__["a"] = EnableAriaLabelNavMegaMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);

var $ = jQuery;
function EnableAriaLabelNavMegaMenu() {
  $(window).on('load', function () {
    var elements = [$('#et-top-navigation'), // Simple menus
    $('.et_pb_menu__wrap'), // Mega menu with sticky header
    $('.fl-mobile-pa'), //practice area menu
    $('.fl-home-practice-area'), //practice area menu
    $('.fl-mobile-practice')];
    elements.forEach(function (element) {
      if (element.length) {
        element.each(function () {
          var CurrentElement = $(this);
          var navElements = $(this).find('nav');
          var mobileMenusElements = $(this).find('.et_mobile_nav_menu, #et_mobile_nav_menu');

          if (navElements.length) {
            // If <nav> tags are present, add attributes to them
            navElements.each(function () {
              $(this).attr('aria-label', 'Main Site Navigation');
            });
          }

          if (mobileMenusElements.length) {
            mobileMenusElements.each(function () {
              $(this).attr('role', 'navigation');

              if (CurrentElement.hasClass('fl-mobile-pa') || CurrentElement.hasClass('fl-home-practice-area') || CurrentElement.hasClass('fl-mobile-practice')) {
                $(this).attr('aria-label', 'Practice Areas Navigation');
              } else {
                $(this).attr('aria-label', 'Main Site Navigation');
              }
            });
          }
        });
      }
    });
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony export (immutable) */ __webpack_exports__["a"] = EnableAriaLabelNFFields;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);

var $ = jQuery;
function EnableAriaLabelNFFields() {
  $(document).on('nfFormReady', function (e, layout) {
    var currentForm = $(layout.$el[0]);
    var FormId = currentForm.attr('id');
    $("#".concat(FormId)).find('form').attr('aria-label', 'Contact Form');
    $('.nf-form-fields-required').attr('aria-hidden', true);
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EnableFocusOnElementsOnTabNavigationFix;
function EnableFocusOnElementsOnTabNavigationFix() {
  var mouseClickFlag = false; //Set the flag when a mousedown event occurs (for any element)

  document.addEventListener('mousedown', function () {
    mouseClickFlag = true;
  }, true); // Reset the flag after a short delay to ensure it doesn't interfere with subsequent focus events

  document.addEventListener('focusin', function (event) {
    var focusedElement = event.target;

    if (mouseClickFlag) {
      mouseClickFlag = false;
      return; // Exit the function to prevent scrolling
    } // Get the bounding rectangle of the focused element


    var rect = focusedElement.getBoundingClientRect(); // Get elements from the center in four directions

    var topElement = document.elementFromPoint(rect.left, rect.top); // Up
    // Check if the focused element is not the same as the topElement or its descendant

    if (!(focusedElement.isSameNode(topElement) || focusedElement.contains(topElement))) {
      focusedElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, true);
}

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoRotatingSliderImprovement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AutoRotatingSliderImprovement =
/*#__PURE__*/
function () {
  function AutoRotatingSliderImprovement() {
    _classCallCheck(this, AutoRotatingSliderImprovement);
  }

  _createClass(AutoRotatingSliderImprovement, [{
    key: "start",
    value: function start() {
      this.AutoRotatingSliderImprovements();
    }
  }, {
    key: "AutoRotatingSliderImprovements",
    value: function AutoRotatingSliderImprovements() {
      var _this = this;

      $(window).load(function () {
        $('.swiper-container').each(function (i, slider) {
          var swiper = slider.swiper;
          var sliderObj = $(slider).parent();
          var isAutoplay = sliderObj.data('props').autoplay;
          var isPauseOnHover = sliderObj.data('props').pause_onhover;

          if (isAutoplay === 'on') {
            _this.autoRotationSliderImprovement(sliderObj, swiper, isPauseOnHover);
          }
        });
      });
    }
  }, {
    key: "autoRotationSliderImprovement",
    value: function autoRotationSliderImprovement(slider, swiper, isPauseOnHover) {
      var ariaLabelDiv = slider.parent().find('.ariaLabelList');
      var ariaLabelFromDataSet = ariaLabelDiv.data('arialabel');
      var mainContainerAriaLabel = ariaLabelFromDataSet.main_container_aria_label;
      var startAriaLabel = ariaLabelFromDataSet.start_button_aria_label;
      var pauseAriaLabel = ariaLabelFromDataSet.pause_button_aria_label;
      slider.attr('aria-label', mainContainerAriaLabel);
      var sliderButton = slider.parent().find('.fl-rotation-control-button');
      sliderButton.click(function (e) {
        if (sliderButton.hasClass('pause')) {
          sliderButton.toggleClass('pause play');
          sliderButton.attr('aria-label', startAriaLabel);
          e.preventDefault();
          swiper.autoplay.stop();

          if (isPauseOnHover === 'on') {
            $(slider).find('.swiper-container').css('pointer-events', 'none');
          }
        } else {
          sliderButton.toggleClass('play pause');
          sliderButton.attr('aria-label', pauseAriaLabel);
          e.preventDefault();
          swiper.autoplay.start();

          if (isPauseOnHover === 'on') {
            $(slider).find('.swiper-container').removeAttr('style');
          }
        }
      });
    }
  }]);

  return AutoRotatingSliderImprovement;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__);

var $ = jQuery;
/* harmony default export */ __webpack_exports__["a"] = (function () {
  $(window).on('load', function () {
    setTimeout(function () {
      // Function to get computed style
      var getComputedStyle = function getComputedStyle(element, pseudo) {
        return window.getComputedStyle(element, pseudo);
      }; // Function to modify content


      var modifyContent = function modifyContent(content) {
        // Check if the content is empty, "0", or just whitespace
        var trimmedContent = content.replace(/^["']|["']$/g, '');

        if (!trimmedContent || trimmedContent === '0' || /^\s*$/.test(trimmedContent)) {
          return content; // Return original content without modification
        }

        if (content && content !== '"0"' && content !== "'0'") {
          return "".concat(content, "/\" \" ");
        }

        return content;
      }; // Create a style element


      var style = document.createElement('style');
      var styleContent = ''; // Process each menu item for both :before and :after

      $('.et-menu .menu-item-has-children > a:first-child, .nav .menu-item-has-children > a:first-child').each(function (index, element) {
        ['before', 'after'].forEach(function (pseudo) {
          var computedStyle = getComputedStyle(element, ":".concat(pseudo));
          var content = computedStyle.getPropertyValue('content');
          var modifiedContent = modifyContent(content);

          if (content !== modifiedContent) {
            styleContent += "\n                .et-menu .menu-item-has-children > a:first-child:nth-of-type(".concat(index + 1, "):").concat(pseudo, ",\n                .nav .menu-item-has-children > a:first-child:nth-of-type(").concat(index + 1, "):").concat(pseudo, " {\n                    content: ").concat(modifiedContent, " !important;\n                }\n            ");
          }
        });
      }); // Set the style content and append to head

      style.textContent = styleContent;
      document.head.appendChild(style);
    }, 2000);
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NFFomErrorValidation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NFFomErrorValidation =
/*#__PURE__*/
function () {
  function NFFomErrorValidation() {
    _classCallCheck(this, NFFomErrorValidation);
  }

  _createClass(NFFomErrorValidation, [{
    key: "start",
    value: function start() {
      if ($('.ENABLE_NF_FORM_ERROR_VALIDATION_A11Y_ISSUE_FIX').length === 0) {
        return;
      }

      this.nfFomErrorValidation();
    }
  }, {
    key: "nfFomErrorValidation",
    value: function nfFomErrorValidation() {
      $(document).on('nfFormReady', function () {
        $('.nf-form-fields-required').attr('aria-hidden', 'true');
        var nfCustomFieldController = Marionette.Object.extend({
          initialize: function initialize() {
            var fieldsChannel = Backbone.Radio.channel('fields');
            var emailChannel = Backbone.Radio.channel('email');
            var submitChannel = Backbone.Radio.channel('submit');
            emailChannel.off('blur:field');
            emailChannel.off('keyup:field');
            emailChannel.off('change:field');
            emailChannel.off('change:modelValue');
            fieldsChannel.off('change:field');
            fieldsChannel.off('blur:field');
            fieldsChannel.off('keyup:field');
            fieldsChannel.off('change:modelValue');
            this.listenTo(submitChannel, 'validate:field', this.requiredFieldValidation);
            this.listenTo(submitChannel, 'validate:field', this.focusFirstInvalidInput);
            submitChannel.reply('focus:getFirstInvalidInput', this.getFirstInvalidInput);
            nfRadio.channel('fields').reply('get:getFirstFieldByElementId', this.getFirstFieldByElementId);
          },
          //Focus first invalid element
          focusFirstInvalidInput: function focusFirstInvalidInput(e) {
            var i = nfRadio.channel('app').request('get:form', e.get('formID'));
            var fieldsError = i.get('fieldErrors');

            if (_.size(fieldsError) > 0) {
              var fieldType = e.get('type');
              nfRadio.channel('submit').request('focus:getFirstInvalidInput', Object.keys(i.get('fieldErrors')), fieldType);
            }
          },
          getFirstInvalidInput: function getFirstInvalidInput(e, fieldType) {
            var t = nfRadio.channel('fields').request('get:getFirstFieldByElementId', e);

            switch (fieldType) {
              case 'listradio':
              case 'listmultiselect':
              case 'listcheckbox':
                {
                  if (document.getElementById("nf-field-".concat(t, "-0")) !== null) {
                    document.getElementById("nf-field-".concat(t, "-0")).focus();
                  }

                  break;
                }

              case 'date':
                {
                  if (document.getElementById("nf-field-".concat(t)) !== null) {
                    jQuery("#nf-field-".concat(t)).parent().find("input[type='text']").focus();
                  }

                  break;
                }

              default:
                {
                  if (document.getElementById("nf-field-".concat(t)) !== null) {
                    document.getElementById("nf-field-".concat(t)).focus();
                  }
                }
            }
          },
          getFirstFieldByElementId: function getFirstFieldByElementId(idsArray) {
            var targetID = 0; //Loop through an array of fieldIDs to return the one that is positioned first

            _.each(idsArray, function (id) {
              //Get field order
              var order = nfRadio.channel('fields').request('get:field', id); //Set it as the target when the lowest order is found

              targetID = targetID === 0 || order < targetID ? id : targetID;
            });

            return targetID;
          },
          //function for handle custom error message
          requiredFieldValidation: function requiredFieldValidation(model) {
            if (model.get('required') !== 1 || !model.get('visible') || model.get('clean')) return;
            var type = model.get('type');
            var modelId = model.get('id');
            var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var getCurrentField = nfRadio.channel('fields').request('get:field', modelId);
            var getCurrentForm = nfRadio.channel('app').request('get:form', getCurrentField.get('formID'));
            var fieldsChannel = Backbone.Radio.channel('fields');
            var requiredErrorId = 'required-error';
            var adminLabel = model.get('admin_label');
            var checkboxValue = model.get('value');
            var checkboxErrorId = 'custom-checkbox-field-error';

            switch (type) {
              case 'email':
                {
                  var emailCustomErrorMessage = getCurrentForm.get('settings').changeEmailErrorMsg;
                  var errorId = 'custom-email-field-error';
                  var emailValue = model.get('value');

                  if (emailRegex.test(emailValue)) {
                    fieldsChannel.request('remove:error', modelId, errorId);
                  } else {
                    fieldsChannel.request('remove:error', modelId, requiredErrorId);
                    fieldsChannel.request('add:error', modelId, errorId, emailCustomErrorMessage);
                  }

                  break;
                }

              case 'checkbox':
                {
                  if (checkboxValue === 0 && adminLabel === 'readDisclaimer') {
                    var checkboxCustomErrorMessage = getCurrentForm.get('settings').disclaimerCheckBoxErrorMsg ? getCurrentForm.get('settings').disclaimerCheckBoxErrorMsg : 'Please indicate that you have read and agree to the Disclaimer.';
                    fieldsChannel.request('remove:error', modelId, requiredErrorId);
                    fieldsChannel.request('add:error', modelId, checkboxErrorId, checkboxCustomErrorMessage);
                  } else {
                    fieldsChannel.request('remove:error', modelId, checkboxErrorId);
                  }

                  if (checkboxValue === 1 && adminLabel !== 'readDisclaimer') {
                    fieldsChannel.request('remove:error', modelId, requiredErrorId);
                  }

                  break;
                }

              default:
                {
                  var currentValue = model.get('value');

                  if (String(currentValue).trim()) {
                    nfRadio.channel('fields').request('remove:error', modelId, requiredErrorId);
                  } else {
                    nfRadio.channel('fields').request('add:error', modelId, requiredErrorId, getCurrentForm.get('settings').validateRequiredField);
                  }
                }
            }
          }
        });

        (function () {
          return new nfCustomFieldController();
        })();
      });
    }
  }]);

  return NFFomErrorValidation;
}();


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(0)))

/***/ })
],[158]);


// WEBPACK FOOTER //
// scripts.min.js